import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { mergeAdminDashboardExtras } from './locales/adminDashboardExtras';

// Updated: 2025-01-30 - Service descriptions updated
const resources = {
  es: {
    translation: {
      // Navigation & Common
      "language": "Idioma",
      "app_logo_alt": "Logotipo de AutoGo",
      "admin_login": "Acceso Admin",
      "logout": "Cerrar Sesión",
      "get_started": "Comenzar",
      "learn_more": "Saber Más",
      "back_to_home": "Volver al Inicio",
      "loading": "Cargando...",
      "authenticating": "Autenticando...",
      "please_wait": "Por favor espera mientras te conectamos.",
      "success": "¡Éxito!",
      "redirecting": "Redirigiendo al panel...",
      
      // Landing Page
      "professional_car": "Transporte Profesional",
      "transfer_service": "de Vehículos",
      "landing_description": "Servicios de transporte de vehículos seguros, confiables y eficientes en toda Europa. Elige entre entregas estándar, servicios B-C o opciones de intercambio con precios transparentes basados en distancia.",
      "realtime_tracking": "Seguimiento en Tiempo Real",
      "realtime_desc": "Monitorea tu transporte de vehículo en cada paso",
      "flexible_timing": "Horarios Flexibles",
      "flexible_desc": "Establece márgenes de tiempo para recogida y entrega",
      "secure_payment": "Pago Seguro",
      "secure_desc": "Transacciones seguras vía pasarela Redsys",
      "clear_pricing": "Precios Claros",
      "clear_desc": "Tarifas basadas en distancia mostradas desde el inicio",
      "why_choose_us": "¿Por Qué Elegirnos?",
      "professional_service": "Servicio profesional en el que puedes confiar",
      "professional_drivers": "Conductores Profesionales",
      "drivers_desc": "Nuestros conductores experimentados y verificados aseguran que tu vehículo esté en buenas manos durante todo el viaje.",
      "fully_insured": "Completamente Asegurado",
      "insured_desc": "Cobertura de seguro completa para tu tranquilidad durante todo el proceso de transporte.",
      "transparent_pricing": "Precios Transparentes",
      "transparent_desc": "Sin tarifas ocultas. Precios claros basados en distancia calculados antes de reservar.",
      
      // Dashboard
      "client_portal": "Portal de Cliente",
      "my_orders": "Mis Servicios",
      "manage_orders": "Gestiona tus solicitudes de transporte de vehículos",
      "create_order": "Crear Servicio",
      "no_orders_yet": "Aún no hay servicios",
      "create_first_order": "Crea tu primer servicio de transporte de vehículo para comenzar",
      "search_by_plate": "Buscar por Matrícula",
      "enter_plate_number": "Ingresa el número de matrícula...",
      "no_orders_found": "No se encontraron servicios",
      "try_different_search": "Intenta con una búsqueda diferente",
      "try_different_filters": "Intenta ajustar los filtros de búsqueda",
      "filter_orders": "Filtrar Servicios",
      "filter_description": "Usa los filtros para encontrar servicios específicos",
      "filter_by_city": "Filtrar por Ciudad",
      "all_cities": "Todas las Ciudades",
      "date_from": "Fecha Desde",
      "date_to": "Fecha Hasta",
      "select_date": "Seleccionar fecha",
      "clear_filters": "Limpiar Filtros",
      "all": "Todos",
      "order_status": "Estado del Servicio",
      "point_c_required": "Dirección del Punto C requerida",
      "point_c_information": "Información del Punto C (Segunda Entrega)",
      "point_c_address": "Dirección del Punto C",
      "first_vehicle": "Primer Vehículo",
      "second_vehicle": "Segundo Vehículo",
      "bc_service_note": "Se recoge el primer coche en A, se entrega en B. Luego se recoge el segundo coche en B y se entrega en C.",
      "tradein_note": "Se recoge el primer coche en A, se entrega en B. Luego se recoge el segundo coche en B y se entrega en A.",
      "edit_order": "Editar Servicio",
      "client_order_docs_title": "Documentos adjuntos al servicio",
      "client_order_docs_subtitle": "PDF o imágenes (JPEG, PNG, WebP). Máx. 10 MB por archivo y hasta 15 archivos por servicio. Vista previa al hacer clic en el icono.",
      "client_order_doc_upload": "Subir documento",
      "client_order_doc_upload_ok": "Documento subido correctamente",
      "client_order_doc_upload_fail": "No se pudo subir el documento",
      "client_order_doc_download": "Descargar",
      "client_order_doc_download_fail": "No se pudo descargar el documento",
      "client_order_doc_delete_ok": "Documento eliminado",
      "client_order_doc_delete_fail": "No se pudo eliminar el documento",
      "client_order_doc_none": "Aún no hay documentos. Sube el primero con el botón de arriba.",
      "client_order_doc_loading": "Cargando documentos…",
      "service_client_uploaded_files": "Archivos subidos por el cliente",
      "service_client_uploaded_files_empty": "El cliente aún no ha subido archivos para este servicio.",
      "admin_client_order_doc_upload": "Subir documento",
      "admin_client_order_doc_upload_hint": "Los archivos quedan asociados al servicio y el cliente los verá en su portal.",
      "admin_client_order_doc_upload_ok": "Documento subido correctamente",
      "admin_client_order_doc_upload_fail": "No se pudo subir el documento",
      "admin_client_order_doc_delete_ok": "Documento eliminado",
      "admin_client_order_doc_delete_fail": "No se pudo eliminar el documento",
      "client_order_doc_badge_admin": "Subido por administración",
      "cancel_order": "Cancelar Servicio",
      "show_more": "Ver más",
      "show_less": "Ver menos",
      "dashboard": "Panel Principal",
      "my_services": "Mis Servicios",
      "create_service": "Crear Servicio",
      "my_company": "Mi Empresa",
      "company_profile": "Perfil Empresarial",
      "statistics": "Estadísticas",
      "total_services": "Total de Servicios",
      "in_progress": "En Proceso",
      "completed": "Completados",
      "cancelled": "Cancelados",
      "pending_payment": "Pagos Pendientes",
      "total_spent": "Total Gastado",
      "recent_services": "Servicios Recientes",
      "upcoming_services": "Próximos Servicios",
      "client_home_nav_general": "General",
      "client_home_nav_tracking": "Seguimiento",
      "client_home_nav_account": "Cuenta",
      "client_home_client_panel": "Panel de Cliente",
      "client_home_welcome_user": "Bienvenido, {{name}}",
      "client_home_service_trend_title": "Tendencia de Servicios",
      "client_home_service_trend_subtitle": "Comparativa de servicios creados vs completados",
      "client_home_chart_legend_services": "Servicios",
      "client_home_chart_legend_completed": "Completados",
      "client_home_recent_subtitle": "Últimos servicios registrados",
      "client_home_view_all": "Ver todos",
      "client_home_no_services_yet": "No hay servicios aún",
      "client_home_create_first_service_btn": "Crear primer servicio",
      "client_home_service_status_menu": "Estado Servicios",
      "client_home_inspections_menu": "Peritajes",
      "client_home_invoices_menu": "Facturas",
      "client_invoice_date_fallback": "Factura - {{date}}",
      "client_completion_completed_at": "Completado:",
      "client_home_gauge_total_sub": "Servicios totales",
      "client_home_gauge_in_progress_sub": "Servicios activos",
      "client_home_gauge_completed_sub": "Entregas exitosas",
      "client_home_gauge_cancelled_sub": "Servicios cancelados",
      
      // Profile/Company
      "company_information": "Información de Empresa",
      "company_name": "Nombre de Empresa",
      "company_name_required": "Nombre de Empresa *",
      "company_logo": "Logo de Empresa",
      "upload_logo": "Subir Logo",
      "change_logo": "Cambiar Logo",
      "contact_person": "Persona de Contacto",
      "contact_person_required": "Persona de Contacto *",
      "cif_dni": "CIF/DNI",
      "cif_dni_required": "CIF/DNI *",
      "cif_dni_placeholder": "Ej: B12345678 o 12345678A",
      "phone_number": "Teléfono",
      "phone_required": "Teléfono *",
      "company_address": "Dirección",
      "address_placeholder": "Dirección completa de la empresa",
      "contact_information": "Información de Contacto",
      "company_logo_desc": "Sube el logo de tu empresa para personalizar tu perfil",
      "company_info_billing_desc": "Información empresarial y de facturación",
      "contact_data_desc": "Datos de la persona de contacto",
      "email_readonly_note": "El email no se puede modificar",
      "change_password_section_desc": "Actualiza tu contraseña de acceso",
      "email_address": "Correo electrónico",
      "client_no_invoices": "No hay facturas disponibles",
      "client_invoices_biweekly": "Las facturas se generan automáticamente cada 15 días",
      "client_invoices_ondemand": "Los pagos se procesan al momento de crear servicios",
      "client_invoice_status_invoiced": "Facturado",
      "client_address_required": "Dirección *",
      "client_verification_date": "Fecha de Verificación *",
      "client_verification_time": "Hora de Verificación *",
      "client_verification_time_from": "Hora de Verificación - Desde *",
      "client_verification_time_to": "Hora de Verificación - Hasta *",
      "client_fixed_datetime": "Fecha y Hora Fija",
      "client_range_datetime": "Rango de Fecha y Hora",
      "client_switch_to_range": "Cambiar a Rango",
      "client_switch_to_fixed": "Cambiar a Fecha Fija",
      "client_select_date": "Selecciona fecha",
      "client_address_heading": "Dirección",
      "client_time_from": "Desde",
      "client_time_to": "Hasta",
      "service_not_found": "Servicio no encontrado",
      "no_driver_assigned": "Sin asignar",
      "address_not_specified": "Dirección no especificada",
      "no_plate": "Sin matrícula",
      "car_type_turismo": "Turismo",
      "back_to_dashboard": "Volver al Dashboard",
      "client_financial_summary_desc": "Resumen de pagos y facturación",
      "client_pending_services_label": "servicios pendientes",
      "client_last_5_services": "Últimos 5 servicios solicitados",
      "client_pickup_label": "Recogida:",
      "client_delivery_label": "Entrega:",
      "client_no_recent_services": "No hay servicios recientes",
      "client_create_first_service": "Crea tu primer servicio para empezar",
      "billing_information": "Información de Facturación",
      "security": "Seguridad",
      "change_password": "Cambiar Contraseña",
      "current_password": "Contraseña Actual",
      "new_password": "Nueva Contraseña",
      "confirm_password": "Confirmar Contraseña",
      "password_requirements": "Mínimo 8 caracteres",
      "save_changes": "Guardar Cambios",
      "profile_updated": "Perfil actualizado correctamente",
      "profile_update_error": "Error al actualizar el perfil",
      "password_updated": "Contraseña actualizada correctamente",
      "password_update_error": "Error al actualizar la contraseña",
      "passwords_dont_match": "Las contraseñas no coinciden",
      "welcome": "Bienvenido",
      "services_by_status": "Servicios por Estado",
      "services_by_type": "Servicios por Tipo",
      "financial_summary": "Resumen Financiero",
      "view_invoices": "Ver Facturas",
      "member_since": "Miembro desde",
      "quick_actions": "Acciones Rápidas",
      "cancellation_policy": "Política de Cancelaciones y Modificaciones",
      "cancel_policy_1": "• Cancelaciones en la primera hora: Sin coste",
      "cancel_policy_2": "• Cancelaciones entre 1 hora y 24 horas antes: 50% del precio",
      "cancel_policy_3": "• Cancelaciones con menos de 24 horas: 100% del precio",
      "cancel_policy_4": "• Modificaciones de ubicación después de 1 hora: 20€",
      "cancel_policy_5": "• Cambios en primera hora: Gratis",
      "cancel_policy_6": "• Cambios durante transporte: 50€ + 0.33€/km",
      "cancel_policy_7": "• Cambios dentro de 24h previas: 20€ + 0.26€/km",
      "cancel_policy_8": "• Cancelación durante transporte: Se cobra como completado",
      "cancel_policy_9": "• Si el vehículo no está disponible: Se cobra como completado",
      "confirm_cancel": "¿Estás seguro que quieres cancelar este servicio?",
      "order_cancelled": "Servicio cancelado exitosamente",
      "order_updated": "Servicio actualizado exitosamente",
      
      // Order Form
      "create_new_order": "Crear Nuevo Servicio de Transporte",
      "fill_details": "Completa los detalles de tu solicitud de transporte de vehículo",
      "service_type": "Tipo de Servicio",
      "service_type_required": "Selecciona un tipo de servicio *",
      "delivery": "Entrega",
      "delivery_desc": "Transporte estándar de un solo vehículo del punto A al punto B.",
      "bc_service": "Servicio B-C",
      "bc_service_desc": "Múltiples Destinos: Recojo en A, entrego en B y recojo en B para entregar en C (20% de descuento en el 2do vehículo).",
      "tradein": "TRADE-IN",
      "tradein_desc": "Intercambio de Vehículos: Recojo en A, entrego en B y recojo en B para devolver en A (30% de descuento en el 2do vehículo).",
      "representacion": "Representación",
      "representacion_desc": "Verificación in situ",
      
      // Pickup Information
      "pickup_information": "Información de Recogida",
      "pickup_address": "Dirección de Recogida *",
      "start_typing_address": "Comienza a escribir la dirección...",
      "contact_name": "Nombre de Contacto *",
      "contact_phone": "Teléfono de Contacto *",
      "pickup_date_range": "Rango de Fechas de Recogida *",
      "select_dates": "Seleccionar fechas",
      "pickup_time": "Hora de Recogida *",
      "select_time": "Seleccionar hora",
      
      // Delivery Information
      "delivery_information": "Información de Entrega",
      "delivery_address": "Dirección de Entrega *",
      "delivery_date_range": "Rango de Fechas de Entrega *",
      "delivery_time": "Hora de Entrega *",
      
      // Vehicle Information
      "vehicle_information": "Información del Vehículo",
      "vehicle_type": "Tipo de Vehículo *",
      "select_vehicle_type": "Selecciona tipo de vehículo",
      "car": "Berlina",
      "van": "Furgoneta",
      "pickup_truck": "Camión < 3.500kg",
      "sport_car": "Deportivo",
      "suv": "SUV",
      "motorcycle": "Motocicleta",
      "brand": "Marca *",
      "model": "Modelo *",
      "license_plate": "Matrícula *",
      "fuel_type": "Tipo de Combustible *",
      "select_fuel_type": "Selecciona tipo de combustible",
      "electric": "Eléctrico",
      "hybrid": "Híbrido",
      "diesel": "Diésel",
      "gasoline": "Gasolina",
      
      // Second Vehicle
      "second_vehicle_optional": "Segundo Vehículo (Opcional)",
      "second_vehicle_desc": "Para servicios B-C o intercambio",
      "add_second_vehicle": "Agregar Segundo Vehículo",
      "remove_second_vehicle": "Eliminar Segundo Vehículo",
      
      // Representación fields
      "buyer_data": "Datos del Comprador",
      "seller_data": "Datos del Vendedor",
      "buyer_name": "Nombre del Comprador",
      "buyer_surname": "Apellidos del Comprador",
      "buyer_phone": "Teléfono del Comprador",
      "buyer_dni": "DNI/NIE del Comprador",
      "seller_name": "Nombre del Vendedor",
      "seller_surname": "Apellidos del Vendedor",
      "seller_phone": "Teléfono del Vendedor",
      "seller_dni": "DNI/NIE del Vendedor",
      "verification_address": "Dirección de Verificación",
      "verification_date": "Fecha de Verificación",
      "verification_time": "Hora de Verificación",
      "enter_verification_address": "Introduce la dirección donde se verificará el vehículo",
      
      // Additional Services
      "additional_services": "Servicios Adicionales",
      "select_additional_services": "Selecciona servicios adicionales si los necesitas",
      "exterior_cleaning": "Limpieza Exterior",
      "interior_cleaning": "Limpieza Interior",
      "waiting_period": "Período de Espera",
      "itv_inspection": "Inspección ITV",
      "pit_stop": "Parada en Taller",
      "extra_pit_stop_technical": "Paradas Técnicas (Pit Stop)",
      "extra_recovery_continental_uk": "Recuperación (Europa Continental y UK)",
      "extra_recovery_islands": "Recuperación (Islas Europeas)",
      "extra_recovery_ceuta_melilla": "Recuperación (Ceuta y Melilla)",
      "additional_service_desc_interior_cleaning": "Parte interior del vehículo",
      "additional_service_desc_exterior_cleaning": "Parte exterior del vehículo",
      "additional_service_desc_itv_inspection": "Por vehículo y por intento",
      "additional_service_desc_representation": "Verificación in situ",
      "additional_service_desc_recovery_continental_uk": "Tarifa de recuperación en Europa Continental y Reino Unido",
      "additional_service_desc_recovery_islands": "Tarifa de recuperación en islas europeas",
      "additional_service_desc_recovery_ceuta_melilla": "Tarifa de recuperación en Ceuta y Melilla",
      "additional_service_desc_pit_stop_technical": "Por hora de espera en talleres (cambio neumáticos, servicios batería, etc.)",
      
      // Distance & Pricing
      "distance_pricing": "Distancia y Precios",
      "client_service_price": "Precio del Servicio",
      "calculated_distance": "Distancia Calculada",
      "calculating": "Calculando...",
      "base_price": "Precio Base",
      "client_base_price_no_vat": "Precio Base (sin IVA)",
      "additional_services_total": "Total Servicios Adicionales",
      "total_price": "Precio Total",
      "client_subtotal_no_vat": "Subtotal (sin IVA)",
      "client_total_with_vat": "Total (con IVA)",
      "client_address_status": "Estado de Direcciones:",
      "client_pickup_ok": "Recogida: OK",
      "client_pickup_missing": "Recogida: Falta",
      "client_delivery_ok": "Entrega: OK",
      "client_delivery_missing": "Entrega: Falta",
      "client_set_distance_manually": "Establecer distancia manualmente (km)",
      "notes": "Notas (Opcional)",
      "notes_placeholder": "Cualquier información adicional...",
      "service_docs_title": "Documentos adjuntos (opcional)",
      "service_docs_hint": "PDF o imágenes (JPEG, PNG, WebP). Máx. 10 MB por archivo, hasta 15 archivos. Puedes previsualizarlos antes de enviar.",
      "service_docs_hint_edit": "Puedes adjuntar documentos adicionales aquí. Los archivos ya guardados en el servicio no se eliminan.",
      "service_docs_browse": "Adjuntar archivos",
      "service_docs_preview": "Vista previa",
      "service_docs_remove": "Quitar",
      "service_docs_max_files": "Máximo 15 archivos por servicio",
      "service_docs_file_too_large": "Cada archivo debe pesar 10 MB o menos",
      "service_docs_invalid_type": "Solo se permiten PDF o imágenes JPEG, PNG o WebP",
      "service_docs_upload_warn": "Algunos documentos no se subieron",
      "service_docs_upload_warn_generic": "El servicio se guardó, pero no se pudieron subir algunos documentos.",
      
      // Actions
      "cancel": "Cancelar",
      "create": "Crear",
      "update_order": "Guardar Cambios",
      "update": "Actualizar",
      "delete": "Eliminar",
      "edit": "Editar",
      "pay_now": "Pagar Ahora",
      "calculate_price": "Calcular Precio",
      
      // Order Status
      "status": "Estado",
      "pending": "Por Asignar",
      "confirmed": "Confirmado",
      "assigned": "Asignado",
      "in_transit": "En Tránsito",
      "delivered": "Completado",
      "cancelled": "Cancelados",
      "Cancelado en Garantía": "Cancelado en Garantía",
      "Cancelado con -24h antelación": "Cancelado con -24h antelación",
      "Cancelado con +24h de antelación": "Cancelado con +24h de antelación",
      "payment_status_pending": "Pendiente",
      "paid": "Pagado",
      "failed": "Fallido",
      
      // Admin
      "admin_portal": "Portal de Administración",
      "dashboard": "Panel",
      "overview": "Resumen",
      "orders": "Servicios",
      "drivers": "Conductores",
      "pricing": "Precios",
      "total_orders": "Servicios Totales",
      "pending_orders": "Servicios Pendientes",
      "total_drivers": "Conductores Totales",
      "total_revenue": "Ingresos Totales",
      "recent_orders": "Servicios Recientes",
      "orders_management": "Gestión de Servicios",
      "drivers_management": "Gestión de Conductores",
      "pricing_management": "Gestión de Precios",
      "search_by_client": "Buscar por cliente",
      "search_by_plate": "Buscar por matrícula",
      "filter_by_status": "Filtrar por estado",
      "filter_by_city": "Filtrar por ciudad",
      "filter_by_date": "Filtrar por fecha",
      "from_date": "Desde fecha",
      "to_date": "Hasta fecha",
      "all_statuses": "Todos los estados",
      "all_cities": "Todas las ciudades",
      "update_order": "Actualizar Servicio",
      "edit_order_details": "Editar Detalles del Servicio",
      "assign_driver": "Asignar Conductor",
      "no_driver": "Sin conductor",
      "update": "Actualizar",
      "save_changes": "Guardar Cambios",
      "cancel": "Cancelar",
      "pickup_address": "Dirección de Recogida",
      "delivery_address": "Dirección de Entrega",
      "client_info": "Información del Cliente",
      "service_details": "Detalles del Servicio",
      "add_driver": "Añadir Conductor",
      "driver_name": "Nombre del Conductor",
      "driver_phone": "Teléfono del Conductor",
      "driver_status": "Estado del Conductor",
      "available": "Disponible",
      "busy": "Ocupado",
      "offline": "Desconectado",
      "add_pricing_rate": "Añadir Tarifa",
      "distance_range": "Rango de Distancia",
      "min_distance": "Distancia Mínima (km)",
      "max_distance": "Distancia Máxima (km)",
      "price_per_km": "Precio por km",
      "base_fee": "Tarifa Base",
      "example_price": "Precio de Ejemplo (100km)",
      "actions": "Acciones",
      "edit": "Editar",
      "delete": "Eliminar",
      "view_details": "Ver Detalles",
      "filters": "Filtros",
      "clear_filters": "Limpiar Filtros",
      "apply_filters": "Aplicar Filtros",
      "results": "resultados",
      "no_results": "No se encontraron resultados",
      "view_manage_orders": "Ver y gestionar todos los servicios de traslado",
      "pickup": "Recogida",
      "delivery": "Entrega",
      "vehicle": "Vehículo",
      "distance": "Distancia",
      "price": "Precio",
      "assigned_driver": "Conductor Asignado",
      "service_type": "Tipo de Servicio",
      "car_brand": "Marca",
      "car_model": "Modelo",
      "car_plate": "Matrícula",
      "fuel_type": "Tipo de Combustible",
      "pickup_contact": "Contacto de Recogida",
      "delivery_contact": "Contacto de Entrega",
      "contact_name": "Nombre de Contacto",
      "contact_phone": "Teléfono de Contacto",
      "pickup_date": "Fecha de Recogida",
      "delivery_date": "Fecha de Entrega",
      "no_delivery_date": "Sin fecha de entrega",
      "manage_driver_fleet": "Gestiona tu flota de conductores",
      "information": "Información",
      "modify_order_information": "Modifica la información del servicio",
      "payment_status": "Estado del Pago",
      "select_payment_pending": "Pendiente",
      "select_payment_paid": "Pagado",
      "select_payment_failed": "Fallido",
      "admin_order_assigned_client": "Cliente Asignado",
      "admin_order_change_client_hint": "Puedes cambiar el cliente asignado a este servicio",
      "admin_order_notes_label": "Notas / Observaciones",
      "admin_order_notes_visible_driver": "Estas notas serán visibles para el conductor",
      "admin_order_service_details_editable": "Detalles del Servicio (Editable)",
      "admin_order_client_price_undefined_title": "El precio al cliente no está definido",
      "admin_order_client_price_undefined_hint": "Haz clic en \"Recalcular Precio Cliente\" para calcular basado en la distancia",
      "admin_order_recalc_client_price": "Recalcular Precio Cliente",
      "admin_order_client_price_prefix": "Precio al Cliente:",
      "admin_order_client_price_company_hint": "Este es el precio que se cobra a la empresa",
      "admin_order_calc_distance_btn": "Calcular",
      "admin_order_distance_auto_hint": "✨ Se calcula automáticamente al cambiar direcciones, o haz clic en \"Calcular\"",
      "admin_order_service_type_edit_hint": "✏️ Editable - Necesario para calcular tarifa del conductor",
      "admin_order_driver_rate_title": "Tarifa para el Conductor",
      "admin_order_rate_required_badge": "⚠️ OBLIGATORIO",
      "admin_order_driver_rate_required_warning": "⚠️ Has asignado un conductor. Debes seleccionar una tarifa antes de guardar.",
      "admin_order_select_driver_rate_hint": "Selecciona la tarifa que le pagarás al conductor por este servicio de {{km}} km",
      "admin_order_tariff_basic": "💰 Básica (tarifa estándar)",
      "admin_order_tariff_premium": "⭐ Tarifa Premium",
      "admin_order_tariff_jluis": "🌟 JLUIS (premium +10%)",
      "admin_order_tariff_custom": "✏️ Precio Personalizado",
      "admin_order_rate_selected_line": "✓ Tarifa seleccionada: {{price}}€{{suffix}}",
      "admin_order_rate_suffix_custom": " (Personalizada)",
      "admin_order_assign_driver_distance_warning": "⚠️ Has asignado un conductor. Para poder seleccionar su tarifa, primero completa la distancia (km) y el tipo de servicio arriba.",
      "admin_order_address_distance_hint": "✨ La distancia se calculará automáticamente al cambiar las direcciones",
      "admin_order_dates_times_title": "📅 Fechas y Horarios",
      "admin_order_pickup_dates": "Fechas de Recogida",
      "admin_order_delivery_dates": "Fechas de Entrega",
      "admin_order_fixed_datetime": "Fecha y hora fija",
      "admin_order_date_label": "Fecha",
      "admin_order_time_label": "Hora",
      "admin_order_date_from": "Fecha Desde",
      "admin_order_date_to": "Fecha Hasta",
      "admin_order_time_from": "Hora Desde",
      "admin_order_time_to": "Hora Hasta",
      "admin_order_service_date_calendar": "📅 Fecha del Servicio (para calendario)",
      "admin_order_service_date_calendar_hint": "⚠️ Esta fecha aparecerá en el calendario del conductor una vez asignado",
      "admin_order_additional_services_blurb": "Selecciona los servicios adicionales necesarios para este transporte",
      "admin_order_driver_extras_title": "Extras del Conductor",
      "admin_order_driver_extras_intro": "Añade cargos adicionales que se incluirán en la liquidación del conductor (Pit Stop, Espera, ITV, etc.)",
      "admin_order_extras_added": "Extras añadidos:",
      "admin_order_extras_total": "Total Extras:",
      "admin_order_extras_vat_note": "(+21% IVA en liquidación)",
      "admin_order_add_extra_label": "Añadir Extra:",
      "admin_order_select_extra_type_placeholder": "Seleccionar tipo...",
      "admin_order_extra_subtotal": "Subtotal:",
      "admin_order_extra_add_button": "Añadir",
      "admin_fleet_driver_badge": "🚗 Flotista",
      "admin_driver_not_validated_badge": "⚠️ Sin validar",
      "admin_toast_client_price_calculated": "Precio calculado: €{{amount}}",
      "admin_toast_driver_tariff_selected": "Tarifa {{label}} seleccionada: {{price}}€",
      "admin_order_notes_placeholder": "Añade notas o comentarios sobre este servicio...",
      "admin_order_edit_service_type_heading": "Tipo de Servicio *",
      "admin_order_card_delivery_title": "🚗 Entrega",
      "admin_order_card_delivery_desc": "Transporte estándar de un solo vehículo del punto A al punto B.",
      "admin_order_card_bc_title": "🔄 Servicio B-C",
      "admin_order_card_bc_desc": "Múltiples destinos: recogida en A, entrega en B y recogida en B para entregar en C (20% descuento en el 2.º vehículo).",
      "admin_order_card_tradein_title": "🔁 TRADE-IN",
      "admin_order_card_tradein_desc": "Intercambio de vehículos: recogida en A, entrega en B y recogida en B para devolver en A (30% descuento en el 2.º vehículo).",
      "admin_order_card_repr_title": "👤 Representación",
      "admin_order_card_repr_desc": "Verificación in situ por un representante.",
      "admin_order_select_client_placeholder": "Seleccionar cliente",
      "admin_order_distance_km_label": "Distancia (km) *",
      "admin_order_service_type_field_label": "Tipo de Servicio *",
      "admin_custom_pricing_dialog_edit": "Editar rango de precios personalizados",
      "admin_custom_pricing_dialog_assign": "Asignar tarifa personalizada",
      "admin_custom_pricing_desc_for_client": "Configurar precios para {{name}}",
      "admin_custom_pricing_desc_select_client": "Selecciona un cliente y configura sus precios personalizados",
      "admin_copy_from_general_pricing": "Copiar de tarifa general",
      "admin_add_rate_to_template": "Agregar tarifa a {{name}}",
      "admin_template_rate_dialog_desc": "Define un rango de distancia y los precios para cada tipo de servicio",
      "admin_template_rate_per_km_section": "Precios por km adicional (opcional — para rangos 1001+ km)",
      "admin_driver_documents_modal_title": "Documentos del conductor",
      "admin_trip_details_dialog_title": "Detalles de viajes — {{name}}",
      "admin_assign_driver_rate_dialog_title": "Asignar tarifa al conductor",
      "admin_assign_driver_client_charge_title": "Tarifa cobrada al cliente",
      "admin_assign_driver_client_charge_hint": "Este es el precio que pagará el cliente por el servicio",
      "admin_price_vat_included_short": "IVA incluido",
      "admin_select_tariff_for_driver_title": "Selecciona la tarifa para el conductor:",
      "admin_select_tariff_for_driver_subtitle": "Elige qué tarifa le pagaremos al conductor por este servicio",
      "admin_margin_label_plain": "Margen:",
      "admin_payment_for_driver_caption": "para el conductor",
      "admin_custom_driver_price_manual_hint": "Especificar un precio diferente manualmente",
      "admin_edit_go_arrow": "Editar →",
      "admin_template_rates_col_distance_km": "Distancia (km)",
      "admin_pickup_photos_driver_heading": "Fotos de Recogida (Conductor)",
      "admin_delivery_photos_driver_heading": "Fotos de Entrega (Conductor)",
      "admin_vehicle_photo_exterior_section": "Fotos exteriores",
      "admin_vehicle_photo_interior_section": "Fotos interiores",
      "admin_vehicle_photo_angle_front": "Frontal",
      "admin_vehicle_photo_angle_rear": "Trasera",
      "admin_vehicle_photo_angle_left_front": "Lateral izq. frontal",
      "admin_vehicle_photo_angle_left_rear": "Lateral izq. trasero",
      "admin_vehicle_photo_angle_right_front": "Lateral der. frontal",
      "admin_vehicle_photo_angle_right_rear": "Lateral der. trasero",
      "admin_vehicle_photo_front_seats": "Asientos delanteros",
      "admin_vehicle_photo_rear_seats": "Asientos traseros",
      "admin_vehicle_photo_dashboard": "Salpicadero",
      "admin_vehicle_photo_trunk": "Maletero",
      "admin_vehicle_photo_acta_pickup": "Acta de entrega (recogida)",
      "admin_vehicle_photo_acta_delivery": "Acta de entrega (entrega)",
      "admin_rates_for_template_title": "Tarifas — {{name}}",
      "admin_order_distance_placeholder_example": "Ej: 150.5",
      "admin_toast_tariff_calculate_failed": "No se pudo calcular la tarifa",
      "admin_toast_price_calculate_error": "Error al calcular el precio",
      "admin_toast_select_extra_type": "Selecciona un tipo de extra",
      "admin_toast_extra_price_gt_zero": "El precio debe ser mayor a 0",
      "admin_toast_extra_added_ok": "Extra añadido",
      "admin_order_extra_qty_short": "Cant.",
      "admin_order_extra_price_placeholder": "Precio",
      "admin_order_extra_custom_description_ph": "Descripción del extra personalizado...",
      "admin_tariff_name_basic": "Básica (tarifa estándar)",
      "admin_tariff_name_premium": "Premium",
      "admin_tariff_name_jluis": "JLUIS (premium +10%)",
      "admin_unknown_client": "Desconocido",
      "admin_complete_dialog_subtitle": "Servicio para <clientHighlight>{{client}}</clientHighlight> - {{brand}} {{model}} ({{plate}})",
      "admin_complete_journey_expenses": "Gastos del Trayecto",
      "admin_complete_expense_fuel": "Combustible (€)",
      "admin_complete_expense_tolls": "Peajes (€)",
      "admin_complete_expense_parking": "Aparcamiento (€)",
      "admin_complete_expense_taxi": "Taxi/Transporte (€)",
      "admin_complete_expense_other": "Otros Gastos (€)",
      "admin_complete_expense_other_desc": "Descripción otros gastos",
      "admin_complete_expense_other_ph": "Ej: Peaje urbano, etc.",
      "admin_complete_total_expenses": "Total Gastos:",
      "admin_complete_service_photos": "Fotos del Servicio",
      "admin_complete_pickup_photos": "Fotos de Recogida",
      "admin_complete_delivery_photos": "Fotos de Entrega",
      "admin_complete_expense_photos": "Fotos de Gastos (Tickets/Facturas)",
      "admin_complete_contract_photos": "Contrato de Transporte Firmado",
      "admin_complete_contract_hint": "Sube una foto del contrato de transporte firmado por el cliente",
      "admin_complete_photo_count": "{{count}} foto(s)",
      "admin_complete_add_photos": "Añadir fotos",
      "admin_complete_add_tickets": "Añadir tickets",
      "admin_complete_add_contract": "Añadir contrato",
      "admin_complete_photo_alt_pickup": "Recogida {{num}}",
      "admin_complete_photo_alt_delivery": "Entrega {{num}}",
      "admin_complete_photo_alt_expense": "Gasto {{num}}",
      "admin_complete_photo_alt_contract": "Contrato {{num}}",
      "admin_complete_client_charges_title": "Cargos Adicionales al Cliente",
      "admin_complete_client_charges_badge": "NO visible para el conductor",
      "admin_complete_client_charges_intro": "Añade cargos adicionales que se facturarán al cliente (esperas, pit stops, servicios extra, etc.)",
      "admin_complete_charge_type": "Tipo de cargo",
      "admin_complete_select_placeholder": "Seleccionar...",
      "admin_complete_charge_desc_optional": "Descripción (opcional)",
      "admin_complete_charge_desc_ph": "Ej: 30 minutos",
      "admin_complete_charge_amount": "Importe",
      "admin_complete_charges_added": "Cargos añadidos:",
      "admin_complete_charges_total": "Total cargos adicionales:",
      "admin_complete_notes_title": "Notas de Finalización",
      "admin_complete_notes_ph": "Añade notas sobre la entrega (opcional)...",
      "admin_toast_complete_charge_required": "Selecciona un tipo de cargo e ingresa el importe",
      "admin_toast_complete_upload_error_file": "Error al subir {{file}}",
      "admin_toast_complete_photos_uploaded": "{{count}} foto(s) subida(s) correctamente",
      "admin_toast_complete_upload_photos_failed": "Error al subir las fotos",
      "admin_toast_complete_service_ok": "Servicio completado y pasado al histórico",
      "admin_toast_complete_service_failed": "Error al completar el servicio",
      "admin_toast_complete_service_failed_code": "Error al completar el servicio (código {{code}})",
      "admin_toast_complete_service_network": "Error de conexión al completar el servicio",
      "monitor_performance": "Monitorea el rendimiento de tu servicio de traslado",
      "client": "Cliente",
      "route": "Ruta",
      "service": "Servicio",
      "filter_by_payment": "Filtrar por estado del pago",
      "admin_payment_status_label": "Estado de pago *",
      "filter_by_driver": "Filtrar por conductor",
      "no_driver_assigned": "Sin conductor asignado",
      "all_drivers": "Todos los conductores",
      "search_driver": "Buscar conductor...",
      "create_new_driver": "Crear nuevo conductor",
      "type_to_search": "Escribe para buscar...",
      "driver_info": "Información del Conductor",
      "driver_phone": "Teléfono Conductor",
      "driver_dni": "DNI/NIF Conductor",
      
      // Admin Dashboard (sidebar, stats, kanban, sub-admins)
      "admin_calendar": "Calendario",
      "admin_incidents": "Incidencias",
      "admin_management": "Gestión",
      "admin_tracking": "Seguimiento",
      "admin_live_gps": "GPS en vivo",
      "gps_live_title": "GPS en Vivo",
      "gps_live_subtitle": "Monitorea los vehículos en tránsito en tiempo real",
      "gps_live_loading": "Cargando servicios activos...",
      "gps_live_badge": "EN VIVO",
      "gps_live_refresh": "Actualizar",
      "gps_live_last_update_full": "Última actualización: {{time}} (Auto-refresh cada 30s)",
      "gps_live_map_title": "Mapa de Vehículos ({{count}} en ruta)",
      "gps_live_map_alt": "Mapa de vehículos en tránsito",
      "gps_live_open_maps": "Abrir en Google Maps",
      "gps_live_no_locations": "Sin ubicaciones GPS disponibles",
      "gps_live_static_map_key_missing": "Configura la variable REACT_APP_GOOGLE_MAPS_API_KEY para mostrar el mapa de vista previa.",
      "gps_live_empty_title": "No hay vehículos en ruta",
      "gps_live_empty_description": "Los vehículos en tránsito aparecerán aquí cuando un conductor inicie un servicio",
      "gps_live_active_services": "Servicios Activos ({{count}})",
      "gps_live_in_route": "En Ruta",
      "gps_live_origin": "Origen",
      "gps_live_destination": "Destino",
      "gps_live_last_gps_update": "Última actualización GPS:",
      "gps_live_speed": "Velocidad:",
      "gps_live_scheduled_date": "Fecha programada:",
      "gps_live_service_id": "ID Servicio:",
      "gps_live_eta": "ETA: {{minutes}} min",
      "gps_live_na": "N/A",
      "inspections_title": "Peritajes de Vehículos",
      "inspections_subtitle": "Informes de inspección con fotos y análisis IA",
      "inspections_search_placeholder": "Buscar por matrícula, conductor...",
      "inspections_loading": "Cargando peritajes...",
      "inspections_stat_total": "Total Peritajes",
      "inspections_stat_photos": "Fotos",
      "inspections_stat_with_damage": "Con Daños",
      "inspections_stat_no_damage": "Sin Daños",
      "inspections_empty_title": "No hay peritajes",
      "inspections_empty_hint": "Los informes de peritación aparecerán aquí cuando los conductores los realicen",
      "inspections_empty_search": "No se encontraron resultados para tu búsqueda",
      "inspections_damage_count": "{{count}} daño(s)",
      "inspections_no_damage_short": "Sin daños",
      "inspections_modal_title": "Peritaje - {{plate}}",
      "inspections_photo_gallery": "Galería de Fotos ({{count}})",
      "inspections_photo_alt": "Foto {{n}}",
      "inspections_photo_type_default": "Foto",
      "inspections_ai_analysis_prefix": "Análisis IA:",
      "inspections_ai_summary_title": "Resumen del Análisis IA",
      "inspections_damages_detected": "Daños Detectados",
      "inspections_no_damages_message": "No se detectaron daños",
      "inspections_odometer": "Odómetro",
      "inspections_fuel": "Combustible",
      "inspections_overall_condition": "Estado General",
      "inspections_signature_title": "Firma del Responsable",
      "inspections_signature_alt": "Firma",
      "inspections_location_unavailable": "Ubicación no disponible",
      "inspections_performed_by": "Realizado por:",
      "gps_live_tracking_btn": "Tracking",
      "transport_tab_title": "Servicios de Transporte",
      "transport_tab_subtitle": "Gestiona los trayectos de vehículos",
      "transport_tab_loading": "Cargando servicios...",
      "transport_tab_new_service": "Nuevo Servicio",
      "transport_tab_stat_pending": "Pendientes",
      "transport_tab_stat_reserved": "Reservados",
      "transport_tab_stat_in_route": "En Ruta",
      "transport_tab_stat_total": "Total",
      "transport_tab_search_placeholder": "Buscar por matrícula, conductor, cliente...",
      "transport_tab_filter_status": "Estado",
      "transport_tab_filter_pending": "Pendientes",
      "transport_tab_filter_reserved": "Reservados",
      "transport_tab_filter_in_route": "En Ruta",
      "transport_tab_filter_completed": "Completados",
      "transport_tab_status_pending": "Pendiente",
      "transport_tab_status_reserved": "Reservado",
      "transport_tab_status_in_route": "En Ruta",
      "transport_tab_status_completed": "Completado",
      "transport_tab_status_cancelled": "Cancelado",
      "transport_tab_empty_title": "No hay servicios",
      "transport_tab_empty_hint": "Crea un nuevo servicio de transporte",
      "transport_tab_empty_search": "No se encontraron resultados",
      "transport_tab_modal_create_title": "Nuevo Servicio de Transporte",
      "transport_tab_client_required": "Cliente *",
      "transport_tab_plate_required": "Matrícula *",
      "transport_tab_brand": "Marca",
      "transport_tab_model": "Modelo",
      "transport_tab_color": "Color",
      "transport_tab_pickup_address_required": "Dirección de Recogida *",
      "transport_tab_delivery_address_required": "Dirección de Entrega *",
      "transport_tab_scheduled_date": "Fecha Programada",
      "transport_tab_contact_phone": "Teléfono de Contacto",
      "transport_tab_notes": "Notas",
      "transport_tab_notes_placeholder": "Instrucciones especiales...",
      "transport_tab_ph_plate": "1234ABC",
      "transport_tab_ph_brand": "BMW",
      "transport_tab_ph_model": "Serie 3",
      "transport_tab_ph_color": "Negro",
      "transport_tab_ph_pickup": "Calle Principal 123, Madrid",
      "transport_tab_ph_delivery": "Avenida Central 456, Barcelona",
      "transport_tab_ph_phone": "+34 600 000 000",
      "transport_tab_create_service": "Crear Servicio",
      "transport_tab_alert_required_fields": "Por favor completa los campos obligatorios",
      "transport_tab_alert_create_failed": "Error al crear servicio",
      "transport_tab_detail_vehicle": "Vehículo",
      "transport_tab_detail_route": "Ruta",
      "transport_tab_detail_driver": "Conductor",
      "transport_tab_detail_client": "Cliente",
      "transport_tab_unassign_driver": "Quitar asignación",
      "transport_tab_no_driver_assigned_detail": "Sin conductor asignado",
      "transport_tab_assign_driver_placeholder": "Asignar conductor",
      "transport_tab_tracking_link": "Link de Tracking",
      "transport_tab_open": "Abrir",
      "transport_tab_inspections_section": "Peritajes",
      "transport_tab_pickup_inspection_badge": "Peritaje de recogida disponible",
      "transport_tab_delivery_inspection_badge": "Peritaje de entrega disponible",
      "admin_expert_reports": "Peritajes",
      "admin_transportation_services": "Servicios de transporte",
      "admin_pricing_section": "Tarifas",
      "admin_general_pricing": "Tarifas Generales",
      "admin_driver_pricing": "Tarifas Conductores",
      "admin_custom_pricing": "Tarifas Personalizadas",
      "admin_billing": "Facturación",
      "admin_client_invoices": "Facturas Clientes",
      "admin_driver_invoices": "Facturas Conductores",
      "admin_approvals": "Aprobaciones",
      "admin_administration": "Administración",
      "admin_profiles": "Perfiles",
      "admin_documents": "Documentos",
      "admin_collaborators": "Colaboradores",
      "admin_close_sidebar": "Cerrar menú",
      "admin_services_in_progress": "Servicios en Curso",
      "admin_total_services_done": "Servicios Totales Hechos",
      "admin_pending_closure": "Pendientes Cierre (Chóferes)",
      "admin_services_completed": "Servicios Completados",
      "admin_pending_payment": "Pendientes de Pago",
      "admin_services_paid": "Servicios Pagados",
      "admin_pending_approvals": "Aprobaciones Pendientes",
      "admin_total_revenue": "Ingresos Totales",
      "admin_kanban_new": "Nuevos",
      "admin_kanban_new_subtitle": "Sin conductor asignado",
      "admin_kanban_assigned": "Asignados",
      "admin_kanban_assigned_subtitle": "En ruta / En progreso",
      "admin_kanban_pending_approval": "Por Aprobar",
      "admin_kanban_pending_approval_subtitle": "Esperando validación",
      "admin_kanban_completed": "Completados",
      "admin_kanban_completed_subtitle": "Pendiente de histórico",
      "admin_no_client": "Sin cliente",
      "admin_unassigned": "Sin asignar",
      "admin_status_pending": "Pendiente",
      "admin_status_assigned": "Asignado",
      "admin_status_in_progress": "En Progreso",
      "admin_status_in_transit": "En Tránsito",
      "admin_status_delivered": "Entregado",
      "admin_status_cancelled": "Cancelado",
      "admin_payment_pending": "Pago Pendiente",
      "admin_payment_paid": "Pagado",
      "admin_payment_failed": "Pago Fallido",
      "admin_client_label": "Cliente:",
      "admin_driver_label": "Conductor:",
      "admin_price_client": "Precio Cliente:",
      "admin_price_driver": "Precio Conductor:",
      "admin_distance": "Distancia:",
      "admin_photos_pickup": "Fotos Recogida",
      "admin_photos_delivery": "Fotos Entrega",
      "admin_expenses": "Gastos",
      "admin_open": "Abrir",
      "admin_complete": "Completar",
      "admin_history": "Historial",
      "admin_revert": "Revertir",
      "admin_revert_title": "Devolver a En Proceso para modificar gastos",
      "admin_photos": "Fotos",
      "admin_contract": "Contrato",
      "admin_calendar_btn": "Calendar",
      "admin_delete": "Eliminar",
      "admin_cancel": "Cancelar",
      "admin_cancel_at_pickup": "Salida",
      "admin_cancel_at_pickup_title": "Vehículo no disponible en recogida",
      "admin_cancel_in_transit": "Transporte",
      "admin_cancel_in_transit_title": "Cancelado durante transporte",
      "admin_approve_cancellation": "Aprobar Cancelación",
      "admin_filters": "Filtros",
      "admin_filter_client": "Cliente",
      "admin_search_client_placeholder": "Buscar cliente...",
      "admin_plate": "Matrícula",
      "admin_plate_placeholder": "Matrícula...",
      "admin_city": "Ciudad",
      "admin_city_placeholder": "Ciudad...",
      "admin_driver_filter": "Conductor",
      "admin_from": "Desde",
      "admin_to": "Hasta",
      "admin_clear_filters": "Limpiar",
      "admin_all": "Todos",
      "admin_kanban_tip": "Arrastra las tarjetas entre columnas para cambiar el estado del servicio",
      "admin_kanban_bc_vehicle2": "Vehículo 2 (B-C):",
      "admin_kanban_second_vehicle_bc": "Segundo vehículo (B-C)",
      "admin_kanban_delivery_vehicle2_point_c": "Entrega vehículo 2 (Punto C):",
      "admin_kanban_point_c_label": "Punto C:",
      "admin_services_in_process": "servicios en proceso",
      "admin_drop_here": "Soltar aquí",
      "admin_no_services": "No hay servicios",
      "admin_confirm_action": "Confirmar Acción",
      "admin_approve_service": "Aprobar Servicio",
      "admin_approve_service_message": "¿Confirmas que deseas aprobar el servicio #{{id}}? El servicio pasará a estado Completado.",
      "admin_revert_state": "Revertir Estado",
      "admin_revert_state_message": "¿Deseas mover el servicio #{{id}} de vuelta a \"{{target}}\"? Esto abrirá el diálogo de edición para hacer los cambios necesarios.",
      "admin_confirm": "Confirmar",
      "admin_subadmins_title": "Gestión de Colaboradores",
      "admin_subadmins_desc": "Crea y administra usuarios con acceso limitado al sistema",
      "admin_new_collaborator": "Nuevo Colaborador",
      "admin_what_is_collaborator": "¿Qué es un Colaborador?",
      "admin_collaborator_bullet1": "Solo puede ver los conductores y servicios que tú le asignes",
      "admin_collaborator_bullet2": "Puede asignar tarifas solo a los conductores que gestiona",
      "admin_collaborator_bullet3": "Por defecto, no puede ver precios de clientes ni eliminar nada",
      "admin_collaborator_bullet4": "Puede crear nuevos servicios y gestionar fotos/documentos de sus conductores",
      "admin_loading_collaborators": "Cargando colaboradores...",
      "admin_no_collaborators": "No hay colaboradores creados",
      "admin_create_first_collaborator": "Crea un nuevo colaborador para empezar",
      "admin_see_prices": "Ve precios clientes",
      "admin_no_see_prices": "No ve precios clientes",
      "admin_see_unassigned": "Ve sin asignar",
      "admin_no_see_unassigned": "No ve sin asignar",
      "admin_can_delete": "Puede eliminar",
      "admin_cannot_delete": "No puede eliminar",
      "admin_drivers_count": "conductores",
      "admin_services_count": "servicios",
      "admin_assigned_drivers": "Conductores asignados:",
      "admin_assigned_services_unassigned": "Servicios asignados (sin conductor):",
      "admin_edit": "Editar",
      "admin_services": "Servicios",
      "admin_create_collaborator": "Crear Nuevo Colaborador",
      "admin_name_required": "Nombre *",
      "admin_name_placeholder": "Nombre del colaborador",
      "admin_email_required": "Email *",
      "admin_email_placeholder": "colaborador@empresa.com",
      "admin_password_required": "Contraseña *",
      "admin_password_placeholder": "Mínimo 8 caracteres",
      "admin_admin_type": "Tipo de Admin",
      "admin_permissions": "Permisos",
      "admin_can_see_prices_invoices": "Puede ver precios, tarifas y facturas de clientes",
      "admin_includes_prices_note": "Incluye: Tarifas, Facturas Clientes, Perfiles, columna de precios",
      "admin_can_see_unassigned_services": "Puede ver servicios sin asignar",
      "admin_can_delete_services": "Puede eliminar servicios y conductores",
      "admin_assigned_drivers_required": "Conductores Asignados *",
      "admin_assigned_drivers_heading": "Conductores Asignados",
      "admin_all_drivers": "Todos",
      "admin_none": "Ninguno",
      "admin_search_driver_placeholder": "Buscar conductor...",
      "admin_no_drivers_available": "No hay conductores disponibles",
      "admin_drivers_selected": "conductor(es) seleccionado(s)",
      "admin_create_collaborator_btn": "Crear Colaborador",
      "admin_edit_collaborator": "Editar Colaborador",
      "admin_email_readonly": "El email no se puede cambiar",
      "admin_save_changes": "Guardar Cambios",
      "admin_assign_services_to": "Asignar Servicios a",
      "admin_assign_services_note": "Solo se muestran servicios sin conductor asignado. Los servicios con conductor asignado se filtran automáticamente por los conductores del colaborador.",
      "admin_search_service_placeholder": "Buscar por ciudad, cliente o ID...",
      "admin_no_unassigned_services": "No hay servicios sin conductor disponibles",
      "admin_no_date_short": "Sin fecha",
      "admin_services_selected": "servicio(s) seleccionado(s)",
      "admin_save_services": "Guardar Servicios",
      "admin_super_admin": "Administrador Principal",
      "admin_full": "Admin Completo",
      "admin_sub_admin": "Colaborador",
      "admin_sub_admin_option": "Colaborador (Acceso limitado)",
      "admin_full_option": "Admin Completo (Ve todo)",
      "admin_driver_not_found": "Conductor no encontrado",
      "admin_service_not_found": "Servicio no encontrado",
      "admin_error_load_collaborators": "Error al cargar colaboradores",
      "admin_error_create_collaborator": "Error al crear colaborador",
      "admin_error_update_collaborator": "Error al actualizar colaborador",
      "admin_error_delete_collaborator": "Error al eliminar colaborador",
      "admin_error_assign_services": "Error al asignar servicios",
      "admin_confirm_delete_collaborator": "¿Estás seguro de eliminar este colaborador?",
      "admin_delete_collaborator_dialog_title": "Eliminar colaborador",
      "admin_delete_collaborator_dialog_desc": "¿Seguro que deseas eliminar a {{name}}? Esta acción no se puede deshacer.",
      "admin_fill_required": "Por favor completa todos los campos obligatorios",
      "admin_assign_at_least_one_driver": "Debes asignar al menos un conductor al colaborador",
      "admin_charge_espera": "Espera",
      "admin_charge_pit_stop": "Pit Stop",
      "admin_charge_itv": "ITV",
      "admin_charge_express": "Express",
      "admin_charge_recogida_extra": "Recogida Extra",
      "admin_charge_cambio_ruta": "Cambio de Ruta",
      "admin_charge_otros": "Otros",
      "admin_toast_periods_generated": "Periodos generados correctamente",
      "admin_toast_error_load_periods": "Error al cargar periodos de facturación",
      "admin_toast_error_generate_periods": "Error al generar periodos de facturación",
      "admin_toast_error_create_invoice": "Error al crear factura",
      "admin_toast_service_marked_paid": "Servicio marcado como pagado",
      "admin_toast_error_mark_paid": "Error al marcar servicio como pagado",
      "admin_toast_invoice_marked_paid": "Factura marcada como pagada",
      "admin_toast_error_invoice_paid": "Error al marcar factura como pagada",
      "admin_toast_collaborator_created": "Colaborador creado correctamente",
      "admin_toast_collaborator_created_no_email": "Colaborador creado. No se pudo enviar el email; comparte las credenciales manualmente.",
      "admin_toast_collaborator_updated": "Colaborador actualizado correctamente",
      "admin_toast_collaborator_deleted": "Colaborador eliminado correctamente",
      "admin_more_count_short": "+{{count}} más",
      "admin_toast_services_assigned": "Servicios asignados correctamente",
      "admin_table_service_id": "Servicio ID",
      "admin_table_client": "Cliente",
      "admin_table_plate": "Matrícula",
      "admin_table_pickup": "Recogida",
      "admin_table_delivery": "Entrega",
      "admin_table_dates": "Fechas",
      "admin_table_driver": "Conductor",
      "admin_table_status": "Estado",
      "admin_table_price": "Precio",
      "admin_table_action": "Acción",
      "calendar_title": "Calendario de Servicios",
      "calendar_subtitle": "Todos los servicios organizados por fecha de recogida",
      "calendar_no_driver": "Sin conductor",
      "calendar_in_progress": "En proceso",
      "calendar_completed": "Completado",
      "calendar_others": "Otros",
      "calendar_origin": "Origen:",
      "calendar_destination": "Destino:",
      "calendar_driver": "Conductor:",
      "calendar_client": "Cliente:",
      "calendar_price": "Precio:",
      "calendar_grid_timezone_label": "Días del calendario",
      "calendar_grid_timezone_hint": "Elige en qué zona se agrupan los servicios por fecha (útil si trabajas a distancia).",
      "timezone_label": "Zonas horarias (para alinear agenda)",
      "timezone_configure": "Configurar",
      "timezone_zone1_label": "Etiqueta zona 1 (ej. Yo, Madrid, Cliente)",
      "timezone_zone2_label": "Etiqueta zona 2 (ej. Asistente, Bangkok, Equipo)",
      "timezone_zone1_placeholder": "Zona 1",
      "timezone_zone2_placeholder": "Zona 2",
      "timezone_search_placeholder": "Buscar zona...",
      "timezone_help": "Las horas del calendario se muestran en ambas zonas. Elige cualquier par de zonas (p. ej. tú y tu asistente) para alinear agendas.",
      "timezone_save": "Guardar",
      "admin_services_in_progress_tab": "En proceso",
      "admin_historical": "Histórico",
      "admin_list": "Lista",
      "admin_view_mode_kanban": "Kanban",
      "admin_tip_label": "Consejo:",
      "admin_toast_select_driver_for_service": "Selecciona un conductor para asignar al servicio",
      "admin_overview_expiring_docs_title": "Documentos próximos a vencer",
      "admin_overview_expiring_docs_intro": "{{count}} documento(s) vencerán en los próximos 7 días. Requieren atención urgente.",
      "admin_overview_doc_status_expired": "Vencido hace {{days}} día(s)",
      "admin_overview_doc_status_expires": "Vence en {{days}} día(s)",
      "admin_overview_more_documents": "… y {{count}} documento(s) más",
      "admin_overview_view_driver": "Ver conductor",
      "admin_doc_type_license_front": "🪪 Licencia",
      "admin_doc_type_license_back": "🪪 Licencia (reverso)",
      "admin_doc_type_dni_front": "🆔 DNI",
      "admin_doc_type_dni_back": "🆔 DNI (reverso)",
      "admin_doc_section_license": "Licencia de Conducir",
      "admin_doc_section_dni": "DNI/NIE",
      "admin_doc_section_certificates": "Certificados",
      "admin_doc_side_front": "Frontal",
      "admin_doc_side_back": "Trasera",
      "admin_doc_type_autonomo_certificate": "📋 Alta autónomo",
      "admin_doc_type_ss_certificate": "📋 Seguridad Social",
      "admin_doc_type_hacienda_certificate": "📋 Agencia Tributaria",
      "admin_doc_type_unknown": "📄 Documento",
      "admin_recent_orders_row_title": "Abrir servicio en la lista de servicios",
      "admin_toast_driver_tariff_assigned_named": "Tarifa {{label}} (€{{amount}}) asignada al conductor",
      "admin_toast_driver_tariff_assigned_custom": "Tarifa personalizada (€{{amount}}) asignada al conductor",
      "admin_pricing_template_fallback": "Plantilla",
      "admin_contract_download_basename": "Contrato_AutoGo_",
      "admin_creation": "Creación:",
      "admin_rate_assigned_driver": "Tarifa asignada al conductor:",
      "admin_rate_suggestions_driver": "Sugerencias de Tarifa para Conductor:",
      "admin_rate_for_driver_incomplete": "Tarifas para Conductor (completa distancia y tipo):",
      "admin_basic": "Básica (tarifa estándar)",
      "admin_active": "Activa",
      "admin_custom": "A medida",
      "admin_customized": "Personalizada",
      "admin_approve": "Aprobar",
      "admin_complete_service_title": "Completar servicio con fotos y gastos",
      "admin_delete_service_title": "Eliminar servicio permanentemente",
      "admin_view_history_title": "Ver detalles del servicio completado",
      "admin_cancel_normal_title": "Cancelación normal (según tiempo)",
      "admin_calculated_distance": "Distancia Calculada",
      "admin_not_calculated": "No calculada",
      "admin_additional_services": "Servicios Adicionales",
      "admin_service_notes": "Notas del Servicio",
      "admin_notes_general": "General:",
      "admin_notes_vehicle1": "Vehículo 1:",
      "admin_notes_vehicle2": "Vehículo 2:",
      "admin_view_photos": "Ver Fotos",
      "admin_view_expenses": "Ver Gastos",
      "admin_no_photos_for_service": "No hay fotos disponibles para este servicio.",
      "admin_no_expenses_for_service": "No hay gastos reportados para este servicio.",
      "admin_service_expenses": "Gastos del Servicio",
      "admin_close": "Cerrar",
      "admin_no_receipts_attached": "No se adjuntaron recibos con este reporte",
      "admin_table_name": "Nombre",
      "admin_table_phone": "Teléfono",
      "admin_table_email": "Email",
      "admin_table_license": "Licencia",
      "admin_table_actions": "Acciones",
      "admin_driver_status_required": "Estado *",
      "admin_driver_busy": "Ocupado",
      "admin_driver_offline": "Desconectado",
      "admin_toast_driver_created_ok": "Conductor creado correctamente.",
      "admin_toast_driver_docs_uploaded": "{{count}} documento(s) subido(s).",
      "admin_toast_driver_welcome_email_sent": "Email de bienvenida enviado.",
      "admin_service_expenses_subtitle": "Servicio #{{id}} - {{brand}} {{model}}",
      "admin_add_to_calendar": "Agregar a Calendar",
      "admin_download_contract": "Descargar Contrato",
      "admin_premium": "Premium",
      "admin_toast_opening_calendar": "Abriendo Google Calendar...",
      "admin_toast_contract_downloaded": "Contrato descargado - 2 páginas: Conductor y Cliente",
      "admin_toast_contract_fallback_simple_pdf": "Contrato simplificado (Playwright falló). Windows: en backend ejecuta «python run_dev_api.py». Linux/servidor: python -m playwright install chromium",
      "admin_toast_error_generate_contract": "Error al generar el contrato",
      "admin_toast_error_download_contract": "Error al descargar el contrato",
      "pagination_showing": "Mostrando",
      "pagination_to": "a",
      "pagination_of": "de",
      "pagination_results": "resultados",
      "pagination_prev": "Anterior",
      "pagination_next": "Siguiente",
      "pagination_page_of": "Página {{current}} de {{total}}",
      "driver_profile_title": "Perfil del Conductor",
      "driver_profile_subtitle": "Información detallada, documentos y estadísticas",
      "driver_basic_info": "Información Básica",
      "driver_upload_new": "Subir Nuevo",
      "driver_upload_new_document": "Subir Nuevo Documento",
      "driver_statistics": "Estadísticas",
      "driver_total_services": "Servicios Totales",
      "driver_completed": "Completados",
      "driver_earnings": "Ganancias",
      "driver_billing_info": "Información de Facturación",
      "driver_doc_not_uploaded": "No subido",
      "driver_doc_expires_soon": "Vence Pronto",
      "driver_doc_approved": "Aprobado",
      "driver_doc_pending": "Pendiente",
      "driver_doc_rejected": "Rechazado",
      "driver_doc_expired": "Expirado",
      "driver_doc_dni_front": "DNI - Frente",
      "driver_doc_dni_back": "DNI - Reverso",
      "driver_doc_license_front": "Licencia - Frente",
      "driver_doc_license_back": "Licencia - Reverso",
      "driver_doc_autonomo": "Certificado Autónomo",
      "driver_doc_hacienda": "Certificado Hacienda",
      "driver_doc_ss": "Seguridad Social",
      "driver_error_open_document": "Error al abrir el documento",
      "driver_validated": "Validado",
      "driver_subidos_required": "subidos de {{required}} requeridos",
      "admin_edit_driver": "Editar Conductor",
      "admin_edit_driver_description": "Modifica la información del conductor. El admin puede editar todo.",
      "admin_label_name": "Nombre",
      "admin_label_email": "Correo electrónico",
      "admin_label_phone": "Teléfono",
      "admin_label_dni_nif": "DNI/NIF",
      "admin_driver_available": "Conductor disponible",
      "admin_documents_validated": "Documentos Validados",
      "admin_billing_full_name": "Nombre y Apellidos Completos *",
      "admin_billing_legal_name_hint": "Nombre legal completo para facturas",
      "admin_billing_dni_nie": "DNI o NIE *",
      "admin_billing_irpf": "Retención IRPF (%)",
      "admin_billing_irpf_hint": "Porcentaje de IRPF a retener (0-100%)",
      "admin_billing_fiscal_address": "Dirección Fiscal Completa *",
      "admin_billing_bank_name": "Nombre del Banco *",
      "admin_billing_iban": "Número de Cuenta (IBAN) *",
      "admin_driver_type": "Tipo de Conductor",
      "admin_fleet_driver": "Conductor con Flota",
      "admin_fleet_driver_hint": "Los conductores con flota pueden crear y gestionar otros conductores bajo su supervisión.",
      "admin_assign_fleet": "Asignar a Flota (Opcional)",
      "admin_independent_driver": "Conductor Independiente",
      "admin_fleet_assign_hint": "Si seleccionas una flota, este conductor estará bajo la supervisión del conductor con flota seleccionado",
      "admin_create_new_driver_desc": "Crea un nuevo conductor. Se generará una contraseña automáticamente y se enviará por email.",
      "admin_create_new_driver": "Crear Nuevo Conductor",
      "admin_create_driver_password_info": "Se generará una contraseña aleatoria y se enviará al email del conductor junto con sus credenciales de acceso.",
      "admin_driver_dni_required": "DNI/NIF *",
      "admin_review_document": "Revisar Documento",
      "admin_certificate_expiry_12m": "Fecha de vencimiento (12 meses)",
      "admin_certificate_expiry_6m": "Fecha de vencimiento (6 meses)",
      "admin_doc_label_pdf": "{{name}} (PDF)",
      "admin_add_new_driver": "Añadir Nuevo Conductor",
      "admin_enter_driver_info": "Introduce los datos del conductor",
      "admin_license_number": "Número de Licencia",
      "admin_name_label": "Nombre",
      "admin_vehicle_info_label": "Información del Vehículo",
      "admin_vehicle_info_placeholder": "Marca, modelo, matrícula...",
      "admin_billing_full_name_placeholder": "Ej: María Carmen Rodríguez Fernández",
      "admin_billing_fiscal_placeholder": "Calle, número, código postal, ciudad, provincia",
      "admin_billing_bank_placeholder": "Ej: Santander",
      "admin_billing_iban_placeholder": "ES00 0000 0000 0000 0000 0000",
      "admin_drivers_management": "Gestión de Conductores",
      "admin_manage_driver_fleet": "Gestiona tu flota de conductores",
      "admin_clients_management": "Gestión de Clientes",
      "admin_clients_detail": "Información detallada de todos los clientes",
      "admin_drivers_detail": "Información detallada de todos los conductores",
      "admin_drivers_assigned_desc": "Conductores que tienes asignados o que has creado",
      "admin_drivers_assigned": "Asignados",
      "admin_drivers_registered": "Registrados",
      "admin_drivers_assigned_title": "Conductores Asignados",
      "admin_drivers_registered_title": "Conductores Registrados",
      "admin_create_driver": "Crear Conductor",
      "admin_billing_info": "Información de Facturación",
      "admin_delivery_info": "Información de Entrega",
      "admin_driver_docs_title": "Documentación del Conductor",
      "admin_validation_pending": "Pendiente Validación",
      "admin_docs_warning_title": "Atención: Conductor validado sin documentos",
      "admin_docs_warning_body": "Este conductor está marcado como \"Validado\" pero no tiene ningún documento subido al sistema. Por favor, sube los documentos correspondientes para mantener los registros correctos.",
      "admin_fleet_driver_info": "Conductor de Flota: Solo requiere Licencia de Conducir y DNI (4 documentos básicos)",
      "admin_independent_driver_info": "Conductor Independiente/Flotista: Requiere todos los documentos (7 en total)",
      "admin_docs_upload_note": "Al subir documentos como admin, se validan automáticamente. Máximo 5MB por archivo.",
      "admin_docs_uploaded_count": "Documentos Subidos ({{count}})",
      "admin_docs_basic": "Documentos Básicos (Obligatorios)",
      "admin_docs_certificates": "Certificados Adicionales (Solo Independientes y Flotistas)",
      "admin_expiry_date": "Fecha de Vencimiento",
      "admin_format_image_pdf": "Formato: JPG, PNG o PDF (máx. 5MB)",
      "admin_format_pdf": "Formato: PDF (máx. 5MB)",
      "admin_uploaded": "Subido",
      "admin_expires": "Vence",
      "admin_expired": "VENCIDO",
      "admin_expires_soon": "VENCE PRONTO",
      "admin_docs_no_delete": "Los documentos NO pueden ser borrados. Para reemplazar un documento, sube uno nuevo del mismo tipo.",
      "admin_uploading_doc": "Subiendo documento...",
      "admin_doc_license_front_full": "Licencia de Conducir (Frontal)",
      "admin_doc_license_back_full": "Licencia de Conducir (Trasera)",
      "admin_doc_dni_front_full": "DNI/NIE (Frontal)",
      "admin_doc_dni_back_full": "DNI/NIE (Trasero)",
      "admin_doc_autonomo_full": "Alta de Autónomo",
      "admin_doc_ss_full": "Certificado Corriente Seguridad Social",
      "admin_doc_hacienda_full": "Certificado Corriente Agencia Tributaria",
      "admin_general_pricing_title": "Tarifas Generales Clientes",
      "admin_general_pricing_description": "Estas tarifas se aplican por defecto a todos los clientes",
      "admin_add_pricing_rate": "Añadir Tarifa",
      "admin_edit_pricing_rate": "Editar Tarifa",
      "admin_add_new_pricing_rate": "Añadir Nueva Tarifa",
      "admin_configure_pricing_description": "Configura la tarifa para un rango de distancia",
      "admin_min_distance_km": "Distancia Mínima (km)",
      "admin_max_distance_km": "Distancia Máxima (km)",
      "admin_price_delivery": "Precio Servicio Entrega (€)",
      "admin_price_bc": "Precio Servicio B-C (€)",
      "admin_price_tradein": "Precio Servicio TRADE-IN (€)",
      "admin_price_representation": "Precio Servicio Representación (€)",
      "admin_per_km_section": "Precios por km adicional (opcional - para rangos 1001+ km)",
      "admin_per_km_delivery": "Entrega - Precio por km adicional (€)",
      "admin_per_km_bc": "B-C - Precio por km adicional (€)",
      "admin_per_km_tradein": "TRADE-IN - Precio por km adicional (€)",
      "admin_per_km_note": "Si se define, el precio será: base + (km - 1001) × este valor",
      "admin_placeholder_040": "Ej: 0.40",
      "admin_placeholder_032": "Ej: 0.32",
      "admin_placeholder_028": "Ej: 0.28",
      "admin_pricing_table_title": "Tabla de Tarifas Generales Clientes",
      "admin_pricing_table_description": "Por defecto, todos los clientes usan estas tarifas",
      "admin_pricing_col_distance": "Distancia (km)",
      "admin_pricing_col_delivery": "Entrega (€)",
      "admin_pricing_col_bc": "Servicio B-C (€)",
      "admin_pricing_col_tradein": "TRADE-IN (€)",
      "admin_pricing_col_representation": "Representación (€)",
      "admin_pricing_col_actions": "Acciones",
      "admin_no_rates_configured": "No hay tarifas configuradas. Haz clic en \"Añadir Tarifa\" para crear una.",
      "admin_pricing_cell_base_plus_per_km": "€{{base}} + €{{perKm}}/{{perKmUnit}}",
      "admin_per_km_suffix": "km adicional",
      "admin_additional_services_title": "Servicios Adicionales",
      "admin_additional_services_description": "Tarifas de servicios extras disponibles para todos los clientes",
      "admin_add_service": "Agregar Servicio",
      "admin_edit_additional_service": "Editar Servicio Adicional",
      "admin_new_additional_service": "Nuevo Servicio Adicional",
      "admin_edit_additional_service_desc": "Modifica los datos del servicio",
      "admin_new_additional_service_desc": "Agrega un nuevo servicio adicional",
      "admin_service_name_label": "Nombre del Servicio",
      "admin_service_name_placeholder": "Ej: Limpieza Exterior",
      "admin_service_price_label": "Precio (€)",
      "admin_billing_unit_label": "Unidad de Cobro",
      "admin_unit_per_service": "Por Servicio",
      "admin_unit_per_hour": "Por Hora",
      "admin_unit_per_vehicle": "Por Vehículo",
      "admin_service_description_label": "Descripción",
      "admin_service_description_placeholder": "Descripción del servicio",
      "admin_additional_services_col_service": "Servicio",
      "admin_additional_services_col_price": "Precio (€)",
      "admin_additional_services_col_unit": "Unidad",
      "admin_additional_services_col_description": "Descripción",
      "admin_additional_services_col_actions": "Acciones",
      "admin_no_additional_services": "No hay servicios adicionales configurados",
      "admin_driver_pricing_title": "Tarifas para Conductores",
      "admin_driver_pricing_subtitle": "Gestiona las tarifas que se pagan a los conductores por sus servicios",
      "admin_driver_template_desc_basica": "Tarifa básica para conductores",
      "admin_driver_template_desc_premium": "Tarifa premium para conductores",
      "admin_driver_template_desc_jluis": "Tarifa premium + 10%",
      "admin_driver_template_basica": "Básica (tarifa estándar)",
      "admin_driver_template_premium": "Premium",
      "admin_driver_template_jluis": "JLUIS (premium +10%)",
      "admin_new_template": "Nueva Plantilla",
      "admin_view_rates": "Ver Tarifas",
      "admin_badge_high_end": "Alta gama",
      "admin_badge_standard": "Estándar",
      "admin_badge_premium_plus_10": "Premium +10%",
      "admin_how_tariff_system_works": "Cómo funciona el sistema de tarifas",
      "admin_basic_tariff_explanation": "Básica (tarifa estándar): tarifa habitual para la mayoría de servicios",
      "admin_premium_tariff_explanation": "Premium: Tarifa superior con mejores márgenes",
      "admin_jluis_tariff_explanation": "JLUIS (premium +10%): tarifa premium con un 10% adicional (calculada automáticamente)",
      "admin_tariff_assignment_explanation": "Al asignar un conductor a un servicio, el admin elige la tarifa que aplica",
      "admin_custom_tariff_explanation": "También se puede ingresar una tarifa personalizada para casos especiales",
      "admin_tariff_comparison_title": "Comparativa de Tarifas (Ejemplo: 500 km)",
      "admin_tariff_comparison_subtitle": "Precios aproximados para servicios de 500 km",
      "admin_standard_delivery": "Entrega estándar",
      "admin_superior_delivery": "Entrega superior",
      "admin_premium_plus_10_label": "Premium + 10%",
      "admin_pricing_disclaimer": "* Los precios exactos varían según la distancia y tipo de servicio",
      "admin_services_with": "Servicios con {{name}}",
      "admin_error_load_rates": "Error al cargar las tarifas",
      "admin_rates_for_template": "Tarifas - {{name}}",
      "admin_all_rates_configured_for_template": "Todas las tarifas configuradas para esta plantilla",
      "admin_range_km": "Rango (km)",
      "admin_rates_col_delivery": "Entrega",
      "admin_rates_col_bc": "B-C",
      "admin_rates_col_tradein": "Trade-In",
      "admin_rates_col_representation": "Representación",
      "admin_rates_col_actions": "Acciones",
      "admin_base_plus_per_km": "Base + adicional por km",
      "admin_rates_per_km_long_note": "Las tarifas con \"+ km\" aplican una tarifa base más un cargo por kilómetro adicional para distancias superiores a 1000 km.",
      "admin_distance_range_closed": "{{min}} - {{max}} km",
      "admin_distance_range_open": "{{min}}+ km",
      "admin_rates_plus_amount_per_km": "+ {{amount}}€/km",
      "admin_edit_rate_title": "Editar tarifa",
      "admin_edit_rate_range_caption": "Rango: {{range}}",
      "admin_edit_rate_per_km_heading": "Precios por km adicional (para 1001+ km):",
      "admin_rate_delivery_per_km": "Entrega por km (€)",
      "admin_rate_bc_per_km": "B-C por km (€)",
      "admin_rate_tradein_per_km": "Trade-In por km (€)",
      "admin_no_rates_for_template": "No hay tarifas configuradas para esta plantilla",
      "admin_create_new_pricing_template": "Crear Nueva Plantilla de Tarifas",
      "admin_new_template_intro": "La nueva plantilla se creará con las mismas tarifas que la plantilla «Básica» (tarifa estándar). Puedes editarlas después.",
      "admin_template_name_required": "Nombre de la Plantilla *",
      "admin_template_name_placeholder": "Ej: Premium Plus, Especial, etc.",
      "admin_template_description_placeholder": "Breve descripción de esta plantilla",
      "admin_note": "Nota:",
      "admin_new_template_note_body": "La nueva plantilla se creará automáticamente con 17 rangos de tarifas (basadas en la plantilla «Básica» (tarifa estándar)). Podrás editarlas individualmente después de crearla.",
      "admin_create_template": "Crear Plantilla",
      "admin_creating": "Creando...",
      "admin_modal_create_intro": "Complete los datos del servicio. Los campos marcados con * son obligatorios.",
      "admin_modal_client_optional_label": "Cliente (Opcional)",
      "admin_modal_no_client_admin": "Sin cliente (Admin)",
      "admin_modal_no_client_hint": "Si no seleccionas cliente, el servicio quedará asignado al admin",
      "admin_modal_datetime_range_title": "Rango de Fecha y Hora",
      "admin_modal_switch_to_range": "Cambiar a Rango",
      "admin_modal_switch_to_fixed": "Cambiar a Fecha Fija",
      "admin_modal_pickup_date_label": "Fecha de Recogida",
      "admin_modal_pickup_time_label": "Hora de Recogida",
      "admin_modal_pickup_time_from": "Hora de Recogida * - Desde",
      "admin_modal_pickup_time_to": "Hora de Recogida * - Hasta",
      "admin_modal_delivery_date_label": "Fecha de Entrega",
      "admin_modal_delivery_time_label": "Hora de Entrega",
      "admin_modal_delivery_time_from": "Hora de Entrega * - Desde",
      "admin_modal_delivery_time_to": "Hora de Entrega * - Hasta",
      "admin_optional_paren": "(Opcional)",
      "admin_modal_no_additional_services": "No hay servicios adicionales disponibles",
      "admin_modal_total_price_label": "PRECIO TOTAL:",
      "admin_modal_price_base_service": "Precio base del servicio:",
      "admin_modal_additional_services_sum": "Servicios adicionales:",
      "admin_modal_additional_selected_label": "Servicios adicionales seleccionados:",
      "admin_modal_assign_driver_heading": "Asignar Conductor (Opcional)",
      "admin_modal_driver_unassigned_placeholder": "Sin asignar (pendiente)",
      "admin_modal_driver_status_assigned": "Estado: Asignado (se enviará email al conductor)",
      "admin_modal_driver_status_pending": "Estado: Pendiente de asignación",
      "admin_modal_driver_rate_block_title": "Tarifa del Conductor (Cuánto le pagarás)",
      "admin_modal_driver_price_label": "Precio para el Conductor *",
      "admin_modal_driver_price_hint": "Establece cuánto le pagarás al conductor por este servicio",
      "admin_modal_pay_driver_short": "Pago al Conductor",
      "admin_modal_your_margin": "Tu Margen:",
      "admin_modal_margin_percent": "{{pct}}% de margen de ganancia",
      "admin_modal_payment_status_title": "Estado de Pago",
      "admin_modal_mark_paid_label": "Marcar como pagado",
      "admin_modal_payment_paid_hint": "✓ El servicio se creará con estado \"Pagado\"",
      "admin_modal_payment_pending_hint": "El servicio se creará con estado \"Pendiente de pago\"",
      "admin_modal_notes_additional": "Notas Adicionales",
      "admin_placeholder_contact_first_name": "Nombre",
      "admin_placeholder_brand_example": "Ej: Toyota",
      "admin_placeholder_model_example": "Ej: Corolla",
      "admin_service_history_title": "Historial del Servicio",
      "admin_history_delivered": "Entregado",
      "admin_history_completed_on": "Completado:",
      "admin_history_expenses_registered": "Gastos Registrados",
      "admin_history_total_label": "TOTAL:",
      "admin_history_submitted_by": "Registrado por:",
      "admin_history_contract_photos": "Fotos del Contrato",
      "admin_history_expense_photos": "Fotos de Gastos/Tickets",
      "admin_history_completion_notes": "Notas de Finalización",
      "admin_history_completed_by": "Completado por:",
      "admin_loading_order_expenses": "Cargando gastos...",
      "admin_expenses_registered_completion": "Gastos registrados al completar el servicio",
      "admin_expenses_by": "por {{name}}",
      "admin_expenses_on": "el {{date}}",
      "admin_expense_status_label": "Estado:",
      "admin_expense_status_approved": "Aprobado",
      "admin_expense_status_rejected": "Rechazado",
      "admin_expense_status_pending": "Pendiente de Aprobación",
      "admin_expense_reported": "Reportado:",
      "admin_expense_total_expenses": "Total Gastos:",
      "admin_expense_rejection_reason": "Motivo de rechazo:",
      "admin_expense_other_na": "N/A",
      "admin_expense_gas_label": "Gasolina:",
      "admin_expense_tolls_label": "Peajes:",
      "admin_expense_parking_label": "Parking:",
      "admin_expense_taxi_label": "Taxi:",
      "admin_expense_other_label_short": "Otros ({{desc}}):",
      "admin_expense_tickets_attached": "Tickets/Recibos Adjuntos ({{count}})",
      "admin_photo_source_admin": "(Admin)",
      "admin_photo_source_driver": "(Conductor)",
      "admin_photos_completion_notice": "Fotos subidas al completar el servicio",
      "admin_photos_dialog_caption_driver_admin": "Fotos del servicio (Conductor y/o Admin)",
      "admin_photo_pickup_alt": "Recogida {{n}}",
      "admin_photo_delivery_alt": "Entrega {{n}}",
      "admin_photo_contract_alt": "Contrato {{n}}",
      "admin_photo_expense_alt": "Gasto {{n}}",
      "admin_photo_ticket_label": "Ticket {{n}}",
      "admin_photo_contract_label": "Contrato {{n}}",
      "admin_dialog_order_vehicle_line": "Servicio #{{id}} — {{brand}} {{model}} ({{plate}})",
      "admin_photo_numbered": "Foto {{n}}",
      "admin_expense_click_enlarge": "Haz clic en la imagen para ampliarla",
      "admin_expense_click_enlarge_download": "Haz clic en la imagen para ampliarla o usa el botón \"{{download}}\"",
      "admin_expense_no_receipts": "No se adjuntaron recibos con este reporte",
      "admin_charge_espera": "Espera",
      "admin_charge_pit_stop": "Pit Stop",
      "admin_charge_itv": "ITV",
      "admin_charge_express": "Express",
      "admin_charge_recogida_extra": "Recogida Extra",
      "admin_charge_cambio_ruta": "Cambio de Ruta",
      "admin_charge_otros": "Otros",
      "admin_assign_rate": "Asignar Tarifa",
      "admin_assign_rate_dialog_title": "Asignar Tarifa a Cliente",
      "admin_assign_rate_dialog_desc": "Selecciona un cliente y la plantilla de tarifa que deseas asignarle",
      "admin_assign_rate_client_field": "Cliente *",
      "admin_assign_rate_template_field": "Plantilla de Tarifa *",
      "admin_assign_rate_option_general": "Tarifa General (Predeterminada)",
      "admin_assign_rate_replace_warning": "⚠️ Si el cliente ya tiene una tarifa asignada, esta será reemplazada.",
      "admin_create_new_template_singular": "Crear Nueva Plantilla de Tarifa",
      "admin_define_template_desc": "Define un nombre y descripción para la nueva plantilla de tarifas",
      "admin_template_placeholder_vip": "Ej: Tarifa VIP Madrid",
      "admin_template_description_optional": "Descripción (opcional)",
      "admin_template_placeholder_special": "Ej: Tarifa especial para clientes VIP en Madrid",
      "admin_no_custom_templates": "No hay plantillas personalizadas.",
      "admin_click_new_template_to_create": "Haz clic en \"Nueva Plantilla\" para crear una.",
      "admin_custom_pricing_clients_title": "Tarifas Personalizadas Clientes",
      "admin_custom_pricing_subtitle": "Gestiona plantillas de tarifas y asígnalas a clientes específicos",
      "admin_clients_and_assigned_rates": "Clientes y sus Tarifas Asignadas",
      "admin_clients_assigned_rates_description": "Todos los clientes registrados y la tarifa que están utilizando",
      "admin_no_clients_registered": "No hay clientes registrados",
      "admin_assigned_rate": "Tarifa Asignada",
      "admin_general_rate": "Tarifa General",
      "admin_custom_rate": "Tarifa Personalizada",
      "admin_change": "Cambiar",
      "admin_email_header": "Email",
      "admin_default_badge": "Predeterminada",
      "admin_standard_rate_default": "Tarifa estándar aplicada por defecto a todos los clientes",
      "admin_clients_count": "{{count}} clientes",
      "admin_available_rate_templates": "Plantillas de Tarifas Disponibles",
      "admin_manage_templates_assign_clients": "Gestiona las plantillas de tarifas que puedes asignar a los clientes",
      "admin_distance_ranges": "Rangos de Distancia",
      "admin_add_rate": "Agregar Tarifa",
      "admin_add_rate_to": "Agregar Tarifa a {{name}}",
      "admin_add_rate_dialog_desc": "Define un rango de distancia y los precios para cada tipo de servicio",
      "admin_price_delivery_eur": "Precio Entrega (€)",
      "admin_price_bc_eur": "Precio B-C (€)",
      "admin_price_tradein_eur": "Precio TRADE-IN (€)",
      "admin_price_representation_eur": "Precio Representación (€)",
      "admin_template_clidrive_name": "Tarifa Clidrive",
      "admin_template_clidrive_description": "Tarifas especiales para Clidrive",
      "admin_client_invoices_subtitle": "Gestiona y genera facturas para los servicios de clientes",
      "admin_client_invoice_period_card_title": "Período a facturar",
      "admin_client_period_services_included": "Servicios incluidos en este período",
      "admin_billing_period_no_services": "No hay servicios en este período",
      "admin_upload_client_invoice_title": "Subir factura de cliente",
      "admin_upload_client_invoice_desc": "Sube el PDF de la factura generada externamente (Holded u otro sistema).",
      "admin_upload_client_invoice_pdf_label": "Archivo PDF *",
      "admin_upload_client_invoice_number_label": "Número de factura *",
      "admin_upload_client_invoice_date_label": "Fecha de factura *",
      "admin_upload_client_invoice_submit": "Subir factura",
      "admin_no_documents_for_driver": "No hay documentos disponibles para este conductor.",
      "admin_generate_invoices": "Generar Facturas",
      "admin_current_period_in_progress": "Período actual – En curso",
      "admin_services_period": "Servicios: {{start}} - {{end}}",
      "admin_billing_expected": "Facturación prevista: {{start}} - {{end}}",
      "admin_no_services_pending_invoice": "No hay servicios pendientes de facturar",
      "admin_metric_clients": "Clientes",
      "admin_metric_services": "Servicios",
      "admin_taxable_base": "Base Imponible",
      "admin_total_with_vat": "Total con IVA",
      "admin_invoices_col_client": "CLIENTE",
      "admin_invoices_col_services": "SERVICIOS",
      "admin_invoices_col_base": "BASE",
      "admin_invoices_col_iva": "IVA (21%)",
      "admin_invoices_col_total": "TOTAL",
      "admin_invoices_col_actions": "ACCIONES",
      "admin_view_detail": "Ver Detalle",
      "admin_hide": "Ocultar",
      "admin_services_detail": "Detalle de Servicios",
      "admin_invoices_col_date": "FECHA",
      "admin_invoices_col_plate": "MATRÍCULA",
      "admin_service_id_col": "REF.",
      "admin_invoices_col_vehicle": "VEHÍCULO",
      "admin_invoices_col_type": "TIPO",
      "admin_invoices_col_extras": "EXTRAS",
      "admin_nif_label": "NIF",
      "admin_generate_client_invoices_title": "Generar Facturas de Clientes",
      "admin_generate_client_invoices_desc": "Genera las facturas para el período seleccionado. Solo se incluirán servicios entregados.",
      "admin_fortnight_type": "Tipo de Quincena",
      "admin_quincena_1_option": "Quincena 1 (Serv. 25-9 → Factura 10-15)",
      "admin_quincena_2_option": "Quincena 2 (Serv. 10-24 → Factura 25-último)",
      "admin_quincena_1_option_driver": "Quincena 1 (Serv. 25-9 → Pago 10-15)",
      "admin_quincena_2_option_driver": "Quincena 2 (Serv. 10-24 → Pago 25-último)",
      "admin_year": "Año",
      "admin_month_of_payment": "Mes (del pago)",
      "admin_period_summary": "Resumen del período:",
      "admin_services_period_short": "Servicios: {{range}}",
      "admin_billing_period_short": "Facturación: {{range}}",
      "admin_payment_period_short": "Pago: {{range}}",
      "admin_billing_25_end": "25-último",
      "admin_generating": "Generando...",
      "admin_driver_liquidations_title": "Liquidaciones Conductores",
      "admin_driver_liquidations_subtitle": "Gestiona los pagos y liquidaciones de conductores",
      "admin_generate_liquidations": "Generar Liquidaciones",
      "admin_generate_liquidations_desc": "Genera las liquidaciones para el período seleccionado. Solo se incluirán servicios con gastos aprobados.",
      "admin_generation_stopped": "Generación detenida",
      "admin_generation_stopped_reason": "No se generaron liquidaciones: {{reason}}",
      "admin_payment_periods": "Períodos de Pago",
      "admin_quincena_1_desc": "Quincena 1: Servicios del 25 al 9 → Pago del 10 al 15",
      "admin_quincena_2_desc": "Quincena 2: Servicios del 10 al 24 → Pago del 25 al último día",
      "admin_only_approved_expenses": "Solo se incluyen servicios con gastos aprobados",
      "admin_liquidation_calendar_split_hint": "A partir del día 25, la pestaña «En curso» muestra el período 25 → día 9 del mes siguiente, no la quincena 10–24 que acaba de cerrar. Esa quincena cerrada aparece en «Pendiente de facturar».",
      "admin_liquidation_unapproved_banner": "Hay {{count}} servicio(s) en estas fechas con conductor asignado, pero aún sin aprobación administrativa (no cuentan en liquidación hasta que estén «Aprobados»). Revísalos en Servicios → Pendientes de aprobación o en la ficha del servicio.",
      "admin_liquidation_banner_preview_line": "{{count}} servicio(s) completado(s) pendiente(s) de aprobación para liquidación: se muestran abajo como vista previa. Base orientativa €{{amount}} — excluida del total hasta aprobación.",
      "admin_liquidation_preview_section_title": "Vista previa — pendiente de aprobación para liquidación",
      "admin_liquidation_preview_section_note": "Estos viajes ya están completados o entregados, pero aún no cuentan en la liquidación oficial hasta que apruebes el cierre en la ficha del servicio. Los importes de esta tabla son orientativos (base conductor); no incluyen IVA, IRPF ni el desglose final.",
      "admin_liquidation_preview_col_settlement": "Liquidación",
      "admin_liquidation_row_preview_only_badge": "Solo vista previa",
      "admin_liquidation_generate_disabled_until_approved": "No se pueden generar liquidaciones mientras el total aprobado sea 0: primero aprueba los cierres de servicio.",
      "admin_settlement_chip_tooltip": "Estado para liquidación al conductor (approval_status)",
      "admin_settlement_chip_ok": "Liq. ✓",
      "admin_settlement_chip_need_approval": "Aprobar liq.",
      "admin_settlement_chip_rejected": "Liq. ✕",
      "admin_settlement_chip_open": "Sin aprobar",
      "admin_pending_expense_approval_count": "{{count}} servicio(s) completado(s) pendiente(s) de aprobación administrativa del pedido (no cuenta los informes de gastos de la lista inferior)",
      "admin_pending_expense_reports": "Reportes de Gastos Pendientes ({{count}})",
      "admin_approve_reject_expenses_desc": "Aprueba o rechaza los gastos reportados por conductores",
      "admin_no_pending_reports": "No hay reportes pendientes de aprobación",
      "admin_billing_periods_title": "Períodos de Facturación",
      "admin_billing_periods_subtitle": "Liquidaciones agrupadas por período de pago",
      "admin_loading_periods": "Cargando períodos...",
      "admin_in_progress": "En curso",
      "admin_invoice_pending": "Factura pendiente",
      "admin_period_closed_ready_to_bill": "Período cerrado, listo para facturar",
      "admin_period_closed_generate_message": "Este período ha cerrado. Genera las liquidaciones para procesar los pagos a conductores.",
      "admin_generate_settlements_first": "Genera primero las liquidaciones para este período",
      "admin_billing_details": "Datos de facturación",
      "admin_save_billing_data": "Guardar Datos",
      "admin_realtime_accumulation": "Acumulación en Tiempo Real",
      "admin_expected_payment": "Pago previsto",
      "admin_services_count_label": "servicios",
      "admin_total_accumulated": "total acumulado",
      "admin_accumulating_status": "Acumulando",
      "admin_liquidation_fleet_owner_badge": "Flotista ({{count}})",
      "admin_tab_pending_to_bill": "Pendiente facturar",
      "admin_liquidation_status_paid": "Pagada",
      "admin_liquidation_status_pending": "Pendiente",
      "admin_pending_period_banner_title": "{{label}} - Período cerrado, listo para facturar",
      "admin_total_to_liquidate_label": "total a liquidar",
      "admin_no_pending_invoice_services": "No hay servicios pendientes de facturar",
      "admin_confirm_invoice_regenerate": "Ya existe una factura. ¿Regenerar con los datos actualizados?",
      "admin_confirm_invoice_regenerate_detail": "Se generará de nuevo el PDF con los datos actuales del periodo y reemplazará la factura guardada.",
      "admin_invoice_regenerate_confirm_btn": "Regenerar",
      "admin_services_detail_count": "Detalle de Servicios ({{count}})",
      "admin_route_col": "TRAYECTO",
      "admin_rate_col": "TARIFA",
      "admin_totals_label": "Totales:",
      "admin_liquidation_footer_drivers": "{{count}} conductor(es) en este período",
      "admin_liquidation_footer_total_base": "Total Base:",
      "admin_liquidation_footer_total_supplies": "Total Suplidos:",
      "admin_liquidation_footer_total_to_pay": "Total a Pagar:",
      "admin_amounts_update_note": "Los montos se actualizan conforme se aprueban gastos. La liquidación se genera al cerrar el período.",
      "admin_liquidated": "LIQUIDADO",
      "admin_driver_col": "CONDUCTOR",
      "admin_supplies_col": "SUPLIDOS",
      "admin_irpf_col": "IRPF",
      "admin_status_col": "ESTADO",
      "admin_no_drivers_match": "No se encontraron conductores con ese nombre",
      "admin_no_approved_pending_liquidation": "No hay servicios aprobados pendientes de liquidar",
      "admin_no_drivers_in_period": "No hay conductores en este período",
      "admin_reported_label": "Reportado",
      "admin_expense_driver": "Conductor",
      "admin_expense_fuel": "Gasolina",
      "admin_expense_toll": "Peajes",
      "admin_expense_parking": "Parking",
      "admin_expense_taxi": "Taxi",
      "admin_expense_other": "Otros",
      "admin_other_expenses_label": "Otros gastos:",
      "admin_tickets_receipts": "Tickets y Recibos ({{count}})",
      "admin_ticket_label": "Ticket",
      "admin_approve_btn": "Aprobar",
      "admin_reject_btn": "Rechazar",
      "admin_reject_reason_prompt": "Razón del rechazo:",
      "admin_hide_services": "Ocultar servicios",
      "admin_view_services": "Ver servicios",
      "admin_payment_label": "Pago",
      "admin_approvals_subtitle": "Revisa y aprueba los servicios completados por conductores",
      "admin_services_pending_approval_title": "Servicios Pendientes de Aprobación",
      "admin_services_pending_approval_desc": "Servicios que han sido completados y esperan aprobación",
      "admin_no_services_pending_approval": "No hay servicios pendientes de aprobación",
      "admin_vehicle_label": "Vehículo",
      "admin_origin_label": "Origen",
      "admin_destination_label": "Destino",
      "admin_total_price_label": "Precio Total",
      "admin_service_status_label": "Estado del Servicio",
      "admin_service_type_label": "Tipo de Servicio",
      "admin_pending_approval_badge": "Pendiente Aprobación",
      "admin_photos_pickup_label": "Fotos Recogida",
      "admin_photos_delivery_label": "Fotos Entrega",
      "admin_expenses_label": "Gastos",
      "admin_view_photos_btn": "Ver Fotos",
      "admin_profiles_title": "Perfiles",
      "admin_profiles_subtitle": "Visualiza y gestiona los perfiles de clientes y conductores",
      "admin_profiles_subtitle_drivers_only": "Visualiza y gestiona los perfiles de tus conductores asignados",
      "admin_profiles_clients_tab": "Perfiles de Clientes",
      "admin_profiles_drivers_tab": "Perfiles de Conductores",
      "admin_profiles_fleets_tab": "Gestión de Flotas",
      "admin_clients_registered": "Clientes Registrados",
      "admin_create_client": "Crear Cliente",
      "admin_create_new_client": "Crear Nuevo Cliente",
      "admin_create_new_client_desc": "Crea un nuevo cliente. Se generará una contraseña automáticamente y se enviará por email.",
      "admin_create_client_password_info": "Se generará una contraseña aleatoria y se enviará al email del cliente junto con sus credenciales de acceso.",
      "admin_search_client_placeholder": "Buscar por nombre, DNI/NIF/CIF/NIE o email...",
      "admin_no_clients_search": "No se encontraron clientes con ese criterio de búsqueda",
      "admin_no_clients_registered": "No hay clientes registrados",
      "admin_cif_dni_label": "CIF/DNI:",
      "admin_phone_label": "Teléfono:",
      "admin_address_label": "Dirección:",
      "admin_country_label": "País:",
      "admin_registered_label": "Registrado:",
      "admin_rate_label": "Tarifa:",
      "admin_not_specified": "No especificado",
      "admin_not_specified_f": "No especificada",
      "admin_view_details": "Ver Detalles",
      "admin_search_driver_profiles_placeholder": "Buscar por nombre, DNI/NIE, licencia o email...",
      "admin_no_drivers_search": "No se encontraron conductores con ese criterio de búsqueda",
      "admin_no_drivers_registered": "No hay conductores registrados",
      "admin_driver_dni_label": "DNI/NIF:",
      "admin_driver_status_label": "Estado:",
      "admin_available": "Disponible",
      "admin_not_available": "No disponible",
      "admin_edit": "Editar",
      "admin_view_more": "Ver más",
      "admin_driver_badge_validated": "✓ Validado",
      "admin_driver_badge_pending": "⏳ Pendiente",
      "admin_driver_badge_expires_soon": "⚠️ Vence Pronto",
      "admin_driver_badge_no_docs": "❌ Sin Documentos",
      "admin_edit_client": "Editar Cliente",
      "admin_edit_client_desc": "Modifica la información del cliente. El admin puede editar todo, incluyendo el email.",
      "admin_company_logo": "Logo de la Empresa",
      "admin_upload_logo": "Subir Logo",
      "admin_uploading": "Subiendo...",
      "admin_logo_hint": "PNG, JPG • Max 2MB",
      "admin_name_required": "Nombre *",
      "admin_email_required": "Email *",
      "admin_email_change_warning": "Cambiar el email afectará el acceso del cliente",
      "admin_company_name": "Nombre de Empresa",
      "admin_cif_dni": "CIF/DNI",
      "admin_phone": "Teléfono",
      "admin_country": "País",
      "admin_address": "Dirección",
      "admin_country_placeholder": "ES, FR, etc.",
      "admin_payment_type": "Tipo de Pago",
      "admin_payment_biweekly": "Quincenal (Transferencia)",
      "admin_payment_instant": "Pago Instantáneo (TPV Virtual)",
      "admin_payment_biweekly_desc": "Se factura cada 15 días y se paga por transferencia bancaria",
      "admin_payment_instant_desc": "Se cobra al momento al crear o editar servicios vía TPV Virtual Santander",
      "admin_save_changes": "Guardar Cambios",
      "admin_documents_drivers_title": "Documentos Conductores",
      "admin_documents_subtitle": "Revisa y valida los documentos subidos por conductores",
      "admin_documents_pending_expired_title": "Documentos Pendientes y Vencidos",
      "admin_documents_require_attention": "Total: {{count}} documentos requieren atención",
      "admin_no_documents_pending": "No hay documentos pendientes de validación",
      "admin_doc_confirm_approve_title": "¿Aprobar este documento?",
      "admin_doc_confirm_approve_description": "Quedará marcado como validado.",
      "admin_doc_confirm_reject_title": "¿Rechazar este documento?",
      "admin_doc_confirm_reject_description": "El conductor recibirá una notificación. Indica el motivo del rechazo.",
      "admin_doc_reject_reason_placeholder": "Explica el motivo del rechazo…",
      "admin_doc_reject_reason_required": "Indica el motivo del rechazo.",
      "admin_document_label": "Documento:",
      "admin_upload_date_label": "Fecha de subida:",
      "admin_expiry_date_label": "Fecha de vencimiento:",
      "admin_status_label": "Estado:",
      "admin_status_expired": "⚠️ Vencido",
      "driver_name_label": "Nombre",
      "driver_phone_label": "Teléfono",
      "driver_not_specified": "No especificado",
      "driver_type_label": "Tipo",
      "driver_fleet_member": "Miembro de Flota",
      "driver_independent": "Conductor Independiente",
      "driver_doc_status": "Estado de Documentos",
      "driver_docs_loading": "Cargando documentos...",
      "driver_documents": "Documentos",
      "driver_view": "Ver",
      "driver_download": "Descargar",
      "driver_preview_title": "Vista Previa",
      "driver_view_doc_tooltip": "Ver documento en nueva pestaña",
      "driver_download_doc_tooltip": "Descargar documento",
      "driver_delete_doc_tooltip": "Eliminar documento",
      "driver_expires": "Vence:",
      "driver_bank_account": "Cuenta Bancaria",
      "driver_tax_id": "NIF/CIF",

      // Messages
      "order_created": "¡Servicio creado exitosamente!",
      "order_updated": "¡Servicio actualizado exitosamente!",
      "payment_success": "¡Pago completado exitosamente!",
      "payment_failed": "Pago fallido. Por favor intenta nuevamente.",
      "error_occurred": "Ocurrió un error. Por favor intenta nuevamente.",
      "auth_callback_no_session_id": "No se encontró ID de sesión",
      "address_toast_selected": "✓ Dirección seleccionada correctamente",
      "address_toast_no_coords": "No se pudieron obtener las coordenadas de esta dirección",
      "address_toast_init_error": "Error al inicializar autocompletado. Usa los botones de ciudad.",
      "address_toast_city_selected": "✓ Ciudad seleccionada: {{city}}",
      "address_toast_coords_set": "✓ Coordenadas establecidas correctamente",
      "address_toast_invalid_coords": "Coordenadas inválidas. Lat: -90 a 90, Lng: -180 a 180",
      "address_toast_coords_extracted": "✓ Coordenadas extraídas del enlace de Google Maps",
      "address_toast_coords_extract_error": "No se pudieron extraer coordenadas del enlace",
      "address_toast_select_suggestions": "Por favor selecciona una dirección de las sugerencias",
      "address_toast_error_get_details": "Error al obtener detalles de la dirección",
      "forgot_toast_success": "Se ha enviado un enlace de recuperación a tu correo",
      "forgot_toast_error": "Error al procesar tu solicitud",
      "forgot_toast_error_send": "Error al enviar el correo",
      "forgot_toast_email_not_sent": "Si tu correo está registrado, no pudimos enviar el email. Contacta con soporte.",
      "forgot_network_error": "Error de red",
      "forgot_title": "Recuperar Contraseña",
      "forgot_description": "Ingresa tu correo electrónico y te enviaremos instrucciones",
      "forgot_email_label": "Correo Electrónico",
      "forgot_email_placeholder": "tu@email.com",
      "forgot_sending": "Enviando...",
      "forgot_submit": "Enviar Enlace de Recuperación",
      "forgot_back_login": "Volver al inicio de sesión",
      "change_password_mismatch": "Las contraseñas no coinciden",
      "change_password_min_length": "La contraseña debe tener al menos 6 caracteres",
      "change_password_success": "Contraseña actualizada correctamente",
      "change_password_error": "Error al cambiar la contraseña",
      "change_password_description": "Por favor, establece una nueva contraseña segura",
      "change_password_first_login_description": "Es tu primer acceso: elige una nueva contraseña segura. No hace falta repetir la contraseña con la que acabas de entrar.",
      "change_password_current_required": "Introduce tu contraseña actual",
      "change_password_btn": "Actualizar Contraseña",
      "change_password_updating": "Actualizando...",
      "show_password": "Mostrar contraseña",
      "hide_password": "Ocultar contraseña",
      "admin_login_toast_success": "¡Acceso correcto!",
      "admin_login_toast_error": "Email o contraseña incorrectos",
      "admin_back_to_home": "Volver al inicio",
      "admin_sign_in": "Iniciar sesión",
      "admin_signing_in": "Iniciando sesión...",
      "staff_portal_title": "Iniciar sesión",
      "staff_portal_subtitle": "Elige acceso como conductor o administrador",
      "staff_portal_tab_driver": "Conductor",
      "staff_portal_tab_admin": "Administrador",
      "staff_portal_admin_banner": "Portal de administración",
      "staff_portal_admin_desc": "Gestiona el servicio de transporte",
      "client_login_welcome": "¡Bienvenido!",
      "client_login_error": "Error al iniciar sesión",
      "client_toast_no_session": "No hay sesión activa. Por favor, inicia sesión nuevamente.",
      "client_toast_preparing_contract": "Preparando contrato...",
      "client_toast_contract_generated": "Contrato generado. Si no se descarga automáticamente, verifica el bloqueador de ventanas emergentes.",
      "client_toast_error_download_contract": "Error al descargar el contrato",
      "client_toast_error_load_invoices": "Error al cargar facturas",
      "client_toast_photos_pending_approval": "Las fotos están pendientes de aprobación del administrador",
      "client_toast_photos_not_available": "Las fotos aún no están disponibles",
      "client_toast_no_photos_yet": "No hay fotos disponibles todavía",
      "client_toast_error_load_photos": "Error al cargar las fotos",
      "client_toast_no_expenses_yet": "No hay gastos aprobados todavía",
      "client_toast_error_load_expenses": "Error al cargar los gastos",
      "client_toast_error_load_completion": "Error al cargar los detalles de finalización",
      "client_incident_fetch_failed": "No se pudo cargar la información",
      "client_incident_fetch_error": "Error al cargar",
      "client_validation_bc_second_vehicle": "Para servicios B-C es obligatorio añadir los datos del segundo vehículo (marca y matrícula)",
      "client_validation_bc_point_c": "Para servicios B-C es obligatorio añadir la dirección de entrega del segundo vehículo (Punto C)",
      "client_validation_bc_point_c_contact": "Para servicios B-C es obligatorio añadir los datos de contacto del Punto C",
      "client_validation_tradein_second_vehicle": "Para servicios Trade-in es obligatorio añadir los datos del segundo vehículo",
      "client_order_created_at_label": "Fecha de creación:",
      "client_incident_badge": "Incidencia",
      "client_incident_title_hint": "Haz clic para ver detalles de la incidencia",
      "client_incident_loading_details": "Cargando detalles...",
      "client_incident_type_fallback": "Incidencia reportada",
      "client_incident_reported_label": "Reportada:",
      "client_incident_resolved_label": "Resuelta:",
      "client_incident_resolution_label": "Resolución:",
      "client_incident_resolution_cancelled_at_pickup": "Servicio cancelado en recogida",
      "client_incident_resolution_cancelled": "Servicio cancelado",
      "client_incident_resolution_delivered": "Servicio completado",
      "client_incident_generic_notice": "Este servicio tuvo una incidencia asociada. El administrador fue notificado.",
      "client_sidebar_subtitle": "Panel de Cliente",
      "client_sidebar_section_general": "General",
      "client_sidebar_section_tracking": "Seguimiento",
      "client_sidebar_section_account": "Cuenta",
      "client_sidebar_dashboard": "Dashboard",
      "client_loading_services": "Cargando servicios...",
      "client_deliveries_tracking_subtitle": "Seguimiento de tus transportes de vehículos",
      "client_deliv_status_sin_reservar_label": "Sin Reservar",
      "client_deliv_status_sin_reservar_desc": "Esperando que un conductor acepte el servicio",
      "client_deliv_status_reservado_label": "Reservado",
      "client_deliv_status_reservado_desc": "Un conductor ha aceptado el servicio",
      "client_deliv_status_en_proceso_label": "En Proceso",
      "client_deliv_status_en_proceso_desc": "El vehículo está siendo transportado",
      "client_deliv_status_entregado_label": "Entregado",
      "client_deliv_status_entregado_desc": "Servicio completado",
      "client_deliv_status_cancelado_label": "Cancelado",
      "client_deliv_status_cancelado_desc": "Servicio cancelado",
      "client_date_not_specified": "No especificada",
      "client_plate_missing": "Sin matrícula",
      "client_deliveries_showing": "Mostrando:",
      "client_deliveries_empty_title": "No hay servicios",
      "client_deliveries_empty_filtered": "No tienes servicios con estado \"{{status}}\"",
      "client_deliveries_empty_hint": "Tus servicios de transporte aparecerán aquí",
      "client_deliv_view_tracking": "Ver seguimiento",
      "client_deliv_assigned_driver": "Conductor asignado",
      "client_deliv_distance_prefix": "Distancia",
      "client_deliv_notes_heading": "Notas",
      "client_deliv_payment_status_label": "Estado del pago",
      "client_inspections_modal_title": "Peritaje",
      "client_inspections_photo_fallback": "Foto",
      "client_inspections_signature_title": "Firma del Responsable",
      "client_inspections_signature_alt": "Firma",
      "client_inspections_done_by": "Realizado por:",
      "client_inspections_fuel": "Combustible",
      "client_inspections_type_pickup": "Recogida",
      "client_inspections_type_delivery": "Entrega",
      "client_loading_inspections": "Cargando peritajes...",
      "client_inspections_title": "Peritajes de Vehículos",
      "client_inspections_subtitle": "Informes de inspección de tus vehículos transportados",
      "client_inspections_search_placeholder": "Buscar por matrícula...",
      "client_inspections_stat_total": "Total Peritajes",
      "client_inspections_stat_no_damage": "Sin Daños",
      "client_inspections_stat_with_damage": "Con Daños",
      "client_inspections_badge_pickup": "Peritaje Recogida",
      "client_inspections_badge_delivery": "Peritaje Entrega",
      "client_inspections_status_delivered": "Entregado",
      "client_inspections_status_in_progress": "En Proceso",
      "client_inspections_view_btn": "Ver Peritaje",
      "client_inspections_empty_title": "No hay peritajes",
      "client_inspections_empty_search": "No se encontraron resultados para tu búsqueda",
      "client_inspections_empty_hint": "Los informes de peritación aparecerán aquí cuando los conductores los realicen",
      "client_inspections_vehicle_photos": "Fotos del Vehículo ({{count}})",
      "client_inspections_photo_alt": "Foto {{n}}",
      "client_inspections_thumbnail_alt": "Miniatura {{n}}",
      "client_inspections_photo_prev_aria": "Foto anterior",
      "client_inspections_photo_next_aria": "Foto siguiente",
      "client_inspections_ai_label": "Análisis IA:",
      "client_inspections_ai_summary_title": "Resumen del Análisis",
      "client_inspections_vehicle_state": "Estado del Vehículo",
      "client_inspections_damages_detected": "Daños detectados:",
      "client_inspections_no_damage_ai": "✓ Sin daños detectados",
      "client_inspections_odometer": "Odómetro",
      "client_inspections_general_condition": "Condición General",
      "client_gps_loading_vehicles": "Cargando vehículos en ruta...",
      "client_gps_subtitle": "Monitorea tus vehículos en tránsito en tiempo real",
      "client_gps_on_route_count": "{{count}} en ruta",
      "client_gps_last_update": "Última actualización:",
      "client_gps_auto_refresh": "(Auto-refresh cada 30s)",
      "client_gps_map_title": "Mapa de Vehículos",
      "client_gps_vehicles_on_route": "{{count}} vehículo en ruta",
      "client_gps_vehicles_on_route_plural": "{{count}} vehículos en ruta",
      "client_gps_loading_map": "Cargando mapa...",
      "client_gps_empty_title": "No hay vehículos en ruta actualmente",
      "client_gps_empty_hint": "Cuando un conductor inicie un transporte, aparecerá en el mapa",
      "client_gps_legend_vehicle": "Vehículo en ruta",
      "client_gps_legend_click": "Haz clic en un vehículo para ver su ubicación exacta",
      "client_gps_card_en_route": "En Ruta",
      "client_gps_route_origin": "Origen",
      "client_gps_route_destination": "Destino",
      "client_gps_eta_label": "ETA para destino:",
      "client_gps_eta_calculating": "Calculando ETA...",
      "client_gps_last_position": "Última posición:",
      "client_gps_detail_suffix": "Detalle",
      "client_gps_call_driver": "Llamar al conductor",
      "client_gps_label_vehicle": "Vehículo",
      "client_gps_label_driver": "Conductor",
      "client_gps_label_origin": "Origen",
      "client_gps_label_destination": "Destino",
      "client_gps_label_current_location": "Ubicación Actual",
      "client_gps_infowindow_current_location": "Ubicación actual:",
      "client_gps_infowindow_destination": "Destino:",
      "client_gps_infowindow_eta_title": "ETA para destino",
      "client_gps_infowindow_eta_remaining": "restantes",
      "client_gps_infowindow_eta_calculating": "Calculando ETA...",
      "client_gps_infowindow_driver": "Conductor:",
      "client_na": "N/A",
      "driver_doc_upload_click_to_select": "Haz clic para seleccionar un archivo",
      "driver_doc_upload_formats_hint": "PDF, JPG o PNG (máx. 10MB)",
      "driver_doc_upload_pending_note": "Este documento reemplazará el anterior y quedará pendiente de aprobación.",
      "client_toast_distance_calculated": "Distancia calculada: {{distance}} km - Precio: €{{price}}",
      "client_toast_error_calculate_distance": "Error al calcular la distancia",
      "client_toast_service_cancelled_fee": "Servicio cancelado: {{status}}. Cargo: €{{fee}}",
      "client_toast_error_cancel_service": "Error al cancelar el servicio",
      "client_toast_price_updated": "Precio actualizado",
      "client_toast_error_calculate_price": "Error al calcular el precio",
      "client_toast_enter_valid_distance": "Introduce una distancia válida",
      "client_completion_waiting_extras": "Tiempo de espera / Extras",
      "client_completion_extras_total": "Total extras (sin IVA)",
      "service_toast_load_failed": "No se pudo cargar el servicio",
      "service_toast_error_load": "Error al cargar el servicio",
      "service_toast_updated": "Servicio actualizado correctamente",
      "service_toast_error_update": "Error al actualizar",
      "service_toast_error_update_service": "Error al actualizar el servicio",
      "service_toast_error_upload_file": "Error al subir {{fileName}}",
      "service_toast_photos_uploaded": "{{count}} foto(s) subida(s)",
      "service_toast_error_upload_photos": "Error al subir las fotos",
      "service_toast_completed": "Servicio completado correctamente",
      "service_toast_error_complete": "Error al completar",
      "service_toast_error_complete_service": "Error al completar el servicio",
      "service_toast_reverted": "Servicio revertido correctamente",
      "service_toast_error_revert": "Error al revertir",
      "service_toast_error_revert_service": "Error al revertir el servicio",
      "service_toast_deleted": "Servicio eliminado",
      "service_toast_error_delete": "Error al eliminar",
      "service_toast_error_delete_service": "Error al eliminar el servicio",
      "service_toast_cancelled": "Servicio cancelado",
      "service_toast_error_cancel": "Error al cancelar",
      "service_toast_error_cancel_service": "Error al cancelar el servicio",
      "service_toast_contract_downloaded": "Contrato descargado",
      "service_toast_contract_fallback_simple_pdf": "El PDF se generó en modo simplificado (Playwright no pudo renderizar). Windows: en la carpeta backend ejecuta «python run_dev_api.py» (no uses solo uvicorn --reload). Linux/servidor: python -m playwright install chromium",
      "service_toast_error_generate_contract": "Error al generar el contrato",
      "service_toast_error_download_contract": "Error al descargar el contrato",
      "service_toast_opening_calendar": "Abriendo Google Calendar...",
      "service_detail_loading": "Cargando servicio...",
      "service_detail_back": "Volver",
      "service_detail_title": "Servicio #{{id}}",
      "service_detail_print": "Imprimir",
      "service_detail_price_client_short": "Precio cliente",
      "service_detail_price_driver_short": "Precio conductor",
      "service_detail_vehicle_heading": "VEHÍCULO",
      "service_detail_type": "Tipo",
      "service_detail_fuel_default": "Gasolina",
      "service_detail_documents_heading": "DOCUMENTOS",
      "service_detail_download_transport_contract": "Descargar contrato de transporte",
      "service_detail_assign_driver_for_contract": "Asigna un conductor para generar el contrato",
      "service_detail_photos_heading": "FOTOS",
      "service_detail_view_service_photos": "Ver fotos del servicio",
      "service_detail_actions_heading": "Acciones",
      "service_detail_edit_service": "Editar servicio",
      "service_detail_complete_service": "Completar servicio",
      "service_detail_revert_to_in_progress": "Revertir a en proceso",
      "service_detail_add_to_calendar": "Añadir a calendario",
      "service_detail_cancel_service": "Cancelar servicio",
      "service_detail_edit_dialog_title": "Editar servicio",
      "service_detail_label_status": "Estado",
      "service_detail_label_driver": "Conductor",
      "service_detail_no_driver_option": "Sin asignar",
      "service_detail_label_distance_km": "Distancia (km)",
      "service_detail_label_client_price_eur": "Precio cliente (€)",
      "service_detail_label_driver_price_eur": "Precio conductor (€)",
      "service_detail_label_pickup_address": "Dirección recogida",
      "service_detail_label_delivery_address": "Dirección entrega",
      "service_detail_label_notes": "Notas",
      "service_detail_complete_dialog_title": "Completar servicio",
      "service_detail_complete_dialog_desc": "Añade los gastos y fotos para completar el servicio",
      "service_detail_expenses_heading": "Gastos",
      "service_detail_label_parking": "Aparcamiento (€)",
      "service_detail_label_completion_notes": "Notas de finalización",
      "service_detail_photos_section": "Fotos",
      "service_detail_label_pickup_photos_count": "Fotos recogida ({{count}})",
      "service_detail_label_delivery_photos_count": "Fotos entrega ({{count}})",
      "service_detail_label_expense_tickets_count": "Tickets gastos ({{count}})",
      "service_detail_label_signed_contract_count": "Contrato firmado ({{count}})",
      "service_detail_cancel_dialog_title": "Cancelar servicio",
      "service_detail_cancel_dialog_desc": "Selecciona el tipo de cancelación",
      "service_detail_cancel_normal": "Cancelación normal",
      "service_detail_cancel_at_pickup": "Cancelar en salida (vehículo no disponible)",
      "service_detail_cancel_in_transit": "Cancelar en transporte",
      "service_detail_close": "Cerrar",
      "service_detail_photos_dialog_title": "Fotos del servicio",
      "service_detail_loading_photos": "Cargando fotos...",
      "service_detail_pickup_photos_heading": "Fotos de recogida",
      "service_detail_delivery_photos_heading": "Fotos de entrega",
      "service_detail_no_photos": "No hay fotos disponibles",
      "service_detail_contact": "Contacto:",
      "service_detail_pickup_otp_whatsapp": "Código de confirmación recogida (mismo envío WhatsApp al contacto)",
      "service_detail_delivery_otp_whatsapp": "Código de confirmación entrega (WhatsApp)",
      "service_calendar_event_body": "Servicio AutoGo\nVehículo: {{brand}} {{model}} ({{plate}})\nConductor: {{driver}}\n\n📍 Recogida: {{pickup}}\n📍 Entrega: {{delivery}}",
      "driver_complete_dialog_title": "Completar servicio #{{id}}",
      "driver_complete_status_done": "Completado",
      "driver_complete_section_pickup": "📦 Fotos de recogida",
      "driver_complete_section_delivery": "🎯 Fotos de entrega",
      "driver_complete_section_contract": "📝 Contrato firmado",
      "driver_complete_section_expenses": "💰 Reporte de gastos",
      "driver_complete_pickup_hint": "Sube fotos del vehículo en el momento de la recogida (exterior e interior)",
      "driver_complete_delivery_hint": "Sube fotos del vehículo en el momento de la entrega (exterior e interior)",
      "driver_complete_contract_hint": "Sube foto(s) del contrato de transporte firmado por el cliente",
      "driver_complete_photo_count": "{{count}} foto(s)",
      "driver_complete_pickup_done": "✓ Fotos de recogida ya subidas",
      "driver_complete_delivery_done": "✓ Fotos de entrega ya subidas",
      "driver_complete_contract_done": "✓ Contrato ya subido",
      "driver_complete_expense_intro": "Reporta los gastos del servicio (puedes poner 0 si no hubo gastos)",
      "driver_expense_parking": "Parking (€)",
      "driver_expense_taxi": "Taxi (€)",
      "driver_expense_other_label": "Otros (€)",
      "driver_expense_other_description": "Descripción otros",
      "driver_complete_receipt_photos_label": "📸 Fotos de facturas/tickets (opcional)",
      "driver_complete_invoice_count": "{{count}} factura(s)",
      "driver_complete_expense_done": "✓ Reporte de gastos ya enviado",
      "driver_complete_service_status_title": "Estado del servicio:",
      "driver_complete_summary_pickup": "Fotos de recogida",
      "driver_complete_summary_delivery": "Fotos de entrega",
      "driver_complete_summary_contract": "Contrato firmado",
      "driver_complete_summary_expenses": "Reporte de gastos",
      "driver_complete_finish": "✓ Finalizar",
      "driver_complete_section_batch_hint": "Se subirá cuando pulses «Subir todo» abajo.",
      "driver_complete_contract_optional_batch": "Opcional para el envío a revisión; añádelo si ya tienes el contrato.",
      "driver_complete_extra_docs_batch_hint": "Opcional. También se incluyen en «Subir todo».",
      "driver_complete_submit_all": "Subir todo y enviar",
      "driver_complete_submit_all_desc": "Rellena lo que falte en cada bloque y pulsa una sola vez: se suben fotos, gastos y documentos extra en orden.",
      "driver_complete_submitting_all": "Subiendo todo…",
      "driver_complete_validation_pickup": "Añade al menos una foto de recogida.",
      "driver_complete_validation_delivery": "Añade al menos una foto de entrega.",
      "driver_complete_validation_other_desc": "Si «Otros gastos» es mayor que 0, describe el concepto.",
      "driver_complete_nothing_to_upload": "No hay nada nuevo que subir. Añade archivos o revisa el resumen.",
      "driver_complete_all_uploaded_ok": "Todo enviado correctamente. El servicio queda pendiente de revisión si aplica.",
      "driver_complete_batch_failed": "No se pudo completar la subida. Revisa la conexión e inténtalo de nuevo.",
      "driver_complete_locked": "Este servicio ya está cerrado o aprobado.",
      "driver_download_contract": "Descargar contrato",
      "driver_fleet_assign_service": "Asignar servicio",
      "driver_fleet_reassign_service": "Reasignar servicio",
      "driver_fleet_assign_desc": "Selecciona quién realizará este servicio. Se enviará un email automático con el contrato.",
      "driver_fleet_service_block_title": "Servicio:",
      "driver_fleet_current_assignee": "Actualmente asignado a:",
      "driver_toast_contract_downloaded": "Contrato descargado correctamente",
      "driver_toast_error_download_contract": "Error al descargar el contrato",
      "driver_toast_error_load_drivers": "Error al cargar choferes",
      "driver_toast_driver_created": "Chofer creado. Documentos pendientes de aprobación por admin.",
      "driver_toast_driver_created_with_password": "Chofer creado correctamente. ⚠️ Contraseña temporal: {{temp_password}}. Por favor, comunícasela al conductor.",
      "driver_toast_error_create_driver": "Error al crear chofer: {{message}}",
      "driver_error_create_driver_fallback": "Error al crear chofer",
      "driver_toast_driver_updated": "Chofer actualizado correctamente",
      "driver_toast_error_update_driver": "Error al actualizar chofer",
      "driver_toast_driver_deleted": "Chofer eliminado correctamente",
      "driver_toast_error_delete_driver": "Error al eliminar chofer",
      "driver_toast_service_assigned_self": "Servicio asignado a ti mismo.",
      "driver_toast_service_reassigned": "Servicio reasignado correctamente. Email enviado.",
      "driver_toast_service_assigned": "Servicio asignado correctamente. Email enviado.",
      "driver_toast_service_started": "Servicio iniciado",
      "driver_toast_error_assign_service": "Error al asignar servicio",
      "driver_toast_logged_out": "Sesión cerrada",
      "driver_toast_error_load_billing_periods": "Error al cargar periodos de facturación",
      "driver_toast_error_load_period_details": "Error al cargar detalles del período",
      "driver_toast_error_load_incomplete_services": "Error al cargar servicios incompletos",
      "driver_toast_complete_required_fields": "Por favor completa todos los campos obligatorios",
      "driver_toast_profile_updated": "Perfil actualizado exitosamente",
      "driver_toast_new_iban_next_invoice": "El nuevo número de cuenta se utilizará en tu próxima factura",
      "driver_toast_error_update_profile": "Error al actualizar perfil",
      "driver_toast_error_save_changes": "Error al guardar cambios",
      "driver_toast_member_updated": "Miembro actualizado correctamente.",
      "driver_toast_member_updated_with_docs": "Miembro actualizado correctamente. {{count}} documento(s) subido(s).",
      "driver_toast_error_update_member": "Error al actualizar miembro",
      "driver_toast_select_file": "Por favor selecciona un archivo",
      "driver_toast_document_uploaded": "Documento subido correctamente",
      "driver_toast_error_upload_document": "Error al subir documento",
      "driver_toast_select_at_least_one_photo": "Selecciona al menos una foto",
      "driver_toast_pickup_photos_uploaded": "Fotos de recogida subidas correctamente",
      "driver_toast_error_upload_photos": "Error al subir fotos",
      "driver_toast_error_upload_pickup_photos": "Error al subir fotos de recogida",
      "driver_toast_delivery_photos_uploaded": "Fotos de entrega subidas correctamente",
      "driver_toast_error_upload_delivery_photos": "Error al subir fotos de entrega",
      "driver_toast_select_contract_photo": "Selecciona al menos una foto del contrato",
      "driver_toast_contract_uploaded": "Contrato subido correctamente",
      "driver_toast_error_upload_contract": "Error al subir contrato",
      "driver_toast_expense_report_sent": "Reporte de gastos enviado correctamente",
      "driver_toast_error_send_report": "Error al enviar reporte",
      "driver_toast_error_connection_expense_report": "Error de conexión al enviar reporte de gastos",
      "driver_toast_service_completed": "Servicio completado exitosamente",
      "driver_toast_invalid_server_response": "Respuesta inválida del servidor",
      "driver_toast_incident_reported": "Incidencia reportada correctamente. El admin será notificado.",
      "driver_toast_error_report_incident": "Error al reportar incidencia",
      "driver_toast_contract_photo_added": "Foto del contrato añadida",
      "driver_toast_vehicle_photo_added": "Foto del vehículo añadida",
      "driver_toast_image_process_error": "Error al procesar la imagen",
      "admin_toast_error_load_photos": "Error al cargar las fotos",
      "admin_toast_error_load_expenses": "Error al cargar los gastos",
      "admin_toast_failed_load_data": "Error al cargar los datos",
      "admin_toast_error_load_billing": "Error al cargar datos de facturación",
      "admin_toast_partial_load": "Parte de los datos no se pudieron cargar. Actualiza la página para intentar de nuevo.",
      "admin_toast_error_generate_liquidations": "Error al generar liquidaciones",
      "admin_toast_error_generate_client_invoices": "Error al generar facturas de cliente",
      "admin_toast_excel_downloaded": "Excel descargado",
      "admin_toast_provisional_excel_no_orders": "No hay servicios en esta fila para exportar a Excel.",
      "admin_toast_error_download_excel": "Error al descargar Excel",
      "admin_toast_error_load_period_details": "Error al cargar detalles del periodo",
      "admin_toast_error_load_period_trips": "Error al cargar viajes del periodo",
      "admin_toast_driver_profile_incomplete": "El perfil del conductor está incompleto. Por favor, edita el conductor y completa todos los campos de facturación (nombre completo, DNI/NIE, dirección fiscal, banco y cuenta bancaria).",
      "admin_toast_error_generate_invoice": "Error al generar factura. Por favor, verifica que el conductor tenga todos los datos de facturación completos.",
      "admin_toast_select_charge_and_amount": "Selecciona un tipo de cargo e ingresa el importe",
      "admin_toast_error_update_report": "Error al actualizar reporte",
      "admin_toast_period_marked_paid": "Período marcado como pagado",
      "admin_toast_error_mark_period_paid": "Error al marcar período como pagado",
      "admin_toast_failed_save_driver": "Error al guardar el conductor",
      "admin_toast_driver_deleted": "Conductor eliminado correctamente",
      "admin_toast_failed_delete_driver": "Error al eliminar el conductor",
      "admin_toast_error_save_rate": "Error al guardar la tarifa",
      "admin_toast_pricing_deleted": "Tarifa eliminada correctamente",
      "admin_toast_failed_delete_pricing": "Error al eliminar la tarifa",
      "admin_toast_error_save_service": "Error al guardar el servicio",
      "admin_toast_service_deleted": "Servicio eliminado correctamente",
      "admin_toast_error_delete_service": "Error al eliminar el servicio",
      "admin_toast_template_created": "Plantilla de tarifa creada correctamente",
      "admin_toast_error_create_template": "Error al crear la plantilla",
      "admin_toast_template_deleted": "Plantilla eliminada correctamente",
      "admin_toast_error_delete_template": "Error al eliminar la plantilla",
      "admin_toast_rate_added": "Tarifa agregada correctamente",
      "admin_toast_rate_deleted": "Tarifa eliminada correctamente",
      "admin_toast_error_delete_rate": "Error al eliminar la tarifa",
      "admin_toast_rate_assigned": "Tarifa asignada correctamente al cliente",
      "admin_toast_error_assign_rate": "Error al asignar la tarifa",
      "admin_toast_custom_rate_removed": "Tarifa personalizada removida. Cliente usa tarifas generales.",
      "admin_toast_error_remove_assignment": "Error al remover la asignación",
      "admin_toast_client_updated": "Cliente actualizado correctamente",
      "admin_toast_error_update_client": "Error al actualizar cliente",
      "admin_toast_driver_updated": "Conductor actualizado correctamente",
      "admin_toast_error_open_document": "Error al abrir el documento",
      "admin_toast_error_view_document": "Error al visualizar el documento",
      "admin_incident_type_pickup_unavailable": "Coche no disponible en recogida",
      "admin_incident_type_vehicle_breakdown": "Avería / grúa",
      "admin_incident_type_accident": "Accidente",
      "admin_incident_type_minor_damage": "Daño menor",
      "admin_incident_type_delay": "Retraso",
      "admin_incident_type_other": "Otra incidencia",
      "admin_incident_reported_on": "Reportada el {{datetime}}",
      "admin_incident_service_info_heading": "Información del servicio",
      "admin_incident_vehicle_label": "Vehículo:",
      "admin_incident_driver_label": "Conductor:",
      "admin_incident_btn_in_review": "En revisión",
      "admin_incident_btn_move_history": "Pasar a histórico",
      "admin_incident_description_heading": "Descripción",
      "admin_incident_cancellation_heading": "Motivo de cancelación",
      "admin_incident_photos_heading": "Fotos adjuntas",
      "admin_incident_contract_signed_caption": "Contrato firmado",
      "admin_incident_alt_contract": "Contrato",
      "admin_incident_vehicle_photo_caption": "Foto del vehículo",
      "admin_incident_alt_vehicle": "Vehículo",
      "admin_incident_admin_notes_heading": "Notas del admin",
      "admin_incident_status_current_label": "Estado actual:",
      "admin_incident_order_status_label": "Estado del servicio:",
      "admin_incident_status_reported": "Reportado",
      "admin_incident_status_in_progress_short": "En progreso",
      "admin_incident_status_resolved": "Resuelto",
      "admin_incident_sent_to_client_log": "[Enviado al cliente: {{datetime}}]",
      "admin_incident_report_sent_to_client": "Este reporte ya fue enviado al cliente",
      "admin_incident_in_progress_notice": "En progreso: esta incidencia está siendo gestionada. Cuando termines de revisarla, márcala como resuelta para pasarla al histórico.",
      "admin_incident_finalize_title": "Finalizar servicio desde incidencia",
      "admin_incident_finalize_how_label": "¿Cómo finalizó el servicio? *",
      "admin_incident_finalize_delivered_title": "Entregado",
      "admin_incident_finalize_delivered_help": "El servicio se completó (aunque hubo incidencia)",
      "admin_incident_finalize_cancel_pickup_title": "Cancelado en recogida",
      "admin_incident_finalize_cancel_pickup_help": "El coche no estaba; el conductor se presentó",
      "admin_incident_finalize_box_delivered_title": "Servicio completado",
      "admin_incident_finalize_box_delivered_body": "El servicio entrará al flujo de facturación del conductor con el precio completo.",
      "admin_incident_finalize_box_cancel_title": "Cancelación en recogida — el conductor sí cumplió",
      "admin_incident_finalize_box_cancel_body": "Según las reglas de cancelación: el conductor se presentó en el lugar, por lo tanto tiene derecho al 100% de la compensación.",
      "admin_incident_finalize_box_cancel_footer": "El servicio entrará a la factura del conductor con el precio completo.",
      "admin_incident_finalize_notes_label": "Notas del admin",
      "admin_incident_finalize_notes_placeholder": "Notas adicionales sobre cómo se resolvió…",
      "admin_incident_finalize_expenses_label": "Gastos del conductor (si los hay)",
      "admin_incident_finalize_expenses_hint_cancel": "Desplazamiento, peajes, etc.",
      "admin_incident_finalize_confirm_delivered": "Confirmar entrega",
      "admin_incident_finalize_confirm_compensation": "Confirmar con compensación",
      "admin_incident_finalize_service_btn": "Finalizar servicio",
      "admin_incident_send_client_btn": "Enviar al cliente",
      "admin_liquidation_dialog_title": "Generar liquidaciones",
      "admin_liquidation_dialog_description": "Genera las liquidaciones para el período seleccionado. Solo se incluirán servicios con gastos aprobados.",
      "admin_client_invoice_dialog_title": "Generar facturas de clientes",
      "admin_client_invoice_dialog_description": "Genera las facturas para el período seleccionado. Solo se incluirán servicios entregados.",
      "admin_liquidation_period_type": "Tipo de quincena",
      "admin_liquidation_quincena_1": "Quincena 1 (serv. 25–9 → pago 10–15)",
      "admin_liquidation_quincena_2": "Quincena 2 (serv. 10–24 → pago 25–último)",
      "admin_client_invoice_q1": "Quincena 1 (serv. 25–9 → factura 10–15)",
      "admin_client_invoice_q2": "Quincena 2 (serv. 10–24 → factura 25–último)",
      "admin_client_invoice_label_billing": "Facturación:",
      "admin_liquidation_year_label": "Año",
      "admin_liquidation_payment_month_label": "Mes (del pago)",
      "admin_liquidation_period_summary": "Resumen del período:",
      "admin_liquidation_label_services": "Servicios:",
      "admin_liquidation_label_payment": "Pago:",
      "admin_liquidation_payment_suffix_last": "25–último",
      "admin_liquidation_generate_btn": "Generar liquidaciones",
      "admin_client_invoice_generate_btn": "Generar facturas",
      "admin_toast_liquidations_created": "{{count}} liquidaciones generadas",
      "admin_toast_liquidations_created_carried_suffix": " (incluye {{carried}} servicios arrastrados de períodos anteriores)",
      "admin_toast_no_approved_services_period": "No hay servicios aprobados en este período",
      "admin_toast_client_invoices_created": "{{count}} facturas de cliente generadas",
      "admin_toast_no_services_pending_invoice_period": "No hay servicios pendientes de facturar en este período",
      "admin_toast_invoice_generated_success": "Factura {{number}} generada correctamente",
      "admin_toast_invoice_regenerated_success": "Factura {{number}} regenerada correctamente",
      "admin_toast_server_error_generic": "Error {{status}}: {{message}}",
      "admin_toast_billing_update_failed_fallback": "Error al actualizar datos",
      "admin_liquidation_empty_driver_search": "No se encontraron conductores con ese nombre",
      "admin_liquidation_empty_current_period": "No hay servicios aprobados pendientes de liquidar en el período actual",
      "admin_liquidation_empty_pending_tab": "No hay servicios pendientes de facturar",
      "admin_liquidation_empty_period_no_drivers": "No hay conductores en este período",
      "admin_incidents_empty_active_title": "Sin incidencias activas",
      "admin_incidents_empty_history_title": "Sin histórico",
      "admin_incidents_empty_active_desc": "No hay incidencias pendientes de resolver",
      "admin_incidents_empty_history_desc": "No hay incidencias resueltas aún",
      "admin_tariff_label_colon": "Tarifa:",
      "admin_toast_invoice_created": "Factura creada: {{number}}",
      "admin_toast_incident_finalize_delivered_ok": "Servicio completado correctamente",
      "admin_toast_incident_finalize_cancel_ok": "Servicio cancelado en recogida correctamente",
      "admin_toast_incident_updated": "Incidencia actualizada",
      "admin_toast_error_update_incident": "Error al actualizar incidencia",
      "admin_toast_incident_report_sent_client": "Reporte de incidencia enviado al cliente",
      "admin_toast_error_send_incident_report_client": "Error al enviar reporte al cliente",
      "admin_toast_error_finalize_service": "Error al finalizar servicio",
      "admin_toast_no_pending_invoice_period": "No hay período pendiente de facturar",
      "admin_toast_select_fleet_owner_and_driver": "Selecciona un fleet owner y al menos un conductor",
      "admin_toast_error_assign_drivers": "Error al asignar conductores",
      "admin_toast_error_remove_driver_assignment": "Error al remover conductor",
      "admin_toast_error_create_fleet": "Error al crear flota",
      "admin_toast_driver_id_not_found": "Error: ID del conductor no encontrado",
      "admin_toast_billing_data_updated": "Datos de facturación actualizados",
      "admin_toast_error_apply_penalty": "Error al aplicar penalización",
      "admin_toast_penalty_applied": "Penalización de {{amount}}€ aplicada a {{name}}",
      "admin_toast_connection_error_with_message": "Error de conexión: {{message}}",
      "admin_toast_no_rate_for_km": "No se encontró tarifa para {{distance}} km",
      "service_toast_created_ok": "Servicio creado correctamente",
      "admin_toast_file_too_large": "El archivo es demasiado grande. Máximo 5MB.",
      "admin_toast_invalid_format": "Formato no válido. Solo se permiten JPG, PNG o PDF.",
      "admin_toast_license_expiry_required": "Por favor, introduce la fecha de vencimiento de la licencia",
      "admin_toast_dni_expiry_required": "Por favor, introduce la fecha de vencimiento del DNI",
      "admin_toast_client_created": "Cliente creado correctamente. Email de bienvenida enviado.",
      "admin_toast_client_created_no_email": "Cliente creado correctamente. No se pudo enviar el email; comparte las credenciales manualmente.",
      "admin_toast_error_upload_photos": "Error al subir las fotos",
      "admin_toast_service_completed_historic": "Servicio completado y pasado al histórico",
      "admin_toast_error_connection_complete": "Error de conexión al completar el servicio",
      "admin_toast_error_revert_service": "Error al revertir el servicio",
      "admin_toast_error_load_service_details": "Error al cargar los detalles del servicio",
      "admin_toast_complete_pickup_delivery": "Por favor completa las direcciones de recogida y entrega",
      "admin_toast_delivery_date_required": "Indica la fecha y hora de entrega del servicio",
      "admin_toast_complete_vehicle_data": "Por favor completa los datos del vehículo",
      "admin_toast_set_driver_price": "Por favor establece el precio para el conductor",
      "admin_toast_logo_uploaded": "Logo subido correctamente",
      "admin_toast_document_approved": "Documento aprobado",
      "admin_toast_error_approve_document": "Error al aprobar documento",
      "admin_toast_document_rejected": "Documento rechazado. Email enviado al conductor.",
      "admin_toast_document_rejected_no_email": "Documento rechazado. No se pudo enviar el email al conductor.",
      "admin_toast_driver_created_no_email": "Conductor creado correctamente. No se pudo enviar el email de bienvenida; comparte las credenciales manualmente.",
      "admin_toast_error_reject_document": "Error al rechazar documento",
      "admin_toast_select_rate_before_save": "Debes seleccionar una tarifa para el conductor (Básica (tarifa estándar), Premium, JLUIS (premium +10%) o Personalizada) antes de guardar",
      "admin_toast_complete_all_fields": "Por favor completa todos los campos",
      "admin_toast_invoice_uploaded": "Factura subida correctamente",
      "admin_toast_period_marked_paid_short": "Periodo marcado como pagado",
      "admin_toast_error_mark_period_paid": "Error al marcar el periodo como pagado",
      "admin_toast_invoice_deleted": "Factura eliminada correctamente",
      "admin_toast_error_delete_invoice": "Error al eliminar la factura",
      "admin_toast_period_no_services": "El periodo no tiene servicios asociados",
      "admin_toast_warning_period_no_services": "Este periodo no tiene servicios",
      "admin_toast_warning_services_not_found": "No se encontraron los servicios de este periodo en la base de datos",
      "admin_toast_service_not_found": "Servicio no encontrado",
      "admin_toast_service_no_distance": "El servicio no tiene distancia definida",
      "admin_toast_service_no_type": "El servicio no tiene tipo definido",
      "admin_toast_error_calculate_prices": "Error al calcular precios",
      "admin_toast_driver_docs_not_validated": "Este conductor no tiene los documentos validados. No se puede asignar servicios.",
      "admin_toast_enter_distance_before_assign": "Por favor ingresa la distancia del servicio antes de asignar un conductor.",
      "admin_toast_select_service_type_before_assign": "Por favor selecciona el tipo de servicio antes de asignar un conductor.",
      "admin_toast_templates_not_loaded": "Error: No se han cargado las plantillas de tarifas. Por favor recarga la página.",
      "admin_toast_could_not_calculate_rates": "No se pudieron calcular las tarifas.",
      "admin_toast_error_calculate_rates": "Error al calcular tarifas",
      "admin_toast_error_calculate_price_message": "Error al calcular precio: {{message}}",
      "admin_toast_enter_distance_before_rate": "Por favor ingresa la distancia antes de seleccionar tarifa",
      "admin_toast_select_type_before_rate": "Por favor selecciona el tipo de servicio antes de seleccionar tarifa",
      "admin_toast_could_not_calculate_price": "No se pudo calcular el precio. Verifica la distancia y tipo de servicio.",
      "admin_toast_error_calculate_rate_message": "Error al calcular la tarifa: {{message}}",
      "admin_toast_rate_updated": "Tarifa actualizada correctamente",
      "admin_toast_error_update_rate": "Error al actualizar la tarifa",
      "admin_toast_template_name_required": "El nombre de la plantilla es requerido",
      "admin_toast_template_created_short": "Plantilla creada correctamente",
      "admin_toast_contract_downloaded_2pages": "Contrato descargado - 2 páginas: Conductor y Cliente",
      "admin_confirm_delete_driver": "¿Estás seguro de que quieres eliminar este conductor?",
      "admin_delete_driver_dialog_title": "Eliminar conductor",
      "admin_confirm_delete_driver_detail": "{{name}} se eliminará permanentemente. Esta acción no se puede deshacer.",
      "admin_delete_pricing_rate_dialog_title": "Eliminar tarifa general",
      "admin_confirm_delete_pricing": "¿Estás seguro de que quieres eliminar esta tarifa?",
      "admin_delete_additional_service_dialog_title": "Eliminar servicio adicional",
      "admin_confirm_delete_additional_service": "¿Estás seguro de eliminar este servicio adicional?",
      "admin_toast_additional_service_deleted": "Servicio adicional eliminado correctamente",
      "admin_toast_error_delete_additional_service": "Error al eliminar el servicio adicional",
      "admin_confirm_delete_template": "¿Eliminar esta plantilla y todas sus tarifas?",
      "admin_confirm_delete_rate": "¿Eliminar esta tarifa?",
      "admin_confirm_remove_custom_rate": "¿Remover la tarifa personalizada de este cliente?",
      "admin_confirm_delete_custom_template_detail": "Se eliminarán también todos los tramos de precio de esta plantilla.",
      "admin_confirm_delete_custom_rate_row_detail": "Se eliminará solo este tramo de precio por distancia.",
      "admin_confirm_remove_custom_rate_detail": "El cliente volverá a la tarifa general.",
      "admin_remove_assignment_btn": "Quitar asignación",
      "admin_confirm_delete_service": "¿Estás seguro de que quieres eliminar este servicio? Esta acción no se puede deshacer.",
      "admin_confirm_revert_service": "¿Estás seguro de que quieres devolver este servicio a \"En Proceso\"? Los datos de completación (fotos, gastos) se mantendrán guardados.",
      "admin_confirm_delete_invoice": "¿Eliminar esta factura? El periodo volverá a estado pendiente.",
      "admin_confirm_cancel_order": "¿Estás seguro de que deseas cancelar este servicio?\n\nServicio: #{{serviceId}}\nCliente: {{clientName}}\nConductor: {{driverName}}\n\nSe aplicará la lógica de cancelación automáticamente:\n- Cliente: Cargo según tiempo hasta recogida\n- Conductor: Compensación según tiempo hasta recogida\n- Se enviarán emails de notificación",
      "admin_confirm_cancel_at_pickup": "⚠️ CANCELADO EN SALIDA\n\n¿El vehículo NO está disponible al momento de recogida?\n\nServicio: #{{serviceId}}\nCliente: {{clientName}}\nConductor: {{driverName}}\n\nIMPORTANTE:\n- Cliente: Cargo COMPLETO (100%)\n- Conductor: Pago COMPLETO (100%)\n- Pasa a HISTÓRICO automáticamente\n- Se enviarán emails de notificación",
      "admin_confirm_cancel_in_transit": "⚠️ CANCELADO EN TRANSPORTE\n\n¿El servicio se canceló durante el trayecto?\n\nServicio: #{{serviceId}}\nCliente: {{clientName}}\nConductor: {{driverName}}\n\nPROCESO:\n1. Servicio pasa a estado PENDIENTE\n2. Conductor debe subir: Gastos, Fotos de recogida, Fotos de donde dejó el vehículo\n3. Tú deberás APROBAR la documentación\n4. Una vez aprobado: Cliente paga 100%, Conductor cobra 100%, Pasa a HISTÓRICO",
      "admin_confirm_approve_transit": "✅ APROBAR CANCELACIÓN EN TRANSPORTE\n\n¿Has revisado la documentación del conductor?\n\nServicio: #{{serviceId}}\nConductor: {{driverName}}\n\nAl aprobar: Cliente pagará 100%, Conductor cobrará 100%, Servicio pasará a HISTÓRICO, Se incluirá en facturación",
      "admin_confirm_remove_driver_from_fleet": "¿Remover a {{name}} de su flota?",
      "admin_confirm_promote_fleet_owner": "¿Convertir a {{name}} en Fleet Owner?",
      "admin_prompt_rejection_reason": "Indica el motivo del rechazo:",
      "admin_toast_order_cancelled_success": "✅ Servicio cancelado correctamente\n\nEstado: {{status}}\nCargo al cliente: €{{clientFee}}\nCompensación al conductor: €{{driverPayment}}{{reasonExtra}}",
      "admin_toast_order_cancelled_at_pickup_success": "✅ Servicio cancelado en salida\n\nEstado: {{status}}\nCargo al cliente: €{{clientFee}}\nPago al conductor: €{{driverPayment}}",
      "admin_toast_order_marked_cancel_in_transit_success": "✅ Servicio marcado como cancelado en transporte\n\nEstado: {{status}}\nEl conductor debe subir documentación\nDeberás aprobar antes de finalizar",
      "admin_toast_transit_cancellation_approved_success": "✅ Cancelación en transporte aprobada\n\nEstado: {{status}}\nCargo al cliente: €{{clientFee}}\nPago al conductor: €{{driverPayment}}",
      "admin_toast_cancel_order_error": "Error al cancelar: {{message}}",
      "admin_toast_error_cancel_at_pickup_detail": "Error al cancelar en salida",
      "admin_toast_error_cancel_in_transit_detail": "Error al cancelar en transporte",
      "admin_toast_error_approve_transit_detail": "Error al aprobar",
      "admin_toast_error_upload_client_invoice_detail": "Error al subir factura",
      "admin_toast_error_colon_message": "Error: {{message}}",
      "admin_incident_severity_urgent": "URGENTE",
      "admin_incident_card_cancellation_prefix": "Motivo cancelación:",
      "admin_unknown_driver": "Conductor desconocido",
      "admin_toast_service_reverted_ok": "Servicio devuelto a \"{{status}}\" correctamente",
      "admin_title_edit_billing": "Editar datos de facturación",
      "admin_title_cancellation_normal": "Cancelación normal (según tiempo)",
      "admin_title_cancellation_vehicle_unavailable_pickup": "Vehículo no disponible en recogida",
      "admin_title_cancellation_during_transit": "Cancelado durante transporte",
      "admin_approvals_page_title": "Aprobaciones pendientes",
      "admin_approvals_page_subtitle": "Revisa y aprueba los servicios completados por conductores",
      "admin_approvals_card_title": "Servicios pendientes de aprobación",
      "admin_approvals_card_description": "Servicios que han sido completados y esperan aprobación",
      "admin_approvals_empty": "No hay servicios pendientes de aprobación",
      "admin_incidents_reported_title": "Incidencias reportadas",
      "admin_incidents_page_subtitle": "Gestiona las incidencias reportadas por los conductores",
      "admin_incidents_tab_active": "Activas",
      "admin_expense_approve_dialog_title": "Aprobar reporte de gastos",
      "admin_expense_approve_reported_heading": "Gastos reportados por el conductor:",
      "admin_expense_approve_driver_total": "Total conductor:",
      "admin_expense_approve_client_charges_title": "Cargos adicionales al cliente",
      "admin_expense_approve_client_charges_hint": "Añade cargos que se facturarán al cliente (no visibles para el conductor)",
      "admin_expense_approve_total_charges": "Total cargos: {{total}}€",
      "admin_approve_with_charges": "Aprobar con cargos",
      "admin_label_type_short": "Tipo",
      "admin_order_incident_tooltip": "Este servicio tuvo una incidencia",
      "admin_order_incident_label": "Incidencia",
      "admin_toast_error_load_services": "Error al cargar servicios",
      "admin_toast_period_details_load_error": "Error al cargar detalles: {{message}}",
      "admin_toast_unknown_service_type": "Tipo de servicio desconocido: {{type}}",
      "admin_error_unknown": "Error desconocido",
      "admin_toast_error_approve_driver_detail": "Error al aprobar conductor: {{detail}}",
      "admin_toast_error_create_client": "Error al crear el cliente",
      "admin_toast_service_created_with_client": "Servicio creado y asignado al cliente correctamente",
      "admin_toast_service_created_admin_only": "Servicio creado correctamente (sin cliente asignado)",
      "admin_toast_error_create_service": "Error al crear el servicio",
      "admin_toast_error_upload_logo": "Error al subir el logo",
      "admin_toast_driver_document_uploaded": "Documento subido correctamente",
      "admin_toast_driver_document_validated_auto": "Documento subido y conductor validado automáticamente",
      "admin_toast_error_upload_driver_document": "Error al subir el documento",
      "admin_driver_billing_dialog_title": "Datos de facturación — {{name}}",
      "admin_penalty_dialog_title": "Desasignando conductor",
      "admin_penalty_service_label": "Servicio:",
      "admin_penalty_route_label": "Ruta:",
      "admin_penalty_hours_until_pickup": "Tiempo hasta recogida: {{hours}} h",
      "admin_penalty_apply_label": "Aplicar penalización por cancelación",
      "admin_penalty_calculated_label": "Penalización calculada:",
      "admin_penalty_rule_under_48": "(Cancelación con menos de 48 h de antelación: -50€)",
      "admin_penalty_rule_over_48": "(Cancelación con más de 48 h de antelación: -25€)",
      "admin_penalty_amount_label": "Importe (€)",
      "admin_penalty_reason_label": "Motivo",
      "admin_penalty_reason_late": "Cancelación tardía",
      "admin_penalty_reason_no_show": "No presentado",
      "admin_penalty_reason_breach": "Incumplimiento",
      "admin_penalty_reason_other": "Otro",
      "admin_penalty_save_without": "Guardar sin penalización",
      "admin_penalty_save_with": "Guardar con penalización ({{amount}}€)",
      "admin_toast_error_update_driver": "Error al actualizar el conductor: {{message}}",
      "admin_toast_template_not_found": "Plantilla \"{{name}}\" no encontrada",
      "admin_toast_no_rates_for_template": "No hay tarifas cargadas para \"{{name}}\"",
      "admin_toast_expense_report_approved_ok": "Reporte aprobado correctamente",
      "admin_toast_expense_report_rejected_ok": "Reporte rechazado correctamente",
      "admin_toast_driver_created_ok": "Conductor creado correctamente",
      "admin_toast_driver_updated_ok": "Conductor actualizado correctamente",
      "admin_toast_pricing_created_ok": "Tarifa creada correctamente",
      "admin_toast_pricing_updated_ok": "Tarifa actualizada correctamente",
      "admin_toast_driver_created_with_docs_welcome": "Conductor creado correctamente. {{docsPart}}Email de bienvenida enviado.",
      "admin_toast_error_create_driver": "Error al crear el conductor",
      "admin_toast_no_services_pending_liquidation": "No hay servicios pendientes para liquidar",
      "admin_toast_distance_calculated": "Distancia calculada: {{km}} km",
      "admin_google_cal_service_title": "Servicio AutoGo",
      "admin_calendar_schedule_prefix": "Horario:",
      "admin_calendar_contact_prefix": "Contacto:",
      "admin_calendar_time_tbd": "Por definir",
      "admin_cancel_dialog_title_standard": "Cancelar servicio",
      "admin_cancel_dialog_title_pickup": "Cancelar en recogida",
      "admin_cancel_dialog_title_transit": "Cancelar en transporte",
      "admin_cancel_dialog_title_approve_transit": "Aprobar cancelación en transporte",
      "admin_cancel_dialog_cta_confirm": "Confirmar",
      "admin_toast_cancel_service_failed": "Error al cancelar el servicio",
      "admin_delete_dialog_title": "Eliminar servicio",
      "admin_delete_dialog_confirm": "Eliminar",
      "service_confirm_revert": "¿Estás seguro de que quieres revertir este servicio?",
      "service_confirm_delete": "¿Estás seguro de que quieres ELIMINAR este servicio? Esta acción no se puede deshacer.",
      "driver_confirm_delete_member": "¿Eliminar al chofer {{name}}?",
      "driver_doc_confirm_delete": "¿Estás seguro de que quieres eliminar este documento?",
      "driver_doc_alert_connection_error": "Error de conexión al intentar abrir el documento",
      "driver_doc_alert_download_error": "Error al descargar el documento",
      "driver_doc_alert_deleted": "Documento eliminado correctamente",
      "driver_doc_alert_error_delete": "Error al eliminar el documento",
      "driver_doc_alert_uploaded": "Documento subido correctamente",
      "driver_doc_alert_error_upload": "Error al subir el documento",
      "driver_doc_alert_error_upload_detail": "Error al subir el documento: {{detail}}",
      "service_status_undefined": "No definida",
      "service_status_not_calculated": "No calculada",
      "service_status_pending": "Pendiente",
      "service_status_assigned": "Asignado",
      "service_status_in_progress": "En Progreso",
      "service_status_in_transit": "En Tránsito",
      "service_status_inspected": "Inspeccionado",
      "service_status_delivered": "Entregado",
      "service_status_completed": "Completado",
      "service_status_cancelled": "Cancelado",
      "service_detail_billing_requires_approval_title": "Aún no entra en liquidación al conductor",
      "service_detail_billing_requires_approval_body": "Los informes de liquidación y quincenas solo incluyen servicios con estado de aprobación «Aprobado». Si el servicio está entregado o pendiente de validación, aprueba el cierre en el apartado de aprobaciones del panel.",
      "service_detail_approve_for_billing": "Aprobar para facturación",
      "service_detail_approval_badge_label": "Aprobación admin (liquidación)",
      "service_detail_approval_status_pending": "Pendiente",
      "service_detail_approval_status_pending_approval": "Pendiente de aprobación",
      "service_detail_approval_status_approved": "Aprobado — cuenta en liquidación",
      "service_detail_approval_status_rejected": "Rechazado",
      "service_no_client": "Sin cliente",
      "service_no_driver": "Sin asignar",
      "service_no_plate": "Sin matrícula",
      "driver_no_orders": "No tienes servicios asignados aún",
      "driver_no_orders_filter": "No se encontraron servicios con los filtros aplicados",
      "driver_date_unspecified": "No especificada",
      "driver_pending_approval": "Pendiente de Aprobación",
      "driver_complete_service": "Completar Servicio",
      "driver_cancel_driver_initiated": "Cancelar servicio (cargo al cliente)",
      "driver_cancel_driver_initiated_help": "Solo si faltan al menos 48 h para la recogida. Se facturan €{{fee}} al cliente (base imponible).",
      "driver_cancel_driver_initiated_confirm": "¿Cancelar este servicio como conductor? El cliente recibirá un cargo de €{{fee}} (base) en factura. Esta acción no se puede deshacer.",
      "driver_cancel_driver_initiated_success": "Servicio cancelado. Cargo en factura al cliente: €{{fee}}.",
      "driver_cancel_driver_initiated_error_window": "Esta cancelación solo está disponible cuando faltan al menos 48 horas para la recogida. Si falta menos tiempo, contacta con administración.",
      "driver_cancel_driver_initiated_failed": "No se pudo cancelar el servicio.",
      "driver_not_specified": "No especificado",
      "driver_available": "Disponible",
      "driver_not_available": "No Disponible",
      "driver_saving": "Guardando...",
      "driver_edit_click_hint": "Haz click en \"Editar\" para actualizar tu información.",
      "driver_status_rejected": "Rechazado",
      "driver_send_expense_report": "Enviar Reporte de Gastos",
      "driver_sending": "Enviando...",
      "address_toast_selected": "Dirección seleccionada correctamente",
      "common_document_preview": "Vista previa del documento",
      "ph_description": "Descripción",
      "ph_observations_delivery": "Observaciones sobre la entrega...",
      "ph_email_example": "admin@example.com",
      "ph_enter_password": "Introduce tu contraseña",
      "ph_email_driver": "tu@email.com",
      "ph_password_dots": "••••••••",
      "ph_new_password_placeholder": "Ingresa tu nueva contraseña",
      "ph_city_search": "Escribe una ciudad...",
      "ph_vehicle_address": "Dirección donde se encuentra el vehículo",
      "ph_phone_es": "+34 600 123 456",
      "ph_distance_example": "Ej: 150.5",
      "title_download": "Descargar",
      "title_pdf_viewer": "Visor PDF",
      "ph_company_example": "Ej: AutoTransportes S.L.",
      "ph_select_country": "Seleccionar país",
      "ph_name_example": "Ej: Juan García",
      "ph_lat_example": "Latitud (ej: 41.3851 para Barcelona)",
      "ph_lon_example": "Longitud (ej: 2.1734 para Barcelona)",
      "ph_cities_search": "Madrid, Barcelona...",
      "ph_brands": "Toyota, BMW...",
      "ph_models": "Corolla, Serie 3...",
      "ph_plate_example": "1234ABC",
      "ph_fullname_example": "Ej: Carlos Miguel Fernández García",
      "ph_dni_example": "12345678A",
      "ph_number_short": "15",
      "ph_fiscal_address": "Calle, número, código postal, ciudad, provincia",
      "ph_city_example": "Ej: Santander",
      "ph_iban_example": "ES00 0000 0000 0000 0000 0000",
      "ph_describe_expense": "Describe el gasto",
      "ph_select_client": "Seleccionar cliente",
      "ph_select_client_alt": "Selecciona un cliente",
      "ph_notes_service": "Añade notas o comentarios sobre este servicio...",
      "ph_amount": "0.00",
      "ph_optional": "Opcional",
      "ph_no_client_admin": "Sin cliente (Admin)",
      "admin_create_service_title": "Crear Nuevo Servicio",
      "admin_create_service_desc": "Complete los datos del servicio. Los campos marcados con * son obligatorios.",
      "admin_client_optional": "Cliente (Opcional)",
      "admin_create_service_no_client_hint": "Si no seleccionas cliente, el servicio quedará asignado al admin",
      "admin_label_color": "Color",
      "admin_label_year": "Año",
      "admin_additional_services_optional": "Servicios Adicionales (Opcional)",
      "admin_quantity_short": "Cant:",
      "admin_no_additional_services_available": "No hay servicios adicionales disponibles",
      "admin_selected_additional_services": "Servicios adicionales seleccionados:",
      "admin_total_price_upper": "PRECIO TOTAL:",
      "admin_base_service_price": "Precio base del servicio:",
      "admin_assign_driver_optional": "Asignar Conductor (Opcional)",
      "admin_driver_status_assigned": "Estado: Asignado (se enviará email al conductor)",
      "admin_driver_status_pending": "Estado: Pendiente de asignación",
      "admin_driver_rate_title": "Tarifa del Conductor (Cuánto le pagarás)",
      "admin_driver_price_label": "Precio para el Conductor *",
      "admin_driver_price_hint": "Establece cuánto le pagarás al conductor por este servicio",
      "admin_client_price": "Precio al Cliente",
      "admin_driver_payment": "Pago al Conductor",
      "admin_your_margin": "Tu Margen:",
      "admin_profit_margin_suffix": "de margen de ganancia",
      "admin_payment_status": "Estado de Pago",
      "admin_mark_as_paid": "Marcar como pagado",
      "admin_service_created_paid_status": "✓ El servicio se creará con estado 'Pagado'",
      "admin_service_created_pending_status": "El servicio se creará con estado 'Pendiente de pago'",
      "admin_additional_notes": "Notas Adicionales",
      "admin_create_service": "Crear Servicio",
      "admin_create_switch_to_range": "Cambiar a Rango",
      "admin_create_switch_to_fixed": "Cambiar a Fecha Fija",
      "admin_create_pickup_date_label": "Fecha de Recogida",
      "admin_create_pickup_time_label": "Hora de Recogida",
      "admin_create_delivery_date_label": "Fecha de Entrega",
      "admin_create_delivery_time_label": "Hora de Entrega",
      "admin_pickup_time_from": "Hora de Recogida * - Desde",
      "admin_pickup_time_to": "Hora de Recogida * - Hasta",
      "admin_delivery_time_from": "Hora de Entrega * - Desde",
      "admin_delivery_time_to": "Hora de Entrega * - Hasta",
      "admin_label_driver": "Conductor",
      "admin_driver_unassigned": "Sin asignar",
      "admin_distance_label": "Distancia",
      "admin_base_price_label": "Precio Base",
      "admin_create_creating": "Creando...",
      "admin_toast_create_vehicle_required": "Por favor completa los datos del vehículo",
      "admin_toast_create_driver_price_required": "Por favor establece el precio para el conductor",
      "admin_create_success_with_client": "Servicio creado y asignado al cliente correctamente",
      "admin_create_success_admin_only": "Servicio creado correctamente (sin cliente asignado)",
      "admin_create_docs_warn": "Servicio creado, pero hubo un problema con los documentos: {{detail}}",
      "admin_docs_fallback": "Algunos documentos no se pudieron subir.",
      "admin_create_error_generic": "Error al crear el servicio",
      "ph_search_pickup": "Buscar dirección de recogida...",
      "ph_search_delivery": "Buscar dirección de entrega...",
      "ph_name": "Nombre",
      "ph_invoice_ref": "Ej: 2025/001",
      "ph_no_driver_pending": "Sin asignar (pendiente)",
      "ph_special_instructions": "Instrucciones especiales, observaciones...",
      "ph_toll_example": "Ej: Peaje urbano, etc.",
      "ph_time_example": "Ej: 30 minutos",
      "ph_notes_delivery_optional": "Añade notas sobre la entrega (opcional)...",
      "title_edit_service": "Editar servicio",
      "title_mark_paid": "Marcar como pagado",
      "title_approve_driver": "Aprobar conductor",
      "title_view_profile": "Ver perfil completo",
      "title_view_details": "Ver detalles",
      "title_download_excel": "Descargar Excel",
      "title_download_pdf": "Descargar PDF",
      "title_generate_invoice_pdf": "Generar Factura PDF",
      "title_regenerate_invoice_pdf": "Regenerar Factura PDF",
      "title_download_pdf_existing": "Descargar PDF existente",
      "ph_address_maps": "💡 Escribe la dirección, selecciona sugerencias o pega un enlace de Google Maps",
      "address_autocomplete_placeholder_default": "Escribe dirección o pega link de Google Maps...",
      "address_quick_city_heading": "🏙️ O selecciona una ciudad:",
      "address_city_country_suffix": "{{city}}, España",
      "address_coords_from_maps": "Coordenadas desde Google Maps: {{lat}}, {{lng}}",
      "address_maps_short_label": "Google Maps: {{lat}}, {{lng}}",
      "address_manual_gps_close": "✗ Cerrar coordenadas",
      "address_manual_gps_open": "📍 O usar coordenadas GPS manuales",
      "address_manual_gps_hint": "Ingresa coordenadas GPS precisas:",
      "address_manual_gps_apply": "✓ Establecer coordenadas",
      "ph_phone_admin": "+34 600 000 000",
      "ph_qty": "Cant.",
      "ph_price": "Precio",
      "ph_extra_description": "Descripción del extra personalizado...",
      "ph_search_vehicle": "Marca, modelo, matrícula...",
      "ph_price_eur": "Precio en €",
      "ph_brand_toyota": "Toyota",
      "ph_model_corolla": "Corolla",
      "ph_plate_short": "1234ABC",
      "ph_color_example": "Ej: Blanco",
      "ph_year_example": "2023",
      "ph_zero": "0",
      "ph_rate_040": "0.40",
      "ph_rate_032": "0.32",
      "ph_rate_028": "0.28",
      "aria_select_language": "Seleccionar idioma",
      "aria_pagination": "paginación",
      "aria_prev_page": "Ir a la página anterior",
      "aria_next_page": "Ir a la página siguiente",
      "aria_breadcrumb": "miga de pan",
      "common_previous": "Anterior",
      "common_next": "Siguiente",
      "common_close": "Cerrar",
      "period_trips_title": "Detalles de Viajes",
      "period_trips_total_trips": "Total Viajes",
      "period_trips_income": "Ingresos",
      "period_trips_expenses": "Gastos",
      "period_trips_total_vat": "Total con IVA",
      "period_trips_loading": "Cargando viajes...",
      "period_trips_empty": "No hay viajes en este periodo.",
      "period_trips_expenses_approved": "✓ Gastos Aprobados",
      "period_trips_vehicle": "Vehículo:",
      "period_trips_plate": "Matrícula:",
      "period_trips_client": "Cliente:",
      "period_trips_pickup_date": "Fecha Recogida:",
      "period_trips_delivery_date": "Fecha Entrega:",
      "period_trips_service": "Servicio:",
      "period_trips_route": "Ruta:",
      "period_trips_driver_rate": "Tarifa Conductor",
      "period_trips_supplied_expenses": "Gastos Suplidos",
      "period_trips_total_service": "Total Servicio",
      "period_trips_fuel": "Combustible:",
      "period_trips_tolls": "Peajes:",
      "period_trips_parking": "Parking:",
      "period_trips_taxi": "Taxi:",
      "period_trips_other": "Otros:",
      "period_trips_id_label": "ID:",
      "period_trips_period_intro": "Período: {{start}} - {{end}}",
      "period_status_completed": "Completado",
      "period_label_period": "Período:",
      "driver_nav_home": "Inicio",
      "driver_nav_services": "Servicios",
      "driver_nav_complete": "Completar",
      "driver_nav_profile": "Mi Perfil",
      "driver_nav_billing": "Facturación",
      "driver_nav_fleet": "Mi Flota",
      "driver_portal_subtitle": "Portal del conductor",
      "driver_docs_pending_title": "Documentación Pendiente",
      "driver_docs_pending_text": "Debes subir y validar todos los documentos requeridos para poder recibir asignaciones de servicios.",
      "driver_loading": "Cargando...",
      "calendar_scheduled_subtitle": "Tus servicios programados",
      "driver_active_services": "Servicios activos",
      "driver_from_n_services": "De {{count}} servicios",
      "driver_fleet_employee_no_tariffs": "Las tarifas las gestiona tu flotista",
      "driver_validation_progress": "Progreso de validación ({{uploaded}}/7 subidos)",
      "driver_this_week_n_services": "Esta semana ({{count}} servicios)",
      "driver_status_services": "Estado de Servicios",
      "driver_status_documents": "Estado de Documentos",
      "driver_trend_title": "Tendencia de Servicios e Ingresos",
      "driver_trend_subtitle": "Últimos 6 meses",
      "driver_recent_services": "Servicios Recientes",
      "driver_last_5_assigned": "Últimos 5 servicios asignados",
      "calendar_prev_period": "Período anterior",
      "calendar_next_period": "Período siguiente",
      "calendar_day": "Día",
      "calendar_week": "Semana",
      "calendar_month": "Mes",
      "calendar_legend_assigned": "Asignado",
      "calendar_legend_completed": "Completado",
      "calendar_legend_today": "Hoy",
      "driver_completed_count": "{{count}} completados",
      "driver_chart_completed": "Servicios Completados",
      "driver_chart_income": "Ingresos",
      "driver_chart_approved": "Aprobados",
      "driver_chart_rejected": "Rechazados",
      "driver_chart_missing": "Faltantes",
      "driver_chart_cancelled": "Cancelados",
      "driver_chart_week_empty_title": "Sin actividad esta semana",
      "driver_chart_week_empty_hint": "Cuando tengas servicios en curso o completados en la semana actual, verás el resumen aquí.",
      "driver_date_unavailable": "Fecha no disponible",
      "calendar_origin": "Origen:",
      "calendar_destination": "Destino:",
      "calendar_view_full_details": "Ver detalles completos",
      "calendar_no_services": "Sin servicios",
      "calendar_no_services_this_day": "No hay servicios programados para este día",
      "driver_validated": "Validados",
      "driver_commission": "Comisión",
      "driver_services_title": "Servicios",
      "driver_services_subtitle": "Gestiona tus trayectos activos e históricos",
      "driver_services_in_progress": "En proceso",
      "driver_services_historical": "Histórico",
      "driver_filters_title": "Filtros de Búsqueda",
      "driver_clear": "Limpiar",
      "driver_clear_filters": "Limpiar filtros",
      "driver_search_address": "Buscar Dirección/Ciudad",
      "driver_status": "Estado",
      "driver_all": "Todos",
      "driver_driver_label": "Chofer",
      "driver_myself": "Yo mismo",
      "driver_vehicle_brand": "Marca Vehículo",
      "driver_vehicle_model": "Modelo Vehículo",
      "driver_plate": "Matrícula",
      "driver_fuel_type": "Tipo Combustible",
      "driver_fuel_gasoline": "Gasolina",
      "driver_fuel_diesel": "Diesel",
      "driver_fuel_electric": "Eléctrico",
      "driver_fuel_hybrid": "Híbrido",
      "driver_payment_status": "Estado de Pago",
      "driver_paid": "Pagado",
      "driver_unpaid": "No Pagado",
      "driver_showing_services": "Mostrando {{shown}} de {{total}} servicios",
      "driver_table_date": "Fecha",
      "driver_table_trip": "Trayecto",
      "driver_table_vehicle": "Vehículo",
      "driver_table_price": "Precio",
      "driver_table_status": "Estado",
      "driver_table_actions": "Acciones",
      "driver_details": "Detalles",
      "driver_order_attachments_title": "Archivos adjuntos al servicio",
      "driver_service_doc_preview_error": "No se pudo abrir el documento. Comprueba tu conexión o vuelve a intentarlo.",
      "driver_overdue_banner": "Fecha de entrega pasada - Completar servicio urgentemente",
      "driver_origin_short": "Origen",
      "driver_destination_short": "Destino",
      "driver_service_type_delivery": "Entrega",
      "driver_label_remuneration": "Remuneración",
      "driver_label_distance": "Distancia",
      "driver_label_vehicle": "Vehículo",
      "driver_pickup": "RECOGIDA",
      "driver_delivery": "ENTREGA",
      "driver_completion_docs_title": "Otros documentos del servicio",
      "driver_completion_docs_subtitle": "Opcional: albaranes, autorizaciones u otros PDF o imágenes. Quedan unidos al servicio para cliente y administración.",
      "driver_completion_docs_field_label": "Archivos a subir",
      "driver_completion_docs_hint": "PDF o imágenes (JPEG, PNG, WebP). Máx. 10 MB por archivo, hasta 15 por servicio en total (incluye los ya adjuntos).",
      "driver_upload_completion_docs": "Subir documentos",
      "driver_uploading_completion_docs": "Subiendo…",
      "driver_toast_completion_docs_uploaded": "Documentos subidos correctamente",
      "driver_toast_completion_docs_error": "No se pudieron subir los documentos",
      "driver_incomplete_title": "Servicios sin Completar",
      "driver_incomplete_subtitle": "Estos servicios están entregados pero necesitan fotos del vehículo y reporte de gastos antes del cierre del período",
      "driver_loading_services": "Cargando servicios...",
      "driver_all_services_completed": "¡Todos los servicios están completados!",
      "driver_no_pending_complete": "No hay servicios pendientes de completar",
      "driver_rejected": "Rechazado",
      "driver_service_id": "ID del Servicio",
      "driver_date_pickup": "Fecha Recogida",
      "driver_date_delivery_label": "Fecha Entrega",
      "driver_pending_approval_message": "Este servicio está pendiente de aprobación por el administrador. Una vez aprobado, se agregará automáticamente a tu facturación.",
      "driver_rejection_reason": "Motivo de rechazo:",
      "driver_reupload_photos_expenses": "Por favor, vuelve a subir las fotos y/o gastos correctamente.",
      "driver_missing_pickup_photos": "Faltan fotos de recogida",
      "driver_pickup_photos_uploaded": "Fotos de recogida subidas",
      "driver_missing_delivery_photos": "Faltan fotos de entrega",
      "driver_delivery_photos_uploaded": "Fotos de entrega subidas",
      "driver_missing_expense_report": "Falta reporte de gastos",
      "driver_expense_reported": "Gastos reportados",
      "driver_profile_title": "Mi Perfil",
      "driver_profile_subtitle": "Información personal del conductor",
      "driver_label_name": "Nombre",
      "driver_label_phone": "Teléfono",
      "driver_label_dni": "DNI/NIF",
      "driver_label_status": "Estado",
      "driver_status_available": "Disponible",
      "driver_status_not_available": "No Disponible",
      "driver_doc_validation": "Validación de Documentos",
      "driver_validation_pending": "Validación Pendiente",
      "driver_billing_title": "Información de Facturación",
      "driver_billing_description": "Esta información se utiliza para generar tus facturas",
      "driver_billing_full_name": "Nombre Completo Legal",
      "driver_billing_dni": "DNI/NIE",
      "driver_billing_irpf": "Retención IRPF (%)",
      "driver_billing_fiscal_address": "Dirección Fiscal Completa",
      "driver_billing_bank": "Banco",
      "driver_billing_iban": "Número de Cuenta (IBAN)",
      "driver_billing_iban_note": "El cambio de cuenta se aplicará en tu próxima factura",
      "driver_billing_incomplete_warning": "Para poder generar tus facturas, necesitas completar todos los campos de facturación. Haz click en \"Editar\" para actualizar tu información.",
      "driver_my_documents": "Mis Documentos",
      "driver_docs_progress": "Progreso: {{uploaded}} de {{total}} documentos subidos",
      "driver_upload_document": "Subir Documento",
      "driver_upload_dialog_desc": "Sube el documento requerido para que el administrador pueda validar tu perfil.",
      "driver_doc_type_label": "Tipo de documento *",
      "driver_doc_type_placeholder": "Selecciona un tipo",
      "driver_file_label": "Archivo *",
      "driver_file_hint_pdf": "Solo PDF (máx. {{maxMB}} MB)",
      "driver_file_hint_image": "Solo imágenes (máx. {{maxMB}} MB)",
      "driver_upload_date_label": "Fecha de subida *",
      "driver_expiry_date_label": "Fecha de vencimiento *",
      "driver_expiry_hint_hacienda": "Suele vencer a los 12 meses desde la fecha de emisión.",
      "driver_expiry_hint_ss": "Suele vencer a los 6 meses desde la fecha de emisión.",
      "driver_error_file_too_large": "El archivo supera el tamaño máximo permitido ({{maxMB}} MB). Elige un archivo más pequeño.",
      "driver_doc_license_front": "Carnet de Conducir (Frontal)",
      "driver_doc_license_back": "Carnet de Conducir (Reverso)",
      "driver_doc_dni_front": "DNI/NIE (Frontal)",
      "driver_doc_dni_back": "DNI/NIE (Reverso)",
      "driver_doc_autonomo": "Alta de Autónomo",
      "driver_doc_hacienda": "Corriente de Hacienda",
      "driver_doc_ss": "Corriente de Seguridad Social",
      "driver_doc_uploaded": "Subido:",
      "driver_doc_expires": "Vence:",
      "driver_doc_not_uploaded": "No subido",
      "driver_update": "Actualizar",
      "driver_doc_status_pending": "Pendiente",
      "driver_doc_status_approved": "Aprobado",
      "driver_doc_status_expired": "Vencido",
      "driver_fleet_docs_title": "Documentos de Mis Choferes",
      "driver_fleet_validated": "✓ Validado",
      "driver_billing_my_settlements": "Mis Liquidaciones",
      "driver_billing_subtitle": "Períodos de pago quincenales con desglose completo",
      "driver_billing_periods_info": "Períodos de pago: Quincena 1 (servicios 25-9, pago 10-15) • Quincena 2 (servicios 10-24, pago 25-último)",
      "driver_billing_current_no_services": "Período Actual: Sin servicios",
      "driver_billing_current_no_services_desc": "No tienes servicios aprobados en el período actual. Cuando completes servicios y sean aprobados, aparecerán aquí.",
      "driver_billing_previous_periods": "Períodos Anteriores",
      "driver_billing_no_previous": "No hay liquidaciones anteriores",
      "driver_billing_no_previous_desc": "Cuando se cierre un período y tus servicios sean liquidados, aparecerán aquí",
      "driver_billing_loading_settlements": "Cargando liquidaciones...",
      "driver_billing_loading_period": "Cargando período actual...",
      "driver_billing_in_progress": "En curso",
      "driver_billing_fortnight_1": "Quincena 1",
      "driver_billing_fortnight_2": "Quincena 2",
      "driver_billing_payment_label": "Pago:",
      "driver_billing_services": "Servicios",
      "driver_billing_base": "Base",
      "driver_billing_iva": "IVA (21%)",
      "driver_billing_supplies": "Suplidos",
      "driver_billing_irpf_label": "IRPF",
      "driver_billing_total_accumulated": "TOTAL ACUMULADO",
      "driver_billing_fleet_breakdown": "Desglose por Conductor de Flota:",
      "driver_billing_trips": "viajes",
      "driver_billing_hide_services": "▲ Ocultar Servicios",
      "driver_billing_view_services": "▼ Ver Servicios ({{count}})",
      "driver_billing_grand_total_abbr": "TOTAL",
      "driver_billing_totals": "Totales:",
      "driver_billing_driver": "Conductor",
      "driver_billing_rate": "Tarifa",
      "driver_billing_paid": "✓ Pagado",
      "driver_billing_status_pending": "⏳ Pendiente de pago",
      "driver_billing_period_breakdown": "Desglose por conductor:",
      "driver_billing_services_count": "servicio(s)",
      "driver_billing_view_services_btn": "Ver Servicios",
      "driver_billing_download_invoice": "Descargar Factura",
      "driver_billing_issued_invoices_title": "Facturas emitidas (PDF)",
      "driver_billing_issued_invoices_desc": "Todas las facturas registradas a tu nombre. Si falta un enlace en un período, descárgala desde aquí.",
      "driver_billing_no_invoices_on_file": "No hay facturas en el sistema todavía.",
      "driver_billing_period_details_title": "Detalles del Período de Facturación",
      "driver_billing_period_label": "Período:",
      "driver_billing_total_trips": "Total Viajes",
      "driver_billing_income_without_vat": "Ingresos (sin IVA)",
      "driver_billing_expenses_without_vat": "Gastos (sin IVA)",
      "driver_billing_total_to_pay": "Total a Pagar",
      "driver_billing_total_to_pay_caption": "(Ingresos + IVA + Gastos)",
      "driver_billing_completed_services_count": "Servicios Completados ({{count}})",
      "driver_billing_column_expenses": "Gastos",
      "driver_billing_total_parking": "Total Parking:",
      "driver_billing_total_expenses_short": "Total Gastos:",
      "driver_billing_no_tickets_attached": "No hay tickets adjuntos",
      "driver_billing_ticket_number": "Ticket {{n}}",
      "driver_dialog_upload_section_title": "Subir Documentos",
      "driver_action_start": "Iniciar",
      "driver_you_short": "(Tú)",
      "driver_fleet_no_validated_members": "No hay choferes con documentos validados",
      "driver_fleet_no_validated_members_hint": "Espera a que el admin apruebe los documentos o asígnalo a ti mismo",
      "driver_report_incident_title": "Reportar Incidencia",
      "driver_incident_type_label": "Tipo de Incidencia *",
      "driver_incident_cancel_reason_label": "Motivo de cancelación en recogida *",
      "driver_incident_cancel_reason_placeholder": "Explica por qué el coche no está disponible (ej: cliente no presente, coche no existe, dirección incorrecta...)",
      "driver_incident_description_label": "Descripción detallada *",
      "driver_incident_description_placeholder": "Describe lo ocurrido con detalle...",
      "driver_incident_contract_photo_label": "Foto del Contrato Firmado",
      "driver_incident_vehicle_photo_label": "Foto del Vehículo (si aplica)",
      "driver_incident_submit_notice_title": "⚠️ Importante:",
      "driver_incident_submit_notice_body": "Al reportar esta incidencia, el administrador será notificado inmediatamente. Asegúrate de proporcionar toda la información necesaria.",
      "driver_assign_driver": "Asignar Chofer",
      "driver_reassign_driver": "Reasignar Chofer",
      "driver_urgent": "¡URGENTE!",
      "driver_fleet_manage_subtitle": "Gestiona los conductores de tu flota",
      "driver_fleet_members_title": "Conductores de Flota",
      "driver_fleet_members_count": "{{count}} conductor en tu flota",
      "driver_fleet_members_count_plural": "{{count}} conductores en tu flota",
      "driver_fleet_no_members": "No hay conductores en tu flota",
      "driver_fleet_add_to_start": "Añade conductores para empezar a gestionar tu flota",
      "driver_fleet_add_first": "Añadir Primer Conductor",
      "driver_label_phone_short": "Teléfono:",
      "driver_label_license_no": "Nº Licencia:",
      "driver_status_busy": "Ocupado",
      "driver_status_disconnected": "Desconectado",
      "driver_label_documents": "Documentos:",
      "driver_expense_details_title": "Detalles de Gastos",
      "driver_view_more": "Ver Más",
      "driver_expense_fuel": "Gasolina",
      "driver_expense_tolls": "Peajes",
      "driver_expense_tickets": "Tickets y Recibos",
      "driver_expenses_label": "Gastos",
      "driver_uploading": "Subiendo...",
      "driver_upload_btn": "Subir",
      "driver_dialog_add_fleet_title": "Añadir Conductor a la Flota",
      "driver_dialog_add_fleet_desc": "Crea un nuevo conductor en tu flota.",
      "driver_dialog_basic_info": "Información Básica",
      "driver_dialog_full_name": "Nombre Completo",
      "driver_dialog_license_no": "Nº Carnet de Conducir",
      "driver_dialog_password_note": "📧 Nota: Se generará una contraseña automática y se enviará por email al chofer junto con sus credenciales de acceso.",
      "driver_dialog_docs_optional": "Documentos (Opcional)",
      "driver_dialog_docs_later": "Puedes subir los documentos ahora o el conductor puede subirlos más tarde desde su portal.",
      "driver_dialog_create_driver": "Crear Conductor",
      "driver_dialog_edit_fleet_title": "Editar Conductor de Flota",
      "driver_dialog_edit_fleet_desc": "Actualiza la información del conductor y sube documentos.",
      "driver_fleet_edit_docs_intro": "Sube o actualiza los documentos del conductor (DNI y carnet). Máximo {{maxMB}} MB por archivo.",
      "driver_dialog_driver_available": "Conductor disponible para recibir servicios",
      "driver_save_changes": "Guardar Cambios",
      "driver_close": "Cerrar",
      "driver_select_driver": "Selecciona Conductor",
      "driver_upload_pickup_photos": "Subir {{count}} Foto(s) de Recogida",
      "driver_upload_delivery_photos": "Subir {{count}} Foto(s) de Entrega",
      "driver_upload_contract_photos": "Subir {{count}} Foto(s) del Contrato",
      "placeholder_select_driver": "Seleccionar conductor",
      "placeholder_amount": "0.00",
      "admin_toast_service_approved_completed": "Servicio aprobado y movido a Completados",
      "admin_toast_error_detail": "Error: {{message}}",
      "admin_toast_error_approve_service": "Error al aprobar el servicio",
      "admin_toast_service_approved": "Servicio aprobado correctamente",
      "admin_toast_service_rejected": "Servicio rechazado",
      "admin_toast_error_reject_service": "Error al rechazar servicio",
      "admin_toast_driver_approved": "Conductor aprobado correctamente",
      "admin_toast_error_approve_driver": "Error al aprobar conductor",
      "admin_confirm_approve_driver_title": "¿Aprobar conductor?",
      "admin_confirm_approve_driver_description": "{{name}} pasará a estado disponible y se marcarán sus documentos como validados. ¿Deseas continuar?",
      "admin_driver_approve_dialog_confirm": "Aprobar",
      "admin_error_unknown": "Error desconocido",
      "admin_toast_complete_distance_and_type": "Completa primero la distancia (km) y tipo de servicio para calcular la tarifa",
      "admin_toast_template_basic_not_found": "No se encontró la plantilla Básica (tarifa estándar)",
      "admin_toast_template_premium_not_found": "No se encontró la plantilla Premium",
      "admin_toast_template_jluis_not_found": "No se encontró la plantilla JLUIS (premium +10%)",
      "admin_toast_enter_valid_price": "Introduce un precio válido",
      "admin_toast_please_enter_valid_price": "Por favor ingresa un precio válido",
      "admin_toast_select_extra_type": "Selecciona un tipo de extra",
      "admin_toast_price_must_be_positive": "El precio debe ser mayor a 0",
      "admin_toast_extra_added": "Extra añadido",
      "admin_toast_could_not_calculate_rate": "No se pudo calcular la tarifa",
      "admin_toast_error_calculate_price_short": "Error al calcular el precio",
      "login_successful": "¡Inicio de sesión exitoso!",
      "logout_successful": "Sesión cerrada exitosamente",
      "invalid_credentials": "Credenciales inválidas",
      "driver_login_welcome": "¡Bienvenido!",
      "driver_login_error": "Email o contraseña incorrectos",
      "driver_forgot_success": "Se ha enviado una nueva contraseña a tu correo electrónico",
      "driver_forgot_email_not_sent": "Si tu correo está registrado, no pudimos enviar el email. Contacta con soporte.",
      "driver_forgot_error": "No se pudo enviar el correo de recuperación",
      "driver_forgot_send_error": "Error al enviar el correo",
      "driver_forgot_description": "Ingresa tu correo electrónico y te enviaremos una nueva contraseña.",
      "driver_forgot_submit": "Enviar",
      "reset_toast_invalid_token": "Token de recuperación inválido",
      "reset_toast_password_requirements": "La contraseña no cumple con los requisitos de seguridad",
      "reset_toast_error": "Error al restablecer la contraseña",
      "reset_toast_success": "Contraseña restablecida correctamente",
      "reset_title": "Restablecer Contraseña",
      "reset_description": "Ingresa tu nueva contraseña",
      "reset_new_password": "Nueva Contraseña",
      "reset_confirm_password": "Confirmar Contraseña",
      "reset_requirements_title": "Requisitos de contraseña:",
      "reset_req_min_length": "Mínimo 8 caracteres",
      "reset_req_uppercase": "Al menos una mayúscula",
      "reset_req_number": "Al menos un número",
      "reset_req_symbol": "Al menos un símbolo (!@#$%^&*)",
      "reset_passwords_match": "Las contraseñas coinciden",
      "reset_resetting": "Restableciendo...",
      "reset_submit": "Restablecer Contraseña",
      "reset_back_login": "Volver al inicio de sesión",
      "driver_reset_description": "Conductor - Ingresa tu nueva contraseña",
      "reset_network_error": "Error de red",
      "fill_required_fields": "Por favor completa todos los campos requeridos",
      "address_required": "Por favor selecciona una dirección válida",
      "client_toast_delivery_date_required": "Indica la fecha de inicio y fin de la ventana de entrega",
      "distance_calculating": "Calculando distancia automáticamente...",
    }
  },
  en: {
    translation: {
      // Navigation & Common
      "language": "Language",
      "app_logo_alt": "AutoGo logo",
      "admin_login": "Admin Login",
      "logout": "Logout",
      "get_started": "Get Started",
      "learn_more": "Learn More",
      "back_to_home": "Back to Home",
      "loading": "Loading...",
      "authenticating": "Authenticating...",
      "please_wait": "Please wait while we log you in.",
      "success": "Success!",
      "redirecting": "Redirecting to dashboard...",
      
      // Landing Page
      "professional_car": "Professional Car",
      "transfer_service": "Transfer Service",
      "landing_description": "Safe, reliable, and efficient car transfer services across Europe. Choose from standard deliveries, B-C services, or trade-in options with transparent distance-based pricing.",
      "realtime_tracking": "Real-time Tracking",
      "realtime_desc": "Monitor your car transfer every step of the way",
      "flexible_timing": "Flexible Timing",
      "flexible_desc": "Set pickup and delivery time margins",
      "secure_payment": "Secure Payment",
      "secure_desc": "Safe transactions via Redsys gateway",
      "clear_pricing": "Clear Pricing",
      "clear_desc": "Distance-based rates shown upfront",
      "why_choose_us": "Why Choose Us?",
      "professional_service": "Professional service you can trust",
      "professional_drivers": "Professional Drivers",
      "drivers_desc": "Our experienced and vetted drivers ensure your vehicle is in safe hands throughout the journey.",
      "fully_insured": "Fully Insured",
      "insured_desc": "Complete insurance coverage for your peace of mind during the entire transfer process.",
      "transparent_pricing": "Transparent Pricing",
      "transparent_desc": "No hidden fees. Clear distance-based pricing calculated before you book.",
      
      // Dashboard
      "client_portal": "Client Portal",
      "my_orders": "My Orders",
      "manage_orders": "Manage your car transfer requests",
      "create_order": "Create Order",
      "no_orders_yet": "No orders yet",
      "create_first_order": "Create your first car transfer order to get started",
      "search_by_plate": "Search by Plate",
      "enter_plate_number": "Enter plate number...",
      "no_orders_found": "No orders found",
      "try_different_search": "Try a different search",
      "try_different_filters": "Try adjusting the search filters",
      "filter_orders": "Filter Orders",
      "filter_description": "Use filters to find specific orders",
      "filter_by_city": "Filter by City",
      "all_cities": "All Cities",
      "date_from": "Date From",
      "date_to": "Date To",
      "select_date": "Select date",
      "clear_filters": "Clear Filters",
      "all": "All",
      "order_status": "Order Status",
      "point_c_required": "Point C address required",
      "point_c_information": "Point C Information (Second Delivery)",
      "point_c_address": "Point C Address",
      "first_vehicle": "First Vehicle",
      "second_vehicle": "Second Vehicle",
      "bc_service_note": "First car picked up at A, delivered to B. Then second car picked up at B and delivered to C.",
      "tradein_note": "First car picked up at A, delivered to B. Then second car picked up at B and delivered back to A.",
      "edit_order": "Edit Order",
      "client_order_docs_title": "Documents attached to this service",
      "client_order_docs_subtitle": "PDF or images (JPEG, PNG, WebP). Up to 10 MB per file and 15 files per service. Click the icon to preview.",
      "client_order_doc_upload": "Upload document",
      "client_order_doc_upload_ok": "Document uploaded successfully",
      "client_order_doc_upload_fail": "Could not upload the document",
      "client_order_doc_download": "Download",
      "client_order_doc_download_fail": "Could not download the document",
      "client_order_doc_delete_ok": "Document removed",
      "client_order_doc_delete_fail": "Could not remove the document",
      "client_order_doc_none": "No documents yet. Upload one using the button above.",
      "client_order_doc_loading": "Loading documents…",
      "service_client_uploaded_files": "Files uploaded by the client",
      "service_client_uploaded_files_empty": "The client has not uploaded any files for this service yet.",
      "admin_client_order_doc_upload": "Upload document",
      "admin_client_order_doc_upload_hint": "Files are attached to this service and appear in the client portal.",
      "admin_client_order_doc_upload_ok": "Document uploaded successfully",
      "admin_client_order_doc_upload_fail": "Could not upload the document",
      "admin_client_order_doc_delete_ok": "Document deleted",
      "admin_client_order_doc_delete_fail": "Could not delete the document",
      "client_order_doc_badge_admin": "Uploaded by admin",
      "cancel_order": "Cancel Order",
      "show_more": "Show more",
      "show_less": "Show less",
      "dashboard": "Dashboard",
      "my_services": "My Services",
      "create_service": "Create Service",
      "my_company": "My Company",
      "company_profile": "Company Profile",
      "statistics": "Statistics",
      "total_services": "Total Services",
      "in_progress": "In Progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "pending_payment": "Pending Payment",
      "total_spent": "Total Spent",
      "recent_services": "Recent Services",
      "upcoming_services": "Upcoming Services",
      "client_home_nav_general": "General",
      "client_home_nav_tracking": "Tracking",
      "client_home_nav_account": "Account",
      "client_home_client_panel": "Client panel",
      "client_home_welcome_user": "Welcome, {{name}}",
      "client_home_service_trend_title": "Service trend",
      "client_home_service_trend_subtitle": "Created vs completed services",
      "client_home_chart_legend_services": "Services",
      "client_home_chart_legend_completed": "Completed",
      "client_home_recent_subtitle": "Last registered services",
      "client_home_view_all": "View all",
      "client_home_no_services_yet": "No services yet",
      "client_home_create_first_service_btn": "Create your first service",
      "client_home_service_status_menu": "Service status",
      "client_home_inspections_menu": "Inspections",
      "client_home_invoices_menu": "Invoices",
      "client_invoice_date_fallback": "Invoice - {{date}}",
      "client_completion_completed_at": "Completed:",
      "client_home_gauge_total_sub": "Total services",
      "client_home_gauge_in_progress_sub": "Active services",
      "client_home_gauge_completed_sub": "Successful deliveries",
      "client_home_gauge_cancelled_sub": "Cancelled services",
      "services_by_status": "Services by Status",
      "services_by_type": "Services by Type",
      "financial_summary": "Financial Summary",
      "view_invoices": "View Invoices",
      
      // Profile/Company
      "company_information": "Company Information",
      "company_name": "Company Name",
      "company_name_required": "Company Name *",
      "company_logo": "Company Logo",
      "upload_logo": "Upload Logo",
      "change_logo": "Change Logo",
      "contact_person": "Contact Person",
      "contact_person_required": "Contact Person *",
      "cif_dni": "Tax ID / VAT",
      "cif_dni_required": "Tax ID / VAT *",
      "cif_dni_placeholder": "e.g., B12345678 or 12345678A",
      "phone_number": "Phone Number",
      "phone_required": "Phone Number *",
      "company_address": "Address",
      "address_placeholder": "Complete company address",
      "contact_information": "Contact Information",
      "company_logo_desc": "Upload your company logo to personalize your profile",
      "company_info_billing_desc": "Company and billing information",
      "contact_data_desc": "Contact person details",
      "email_readonly_note": "Email cannot be changed",
      "change_password_section_desc": "Update your access password",
      "email_address": "Email Address",
      "client_no_invoices": "No invoices available",
      "client_invoices_biweekly": "Invoices are generated automatically every 15 days",
      "client_invoices_ondemand": "Payments are processed when creating services",
      "client_invoice_status_invoiced": "Invoiced",
      "client_address_required": "Address *",
      "client_verification_date": "Verification Date *",
      "client_verification_time": "Verification Time *",
      "client_verification_time_from": "Verification Time - From *",
      "client_verification_time_to": "Verification Time - To *",
      "client_fixed_datetime": "Fixed Date and Time",
      "client_range_datetime": "Date and Time Range",
      "client_switch_to_range": "Switch to Range",
      "client_switch_to_fixed": "Switch to Fixed Date",
      "client_select_date": "Select date",
      "client_address_heading": "Address",
      "client_time_from": "From",
      "client_time_to": "To",
      "service_not_found": "Service not found",
      "no_driver_assigned": "Not assigned",
      "address_not_specified": "Address not specified",
      "no_plate": "No plate",
      "car_type_turismo": "Sedan",
      "back_to_dashboard": "Back to Dashboard",
      "client_financial_summary_desc": "Payment and billing summary",
      "client_pending_services_label": "pending services",
      "client_last_5_services": "Last 5 requested services",
      "client_pickup_label": "Pickup:",
      "client_delivery_label": "Delivery:",
      "client_no_recent_services": "No recent services",
      "client_create_first_service": "Create your first service to get started",
      "billing_information": "Billing Information",
      "security": "Security",
      "change_password": "Change Password",
      "current_password": "Current Password",
      "new_password": "New Password",
      "confirm_password": "Confirm Password",
      "password_requirements": "Minimum 8 characters",
      "save_changes": "Save Changes",
      "profile_updated": "Profile updated successfully",
      "profile_update_error": "Error updating profile",
      "password_updated": "Password updated successfully",
      "password_update_error": "Error updating password",
      "passwords_dont_match": "Passwords don't match",
      "welcome": "Welcome",
      "member_since": "Member since",
      "quick_actions": "Quick Actions",
      "cancellation_policy": "Cancellation and Modification Policy",
      "cancel_policy_1": "• Cancellations in first hour: No cost",
      "cancel_policy_2": "• Cancellations between 1 hour and 24 hours before: 50% of price",
      "cancel_policy_3": "• Cancellations with less than 24 hours: 100% of price",
      "cancel_policy_4": "• Location modifications after 1 hour: €20",
      "cancel_policy_5": "• Changes in first hour: Free",
      "cancel_policy_6": "• Changes during transport: €50 + €0.33/km",
      "cancel_policy_7": "• Changes within 24h prior: €20 + €0.26/km",
      "cancel_policy_8": "• Cancellation during transport: Charged as completed",
      "cancel_policy_9": "• If vehicle unavailable: Charged as completed",
      "confirm_cancel": "Are you sure you want to cancel this order?",
      "order_cancelled": "Order cancelled successfully",
      "order_updated": "Order updated successfully",
      
      // Order Form
      "create_new_order": "Create New Transfer Order",
      "fill_details": "Fill in the details for your car transfer request",
      "service_type": "Service Type",
      "service_type_required": "Select a service type *",
      "delivery": "Delivery",
      "delivery_desc": "Standard single vehicle transport from point A to point B.",
      "bc_service": "B-C Service",
      "bc_service_desc": "Multiple Destinations: Pick up at A, deliver at B and pick up at B to deliver at C (20% discount on 2nd vehicle).",
      "tradein": "TRADE-IN",
      "tradein_desc": "Vehicle Exchange: Pick up at A, deliver at B and pick up at B to return at A (30% discount on 2nd vehicle).",
      "representacion": "Representation",
      "representacion_desc": "On-site verification",
      
      // Pickup Information
      "pickup_information": "Pickup Information",
      "pickup_address": "Pickup Address *",
      "start_typing_address": "Start typing address...",
      "contact_name": "Contact Name *",
      "contact_phone": "Contact Phone *",
      "pickup_date_range": "Pickup Date Range *",
      "select_dates": "Select dates",
      "pickup_time": "Pickup Time *",
      "select_time": "Select time",
      
      // Delivery Information
      "delivery_information": "Delivery Information",
      "delivery_address": "Delivery Address *",
      "delivery_date_range": "Delivery Date Range *",
      "delivery_time": "Delivery Time *",
      
      // Vehicle Information
      "vehicle_information": "Vehicle Information",
      "vehicle_type": "Vehicle Type *",
      "select_vehicle_type": "Select vehicle type",
      "car": "Sedan",
      "van": "Van",
      "pickup_truck": "Truck < 3.500kg",
      "sport_car": "Sports Car",
      "suv": "SUV",
      "motorcycle": "Motorcycle",
      "brand": "Brand *",
      "model": "Model *",
      "license_plate": "License Plate *",
      "fuel_type": "Fuel Type *",
      "select_fuel_type": "Select fuel type",
      "electric": "Electric",
      "hybrid": "Hybrid",
      "diesel": "Diesel",
      "gasoline": "Gasoline",
      
      // Second Vehicle
      "second_vehicle_optional": "Second Vehicle (Optional)",
      "second_vehicle_desc": "For B-C service or trade-in",
      "add_second_vehicle": "Add Second Vehicle",
      "remove_second_vehicle": "Remove Second Vehicle",
      
      // Representación fields
      "buyer_data": "Buyer Information",
      "seller_data": "Seller Information",
      "buyer_name": "Buyer Name",
      "buyer_surname": "Buyer Surname",
      "buyer_phone": "Buyer Phone",
      "buyer_dni": "Buyer ID/NIE",
      "seller_name": "Seller Name",
      "seller_surname": "Seller Surname",
      "seller_phone": "Seller Phone",
      "seller_dni": "Seller ID/NIE",
      "verification_address": "Verification Address",
      "verification_date": "Verification Date",
      "verification_time": "Verification Time",
      "enter_verification_address": "Enter the address where the vehicle will be verified",
      
      // Additional Services
      "additional_services": "Additional Services",
      "select_additional_services": "Select additional services if needed",
      "exterior_cleaning": "Exterior Cleaning",
      "interior_cleaning": "Interior Cleaning",
      "waiting_period": "Waiting Period",
      "itv_inspection": "ITV Inspection",
      "pit_stop": "Pit Stop",
      "extra_pit_stop_technical": "Technical Stops (Pit Stop)",
      "extra_recovery_continental_uk": "Recovery (Continental Europe & UK)",
      "extra_recovery_islands": "Recovery (European Islands)",
      "extra_recovery_ceuta_melilla": "Recovery (Ceuta & Melilla)",
      "additional_service_desc_interior_cleaning": "Interior of the vehicle",
      "additional_service_desc_exterior_cleaning": "Exterior of the vehicle",
      "additional_service_desc_itv_inspection": "Per vehicle and per attempt",
      "additional_service_desc_representation": "On-site verification",
      "additional_service_desc_recovery_continental_uk": "Recovery fee in Continental Europe and the United Kingdom",
      "additional_service_desc_recovery_islands": "Recovery fee in European islands",
      "additional_service_desc_recovery_ceuta_melilla": "Recovery fee in Ceuta and Melilla",
      "additional_service_desc_pit_stop_technical": "Per hour of waiting at workshops (tire changes, battery service, etc.)",
      
      // Distance & Pricing
      "distance_pricing": "Distance & Pricing",
      "client_service_price": "Service Price",
      "calculated_distance": "Calculated Distance",
      "calculating": "Calculating...",
      "base_price": "Base Price",
      "client_base_price_no_vat": "Base Price (without VAT)",
      "additional_services_total": "Additional Services Total",
      "total_price": "Total Price",
      "client_subtotal_no_vat": "Subtotal (without VAT)",
      "client_total_with_vat": "Total (with VAT)",
      "client_address_status": "Address Status:",
      "client_pickup_ok": "Pickup: OK",
      "client_pickup_missing": "Pickup: Missing",
      "client_delivery_ok": "Delivery: OK",
      "client_delivery_missing": "Delivery: Missing",
      "client_set_distance_manually": "Set distance manually (km)",
      "notes": "Notes (Optional)",
      "notes_placeholder": "Any additional information...",
      "service_docs_title": "Attached documents (optional)",
      "service_docs_hint": "PDF or images (JPEG, PNG, WebP). Max 10 MB per file, up to 15 files. You can preview before submitting.",
      "service_docs_hint_edit": "You can attach additional documents here. Files already saved on the service are not removed.",
      "service_docs_browse": "Attach files",
      "service_docs_preview": "Preview",
      "service_docs_remove": "Remove",
      "service_docs_max_files": "Maximum 15 files per service",
      "service_docs_file_too_large": "Each file must be 10 MB or smaller",
      "service_docs_invalid_type": "Only PDF or JPEG, PNG, or WebP images are allowed",
      "service_docs_upload_warn": "Some documents failed to upload",
      "service_docs_upload_warn_generic": "The service was saved, but some documents could not be uploaded.",
      
      // Actions
      "cancel": "Cancel",
      "create": "Create",
      "update_order": "Save Changes",
      "update": "Update",
      "delete": "Delete",
      "edit": "Edit",
      "pay_now": "Pay Now",
      "calculate_price": "Calculate Price",
      
      // Order Status
      "status": "Status",
      "pending": "Awaiting Assignment",
      "confirmed": "Confirmed",
      "assigned": "Assigned",
      "in_transit": "In Transit",
      "delivered": "Completed",
      "cancelled": "Cancelled",
      "Cancelado en Garantía": "Cancelled with Guarantee",
      "Cancelado con -24h antelación": "Cancelled with <24h notice",
      "Cancelado con +24h de antelación": "Cancelled with >24h notice",
      "payment_status_pending": "Pending",
      "paid": "Paid",
      "failed": "Failed",
      
      // Admin
      "admin_portal": "Admin Portal",
      "dashboard": "Dashboard",
      "overview": "Overview",
      "orders": "Orders",
      "drivers": "Drivers",
      "pricing": "Pricing",
      "total_orders": "Total Orders",
      "pending_orders": "Pending Orders",
      "total_drivers": "Total Drivers",
      "total_revenue": "Total Revenue",
      "recent_orders": "Recent Orders",
      "orders_management": "Orders Management",
      "drivers_management": "Drivers Management",
      "pricing_management": "Pricing Management",
      "search_by_client": "Search by client",
      "search_by_plate": "Search by plate",
      "filter_by_status": "Filter by status",
      "filter_by_city": "Filter by city",
      "filter_by_date": "Filter by date",
      "from_date": "From date",
      "to_date": "To date",
      "all_statuses": "All statuses",
      "all_cities": "All cities",
      "update_order": "Update Order",
      "edit_order_details": "Edit Order Details",
      "assign_driver": "Assign Driver",
      "no_driver": "No driver",
      "update": "Update",
      "save_changes": "Save Changes",
      "cancel": "Cancel",
      "pickup_address": "Pickup Address",
      "delivery_address": "Delivery Address",
      "client_info": "Client Information",
      "service_details": "Service Details",
      "add_driver": "Add Driver",
      "driver_name": "Driver Name",
      "driver_phone": "Driver Phone",
      "driver_status": "Driver Status",
      "available": "Available",
      "busy": "Busy",
      "offline": "Offline",
      "add_pricing_rate": "Add Pricing Rate",
      "distance_range": "Distance Range",
      "min_distance": "Min Distance (km)",
      "max_distance": "Max Distance (km)",
      "price_per_km": "Price per km",
      "base_fee": "Base Fee",
      "example_price": "Example Price (100km)",
      "actions": "Actions",
      "edit": "Edit",
      "delete": "Delete",
      "view_details": "View Details",
      "filters": "Filters",
      "clear_filters": "Clear Filters",
      "apply_filters": "Apply Filters",
      "results": "results",
      "no_results": "No results found",
      "view_manage_orders": "View and manage all car transfer orders",
      "pickup": "Pickup",
      "delivery": "Delivery",
      "vehicle": "Vehicle",
      "distance": "Distance",
      "price": "Price",
      "assigned_driver": "Assigned Driver",
      "service_type": "Service Type",
      "car_brand": "Brand",
      "car_model": "Model",
      "car_plate": "Plate",
      "fuel_type": "Fuel Type",
      "pickup_contact": "Pickup Contact",
      "delivery_contact": "Delivery Contact",
      "contact_name": "Contact Name",
      "contact_phone": "Contact Phone",
      "pickup_date": "Pickup Date",
      "delivery_date": "Delivery Date",
      "no_delivery_date": "No delivery date",
      "manage_driver_fleet": "Manage your driver fleet",
      "information": "Information",
      "modify_order_information": "Modify order information",
      "payment_status": "Payment Status",
      "select_payment_pending": "Pending",
      "select_payment_paid": "Paid",
      "select_payment_failed": "Failed",
      "admin_order_assigned_client": "Assigned Client",
      "admin_order_change_client_hint": "You can change the client assigned to this service",
      "admin_order_notes_label": "Notes / Comments",
      "admin_order_notes_visible_driver": "These notes will be visible to the driver",
      "admin_order_service_details_editable": "Service Details (Editable)",
      "admin_order_client_price_undefined_title": "Client price is not set",
      "admin_order_client_price_undefined_hint": "Click \"Recalculate client price\" to calculate it from distance",
      "admin_order_recalc_client_price": "Recalculate client price",
      "admin_order_client_price_prefix": "Price to client:",
      "admin_order_client_price_company_hint": "This is the price charged to the company",
      "admin_order_calc_distance_btn": "Calculate",
      "admin_order_distance_auto_hint": "✨ Calculated automatically when addresses change, or click \"Calculate\"",
      "admin_order_service_type_edit_hint": "✏️ Editable — required to calculate the driver rate",
      "admin_order_driver_rate_title": "Driver rate",
      "admin_order_rate_required_badge": "⚠️ REQUIRED",
      "admin_order_driver_rate_required_warning": "⚠️ You assigned a driver. You must select a rate before saving.",
      "admin_order_select_driver_rate_hint": "Select the rate you will pay the driver for this {{km}} km service",
      "admin_order_tariff_basic": "💰 Basic (standard rate)",
      "admin_order_tariff_premium": "⭐ Premium rate",
      "admin_order_tariff_jluis": "🌟 Premium +10% (JLUIS)",
      "admin_order_tariff_custom": "✏️ Custom price",
      "admin_order_rate_selected_line": "✓ Selected rate: {{price}}€{{suffix}}",
      "admin_order_rate_suffix_custom": " (Custom)",
      "admin_order_assign_driver_distance_warning": "⚠️ You assigned a driver. To choose their rate, first enter distance (km) and service type above.",
      "admin_order_address_distance_hint": "✨ Distance will be calculated automatically when addresses change",
      "admin_order_dates_times_title": "📅 Dates and times",
      "admin_order_pickup_dates": "Pickup dates",
      "admin_order_delivery_dates": "Delivery dates",
      "admin_order_fixed_datetime": "Fixed date and time",
      "admin_order_date_label": "Date",
      "admin_order_time_label": "Time",
      "admin_order_date_from": "Date from",
      "admin_order_date_to": "Date to",
      "admin_order_time_from": "Time from",
      "admin_order_time_to": "Time to",
      "admin_order_service_date_calendar": "📅 Service date (for calendar)",
      "admin_order_service_date_calendar_hint": "⚠️ This date will appear on the driver calendar once assigned",
      "admin_order_additional_services_blurb": "Select any extra services needed for this transport",
      "admin_order_driver_extras_title": "Driver extras",
      "admin_order_driver_extras_intro": "Add extra charges to include in the driver settlement (pit stop, waiting, inspection, etc.)",
      "admin_order_extras_added": "Added extras:",
      "admin_order_extras_total": "Extras total:",
      "admin_order_extras_vat_note": "(+21% VAT in settlement)",
      "admin_order_add_extra_label": "Add extra:",
      "admin_order_select_extra_type_placeholder": "Select type...",
      "admin_order_extra_subtotal": "Subtotal:",
      "admin_order_extra_add_button": "Add",
      "admin_fleet_driver_badge": "🚗 Fleet driver",
      "admin_driver_not_validated_badge": "⚠️ Not validated",
      "admin_toast_client_price_calculated": "Price calculated: €{{amount}}",
      "admin_toast_driver_tariff_selected": "{{label}} rate selected: {{price}}€",
      "admin_order_notes_placeholder": "Add notes or comments about this service...",
      "admin_order_edit_service_type_heading": "Service type *",
      "admin_order_card_delivery_title": "🚗 Delivery",
      "admin_order_card_delivery_desc": "Standard single-vehicle transport from point A to point B.",
      "admin_order_card_bc_title": "🔄 B-C service",
      "admin_order_card_bc_desc": "Multiple destinations: pick up at A, deliver at B, pick up at B and deliver at C (20% discount on the 2nd vehicle).",
      "admin_order_card_tradein_title": "🔁 Trade-in",
      "admin_order_card_tradein_desc": "Vehicle exchange: pick up at A, deliver at B, pick up at B and return to A (30% discount on the 2nd vehicle).",
      "admin_order_card_repr_title": "👤 Representation",
      "admin_order_card_repr_desc": "On-site verification by a representative.",
      "admin_order_select_client_placeholder": "Select client",
      "admin_order_distance_km_label": "Distance (km) *",
      "admin_order_service_type_field_label": "Service type *",
      "admin_custom_pricing_dialog_edit": "Edit custom price range",
      "admin_custom_pricing_dialog_assign": "Assign custom rate",
      "admin_custom_pricing_desc_for_client": "Configure prices for {{name}}",
      "admin_custom_pricing_desc_select_client": "Select a client and configure their custom prices",
      "admin_copy_from_general_pricing": "Copy from general pricing",
      "admin_add_rate_to_template": "Add rate to {{name}}",
      "admin_template_rate_dialog_desc": "Define a distance range and prices for each service type",
      "admin_template_rate_per_km_section": "Additional per-km prices (optional — for 1001+ km ranges)",
      "admin_driver_documents_modal_title": "Driver documents",
      "admin_trip_details_dialog_title": "Trip details — {{name}}",
      "admin_assign_driver_rate_dialog_title": "Assign rate to driver",
      "admin_assign_driver_client_charge_title": "Client charge",
      "admin_assign_driver_client_charge_hint": "This is what the client will pay for the service",
      "admin_price_vat_included_short": "VAT included",
      "admin_select_tariff_for_driver_title": "Select the driver rate:",
      "admin_select_tariff_for_driver_subtitle": "Choose which rate we will pay the driver for this service",
      "admin_margin_label_plain": "Margin:",
      "admin_payment_for_driver_caption": "for the driver",
      "admin_custom_driver_price_manual_hint": "Enter a different price manually",
      "admin_edit_go_arrow": "Edit →",
      "admin_template_rates_col_distance_km": "Distance (km)",
      "admin_pickup_photos_driver_heading": "Pickup photos (driver)",
      "admin_delivery_photos_driver_heading": "Delivery photos (driver)",
      "admin_vehicle_photo_exterior_section": "Exterior photos",
      "admin_vehicle_photo_interior_section": "Interior photos",
      "admin_vehicle_photo_angle_front": "Front",
      "admin_vehicle_photo_angle_rear": "Rear",
      "admin_vehicle_photo_angle_left_front": "Left side (front)",
      "admin_vehicle_photo_angle_left_rear": "Left side (rear)",
      "admin_vehicle_photo_angle_right_front": "Right side (front)",
      "admin_vehicle_photo_angle_right_rear": "Right side (rear)",
      "admin_vehicle_photo_front_seats": "Front seats",
      "admin_vehicle_photo_rear_seats": "Rear seats",
      "admin_vehicle_photo_dashboard": "Dashboard",
      "admin_vehicle_photo_trunk": "Trunk",
      "admin_vehicle_photo_acta_pickup": "Delivery note (pickup)",
      "admin_vehicle_photo_acta_delivery": "Delivery note (delivery)",
      "admin_rates_for_template_title": "Rates — {{name}}",
      "admin_order_distance_placeholder_example": "E.g. 150.5",
      "admin_toast_tariff_calculate_failed": "Could not calculate the rate",
      "admin_toast_price_calculate_error": "Error calculating price",
      "admin_toast_select_extra_type": "Select an extra type",
      "admin_toast_extra_price_gt_zero": "Price must be greater than 0",
      "admin_toast_extra_added_ok": "Extra added",
      "admin_order_extra_qty_short": "Qty.",
      "admin_order_extra_price_placeholder": "Price",
      "admin_order_extra_custom_description_ph": "Custom extra description...",
      "admin_tariff_name_basic": "Basic (standard rate)",
      "admin_tariff_name_premium": "Premium",
      "admin_tariff_name_jluis": "Premium +10% (JLUIS)",
      "admin_unknown_client": "Unknown",
      "admin_complete_dialog_subtitle": "Service for <clientHighlight>{{client}}</clientHighlight> - {{brand}} {{model}} ({{plate}})",
      "admin_complete_journey_expenses": "Journey expenses",
      "admin_complete_expense_fuel": "Fuel (€)",
      "admin_complete_expense_tolls": "Tolls (€)",
      "admin_complete_expense_parking": "Parking (€)",
      "admin_complete_expense_taxi": "Taxi / transport (€)",
      "admin_complete_expense_other": "Other expenses (€)",
      "admin_complete_expense_other_desc": "Other expenses description",
      "admin_complete_expense_other_ph": "E.g. Urban toll, etc.",
      "admin_complete_total_expenses": "Total expenses:",
      "admin_complete_service_photos": "Service photos",
      "admin_complete_pickup_photos": "Pickup photos",
      "admin_complete_delivery_photos": "Delivery photos",
      "admin_complete_expense_photos": "Expense photos (receipts / invoices)",
      "admin_complete_contract_photos": "Signed transport contract",
      "admin_complete_contract_hint": "Upload a photo of the transport contract signed by the client",
      "admin_complete_photo_count": "{{count}} photo(s)",
      "admin_complete_add_photos": "Add photos",
      "admin_complete_add_tickets": "Add receipts",
      "admin_complete_add_contract": "Add contract",
      "admin_complete_photo_alt_pickup": "Pickup {{num}}",
      "admin_complete_photo_alt_delivery": "Delivery {{num}}",
      "admin_complete_photo_alt_expense": "Expense {{num}}",
      "admin_complete_photo_alt_contract": "Contract {{num}}",
      "admin_complete_client_charges_title": "Additional charges to the client",
      "admin_complete_client_charges_badge": "NOT visible to the driver",
      "admin_complete_client_charges_intro": "Add extra charges to bill the client (waiting, pit stops, extra services, etc.)",
      "admin_complete_charge_type": "Charge type",
      "admin_complete_select_placeholder": "Select...",
      "admin_complete_charge_desc_optional": "Description (optional)",
      "admin_complete_charge_desc_ph": "E.g. 30 minutes",
      "admin_complete_charge_amount": "Amount",
      "admin_complete_charges_added": "Added charges:",
      "admin_complete_charges_total": "Total additional charges:",
      "admin_complete_notes_title": "Completion notes",
      "admin_complete_notes_ph": "Add notes about the delivery (optional)...",
      "admin_toast_complete_charge_required": "Select a charge type and enter an amount",
      "admin_toast_complete_upload_error_file": "Failed to upload {{file}}",
      "admin_toast_complete_photos_uploaded": "{{count}} photo(s) uploaded successfully",
      "admin_toast_complete_upload_photos_failed": "Failed to upload photos",
      "admin_toast_complete_service_ok": "Service completed and moved to history",
      "admin_toast_complete_service_failed": "Failed to complete service",
      "admin_toast_complete_service_failed_code": "Failed to complete service (code {{code}})",
      "admin_toast_complete_service_network": "Connection error while completing service",
      "monitor_performance": "Monitor your car transfer service performance",
      "client": "Client",
      "route": "Route",
      "service": "Service",
      "filter_by_payment": "Filter by payment status",
      "admin_payment_status_label": "Payment status *",
      "filter_by_driver": "Filter by driver",
      "no_driver_assigned": "No driver assigned",
      "all_drivers": "All drivers",
      "search_driver": "Search driver...",
      "create_new_driver": "Create new driver",
      "type_to_search": "Type to search...",
      "driver_info": "Driver Information",
      "driver_phone": "Driver Phone",
      "driver_dni": "Driver ID/DNI",
      
      // Admin Dashboard (sidebar, stats, kanban, sub-admins)
      "admin_calendar": "Calendar",
      "admin_incidents": "Incidents",
      "admin_management": "Management",
      "admin_tracking": "Tracking",
      "admin_live_gps": "Live GPS",
      "gps_live_title": "Live GPS",
      "gps_live_subtitle": "Monitor vehicles in transit in real time",
      "gps_live_loading": "Loading active services...",
      "gps_live_badge": "LIVE",
      "gps_live_refresh": "Refresh",
      "gps_live_last_update_full": "Last updated: {{time}} (Auto-refresh every 30s)",
      "gps_live_map_title": "Vehicle map ({{count}} on route)",
      "gps_live_map_alt": "Map of vehicles in transit",
      "gps_live_open_maps": "Open in Google Maps",
      "gps_live_no_locations": "No GPS locations available",
      "gps_live_static_map_key_missing": "Set the REACT_APP_GOOGLE_MAPS_API_KEY environment variable to show the preview map.",
      "gps_live_empty_title": "No vehicles on route",
      "gps_live_empty_description": "Vehicles in transit will appear here when a driver starts a service",
      "gps_live_active_services": "Active services ({{count}})",
      "gps_live_in_route": "On route",
      "gps_live_origin": "Origin",
      "gps_live_destination": "Destination",
      "gps_live_last_gps_update": "Last GPS update:",
      "gps_live_speed": "Speed:",
      "gps_live_scheduled_date": "Scheduled date:",
      "gps_live_service_id": "Service ID:",
      "gps_live_eta": "ETA: {{minutes}} min",
      "gps_live_na": "N/A",
      "inspections_title": "Vehicle inspection reports",
      "inspections_subtitle": "Inspection reports with photos and AI analysis",
      "inspections_search_placeholder": "Search by plate, driver...",
      "inspections_loading": "Loading inspection reports...",
      "inspections_stat_total": "Total inspections",
      "inspections_stat_photos": "Photos",
      "inspections_stat_with_damage": "With damage",
      "inspections_stat_no_damage": "No damage",
      "inspections_empty_title": "No inspection reports yet",
      "inspections_empty_hint": "Appraisal reports will appear here when drivers complete them",
      "inspections_empty_search": "No results found for your search",
      "inspections_damage_count": "{{count}} issue(s)",
      "inspections_no_damage_short": "No damage",
      "inspections_modal_title": "Inspection - {{plate}}",
      "inspections_photo_gallery": "Photo gallery ({{count}})",
      "inspections_photo_alt": "Photo {{n}}",
      "inspections_photo_type_default": "Photo",
      "inspections_ai_analysis_prefix": "AI analysis:",
      "inspections_ai_summary_title": "AI analysis summary",
      "inspections_damages_detected": "Damage detected",
      "inspections_no_damages_message": "No damage detected",
      "inspections_odometer": "Odometer",
      "inspections_fuel": "Fuel",
      "inspections_overall_condition": "Overall condition",
      "inspections_signature_title": "Authorized signature",
      "inspections_signature_alt": "Signature",
      "inspections_location_unavailable": "Location not available",
      "inspections_performed_by": "Performed by:",
      "gps_live_tracking_btn": "Tracking",
      "transport_tab_title": "Transport services",
      "transport_tab_subtitle": "Manage vehicle journeys",
      "transport_tab_loading": "Loading services...",
      "transport_tab_new_service": "New service",
      "transport_tab_stat_pending": "Pending",
      "transport_tab_stat_reserved": "Reserved",
      "transport_tab_stat_in_route": "On route",
      "transport_tab_stat_total": "Total",
      "transport_tab_search_placeholder": "Search by plate, driver, client...",
      "transport_tab_filter_status": "Status",
      "transport_tab_filter_pending": "Pending",
      "transport_tab_filter_reserved": "Reserved",
      "transport_tab_filter_in_route": "On route",
      "transport_tab_filter_completed": "Completed",
      "transport_tab_status_pending": "Pending",
      "transport_tab_status_reserved": "Reserved",
      "transport_tab_status_in_route": "On route",
      "transport_tab_status_completed": "Completed",
      "transport_tab_status_cancelled": "Cancelled",
      "transport_tab_empty_title": "No services yet",
      "transport_tab_empty_hint": "Create a new transport service",
      "transport_tab_empty_search": "No results found",
      "transport_tab_modal_create_title": "New transport service",
      "transport_tab_client_required": "Client *",
      "transport_tab_plate_required": "License plate *",
      "transport_tab_brand": "Make",
      "transport_tab_model": "Model",
      "transport_tab_color": "Color",
      "transport_tab_pickup_address_required": "Pickup address *",
      "transport_tab_delivery_address_required": "Delivery address *",
      "transport_tab_scheduled_date": "Scheduled date",
      "transport_tab_contact_phone": "Contact phone",
      "transport_tab_notes": "Notes",
      "transport_tab_notes_placeholder": "Special instructions...",
      "transport_tab_ph_plate": "1234ABC",
      "transport_tab_ph_brand": "BMW",
      "transport_tab_ph_model": "3 Series",
      "transport_tab_ph_color": "Black",
      "transport_tab_ph_pickup": "Main St 123, Madrid",
      "transport_tab_ph_delivery": "Central Ave 456, Barcelona",
      "transport_tab_ph_phone": "+34 600 000 000",
      "transport_tab_create_service": "Create service",
      "transport_tab_alert_required_fields": "Please fill in the required fields",
      "transport_tab_alert_create_failed": "Could not create service",
      "transport_tab_detail_vehicle": "Vehicle",
      "transport_tab_detail_route": "Route",
      "transport_tab_detail_driver": "Driver",
      "transport_tab_detail_client": "Client",
      "transport_tab_unassign_driver": "Remove assignment",
      "transport_tab_no_driver_assigned_detail": "No driver assigned",
      "transport_tab_assign_driver_placeholder": "Assign driver",
      "transport_tab_tracking_link": "Tracking link",
      "transport_tab_open": "Open",
      "transport_tab_inspections_section": "Inspection reports",
      "transport_tab_pickup_inspection_badge": "Pickup inspection available",
      "transport_tab_delivery_inspection_badge": "Delivery inspection available",
      "admin_expert_reports": "Expert reports",
      "admin_transportation_services": "Transportation Services",
      "admin_pricing_section": "Pricing",
      "admin_general_pricing": "General Pricing",
      "admin_driver_pricing": "Driver Pricing",
      "admin_custom_pricing": "Custom Pricing",
      "admin_billing": "Billing",
      "admin_client_invoices": "Client Invoices",
      "admin_driver_invoices": "Driver Invoices",
      "admin_approvals": "Approvals",
      "admin_administration": "Administration",
      "admin_profiles": "Profiles",
      "admin_documents": "Documents",
      "admin_collaborators": "Collaborators",
      "admin_close_sidebar": "Close menu",
      "admin_services_in_progress": "Services in Progress",
      "admin_total_services_done": "Total Services Done",
      "admin_pending_closure": "Pending Closure (Drivers)",
      "admin_services_completed": "Services Completed",
      "admin_pending_payment": "Pending Payment",
      "admin_services_paid": "Services Paid",
      "admin_pending_approvals": "Pending Approvals",
      "admin_total_revenue": "Total Revenue",
      "admin_kanban_new": "New",
      "admin_kanban_new_subtitle": "No driver assigned",
      "admin_kanban_assigned": "Assigned",
      "admin_kanban_assigned_subtitle": "En route / In progress",
      "admin_kanban_pending_approval": "Pending Approval",
      "admin_kanban_pending_approval_subtitle": "Awaiting validation",
      "admin_kanban_completed": "Completed",
      "admin_kanban_completed_subtitle": "Pending history",
      "admin_no_client": "No client",
      "admin_unassigned": "Unassigned",
      "admin_status_pending": "Pending",
      "admin_status_assigned": "Assigned",
      "admin_status_in_progress": "In Progress",
      "admin_status_in_transit": "In Transit",
      "admin_status_delivered": "Delivered",
      "admin_status_cancelled": "Cancelled",
      "admin_payment_pending": "Payment Pending",
      "admin_payment_paid": "Paid",
      "admin_payment_failed": "Payment Failed",
      "admin_client_label": "Client:",
      "admin_driver_label": "Driver:",
      "admin_price_client": "Client Price:",
      "admin_price_driver": "Driver Price:",
      "admin_distance": "Distance:",
      "admin_photos_pickup": "Pickup Photos",
      "admin_photos_delivery": "Delivery Photos",
      "admin_expenses": "Expenses",
      "admin_open": "Open",
      "admin_complete": "Complete",
      "admin_history": "History",
      "admin_revert": "Revert",
      "admin_revert_title": "Revert to In Progress to modify expenses",
      "admin_photos": "Photos",
      "admin_contract": "Contract",
      "admin_calendar_btn": "Calendar",
      "admin_delete": "Delete",
      "admin_cancel": "Cancel",
      "admin_cancel_at_pickup": "Pickup",
      "admin_cancel_at_pickup_title": "Vehicle not available at pickup",
      "admin_cancel_in_transit": "Transit",
      "admin_cancel_in_transit_title": "Cancelled during transport",
      "admin_approve_cancellation": "Approve Cancellation",
      "admin_filters": "Filters",
      "admin_filter_client": "Client",
      "admin_search_client_placeholder": "Search client...",
      "admin_plate": "Plate",
      "admin_plate_placeholder": "Plate...",
      "admin_city": "City",
      "admin_city_placeholder": "City...",
      "admin_driver_filter": "Driver",
      "admin_from": "From",
      "admin_to": "To",
      "admin_clear_filters": "Clear",
      "admin_all": "All",
      "admin_kanban_tip": "Drag cards between columns to change service status",
      "admin_kanban_bc_vehicle2": "Vehicle 2 (B-C):",
      "admin_kanban_second_vehicle_bc": "Second vehicle (B-C)",
      "admin_kanban_delivery_vehicle2_point_c": "Delivery vehicle 2 (Point C):",
      "admin_kanban_point_c_label": "Point C:",
      "admin_services_in_process": "services in progress",
      "admin_drop_here": "Drop here",
      "admin_no_services": "No services",
      "admin_confirm_action": "Confirm Action",
      "admin_approve_service": "Approve Service",
      "admin_approve_service_message": "Do you confirm you want to approve service #{{id}}? The service will move to Completed.",
      "admin_revert_state": "Revert State",
      "admin_revert_state_message": "Do you want to move service #{{id}} back to \"{{target}}\"? This will open the edit dialog to make the necessary changes.",
      "admin_confirm": "Confirm",
      "admin_subadmins_title": "Collaborator Management",
      "admin_subadmins_desc": "Create and manage users with limited access to the system",
      "admin_new_collaborator": "New Collaborator",
      "admin_what_is_collaborator": "What is a Collaborator?",
      "admin_collaborator_bullet1": "Can only see the drivers and services you assign to them",
      "admin_collaborator_bullet2": "Can assign rates only to the drivers they manage",
      "admin_collaborator_bullet3": "By default, cannot see client prices or delete anything",
      "admin_collaborator_bullet4": "Can create new services and manage photos/documents for their drivers",
      "admin_loading_collaborators": "Loading collaborators...",
      "admin_no_collaborators": "No collaborators created",
      "admin_create_first_collaborator": "Create a new collaborator to get started",
      "admin_see_prices": "Sees client prices",
      "admin_no_see_prices": "Does not see client prices",
      "admin_see_unassigned": "Sees unassigned",
      "admin_no_see_unassigned": "Does not see unassigned",
      "admin_can_delete": "Can delete",
      "admin_cannot_delete": "Cannot delete",
      "admin_drivers_count": "drivers",
      "admin_services_count": "services",
      "admin_assigned_drivers": "Assigned drivers:",
      "admin_assigned_services_unassigned": "Assigned services (no driver):",
      "admin_edit": "Edit",
      "admin_services": "Services",
      "admin_create_collaborator": "Create New Collaborator",
      "admin_name_required": "Name *",
      "admin_name_placeholder": "Collaborator name",
      "admin_email_required": "Email *",
      "admin_email_placeholder": "collaborator@company.com",
      "admin_password_required": "Password *",
      "admin_password_placeholder": "Minimum 8 characters",
      "admin_admin_type": "Admin Type",
      "admin_permissions": "Permissions",
      "admin_can_see_prices_invoices": "Can see client prices, rates and invoices",
      "admin_includes_prices_note": "Includes: Pricing, Client Invoices, Profiles, price column",
      "admin_can_see_unassigned_services": "Can see unassigned services",
      "admin_can_delete_services": "Can delete services and drivers",
      "admin_assigned_drivers_required": "Assigned Drivers *",
      "admin_assigned_drivers_heading": "Assigned drivers",
      "admin_all_drivers": "All",
      "admin_none": "None",
      "admin_search_driver_placeholder": "Search driver...",
      "admin_no_drivers_available": "No drivers available",
      "admin_drivers_selected": "driver(s) selected",
      "admin_create_collaborator_btn": "Create Collaborator",
      "admin_edit_collaborator": "Edit Collaborator",
      "admin_email_readonly": "Email cannot be changed",
      "admin_save_changes": "Save Changes",
      "admin_assign_services_to": "Assign Services to",
      "admin_assign_services_note": "Only services with no driver assigned are shown. Services with an assigned driver are automatically filtered by the collaborator's drivers.",
      "admin_search_service_placeholder": "Search by city, client or ID...",
      "admin_no_unassigned_services": "No unassigned services available",
      "admin_no_date_short": "No date",
      "admin_services_selected": "service(s) selected",
      "admin_save_services": "Save Services",
      "admin_super_admin": "Main Administrator",
      "admin_full": "Full Admin",
      "admin_sub_admin": "Collaborator",
      "admin_sub_admin_option": "Collaborator (Limited access)",
      "admin_full_option": "Full Admin (Sees all)",
      "admin_driver_not_found": "Driver not found",
      "admin_service_not_found": "Service not found",
      "admin_error_load_collaborators": "Error loading collaborators",
      "admin_error_create_collaborator": "Error creating collaborator",
      "admin_error_update_collaborator": "Error updating collaborator",
      "admin_error_delete_collaborator": "Error deleting collaborator",
      "admin_error_assign_services": "Error assigning services",
      "admin_confirm_delete_collaborator": "Are you sure you want to delete this collaborator?",
      "admin_delete_collaborator_dialog_title": "Delete collaborator",
      "admin_delete_collaborator_dialog_desc": "Are you sure you want to remove {{name}}? This cannot be undone.",
      "admin_fill_required": "Please complete all required fields",
      "admin_assign_at_least_one_driver": "You must assign at least one driver to the collaborator",
      "admin_charge_espera": "Waiting",
      "admin_charge_pit_stop": "Pit Stop",
      "admin_charge_itv": "ITV",
      "admin_charge_express": "Express",
      "admin_charge_recogida_extra": "Extra Pickup",
      "admin_charge_cambio_ruta": "Route Change",
      "admin_charge_otros": "Other",
      "admin_toast_periods_generated": "Periods generated successfully",
      "admin_toast_error_load_periods": "Error loading billing periods",
      "admin_toast_error_generate_periods": "Error generating billing periods",
      "admin_toast_error_create_invoice": "Error creating invoice",
      "admin_toast_service_marked_paid": "Service marked as paid",
      "admin_toast_error_mark_paid": "Error marking service as paid",
      "admin_toast_invoice_marked_paid": "Invoice marked as paid",
      "admin_toast_error_invoice_paid": "Error marking invoice as paid",
      "admin_toast_collaborator_created": "Collaborator created successfully",
      "admin_toast_collaborator_created_no_email": "Collaborator created. Welcome email could not be sent; share credentials manually.",
      "admin_toast_collaborator_updated": "Collaborator updated successfully",
      "admin_toast_collaborator_deleted": "Collaborator deleted successfully",
      "admin_more_count_short": "+{{count}} more",
      "admin_toast_services_assigned": "Services assigned successfully",
      "admin_table_service_id": "Service ID",
      "admin_table_client": "Client",
      "admin_table_plate": "Plate",
      "admin_table_pickup": "Pickup",
      "admin_table_delivery": "Delivery",
      "admin_table_dates": "Dates",
      "admin_table_driver": "Driver",
      "admin_table_status": "Status",
      "admin_table_price": "Price",
      "admin_table_action": "Action",
      "calendar_title": "Service Calendar",
      "calendar_subtitle": "All services organized by pickup date",
      "calendar_no_driver": "No driver",
      "calendar_in_progress": "In progress",
      "calendar_completed": "Completed",
      "calendar_others": "Others",
      "calendar_origin": "Origin:",
      "calendar_destination": "Destination:",
      "calendar_driver": "Driver:",
      "calendar_client": "Client:",
      "calendar_price": "Price:",
      "calendar_grid_timezone_label": "Calendar days",
      "calendar_grid_timezone_hint": "Choose which zone is used to bucket services by date (useful across time zones).",
      "timezone_label": "Time zones (to align agenda)",
      "timezone_configure": "Configure",
      "timezone_zone1_label": "Zone 1 label (e.g. Me, Madrid, Client)",
      "timezone_zone2_label": "Zone 2 label (e.g. Assistant, Bangkok, Team)",
      "timezone_zone1_placeholder": "Zone 1",
      "timezone_zone2_placeholder": "Zone 2",
      "timezone_search_placeholder": "Search zone...",
      "timezone_help": "Calendar times are shown in both zones. Choose any two zones (e.g. you and your assistant) to align agendas.",
      "timezone_save": "Save",
      "admin_services_in_progress_tab": "In progress",
      "admin_historical": "Historical",
      "admin_list": "List",
      "admin_view_mode_kanban": "Kanban",
      "admin_tip_label": "Tip:",
      "admin_toast_select_driver_for_service": "Select a driver to assign to this service",
      "admin_overview_expiring_docs_title": "Documents expiring soon",
      "admin_overview_expiring_docs_intro": "{{count}} document(s) will expire in the next 7 days. Urgent attention required.",
      "admin_overview_doc_status_expired": "Expired {{days}} day(s) ago",
      "admin_overview_doc_status_expires": "Expires in {{days}} day(s)",
      "admin_overview_more_documents": "… and {{count}} more document(s)",
      "admin_overview_view_driver": "View driver",
      "admin_doc_type_license_front": "🪪 Driver's license",
      "admin_doc_type_license_back": "🪪 License (back)",
      "admin_doc_type_dni_front": "🆔 ID (DNI/NIE)",
      "admin_doc_type_dni_back": "🆔 ID (back)",
      "admin_doc_section_license": "Driver's license",
      "admin_doc_section_dni": "ID / NIE",
      "admin_doc_section_certificates": "Certificates",
      "admin_doc_side_front": "Front",
      "admin_doc_side_back": "Back",
      "admin_doc_type_autonomo_certificate": "📋 Self-employed registration",
      "admin_doc_type_ss_certificate": "📋 Social security",
      "admin_doc_type_hacienda_certificate": "📋 Tax agency",
      "admin_doc_type_unknown": "📄 Document",
      "admin_recent_orders_row_title": "Open service in the orders list",
      "admin_toast_driver_tariff_assigned_named": "{{label}} rate (€{{amount}}) assigned to driver",
      "admin_toast_driver_tariff_assigned_custom": "Custom rate (€{{amount}}) assigned to driver",
      "admin_pricing_template_fallback": "Template",
      "admin_contract_download_basename": "AutoGo_Contract_",
      "admin_creation": "Creation:",
      "admin_rate_assigned_driver": "Rate assigned to driver:",
      "admin_rate_suggestions_driver": "Rate suggestions for driver:",
      "admin_rate_for_driver_incomplete": "Rates for driver (complete distance and type):",
      "admin_basic": "Basic (standard rate)",
      "admin_active": "Active",
      "admin_custom": "Custom",
      "admin_customized": "Customized",
      "admin_approve": "Approve",
      "admin_complete_service_title": "Complete service with photos and expenses",
      "admin_delete_service_title": "Delete service permanently",
      "admin_view_history_title": "View completed service details",
      "admin_cancel_normal_title": "Normal cancellation (by time)",
      "admin_calculated_distance": "Calculated Distance",
      "admin_not_calculated": "Not calculated",
      "admin_additional_services": "Additional Services",
      "admin_service_notes": "Service Notes",
      "admin_notes_general": "General:",
      "admin_notes_vehicle1": "Vehicle 1:",
      "admin_notes_vehicle2": "Vehicle 2:",
      "admin_view_photos": "View Photos",
      "admin_view_expenses": "View Expenses",
      "admin_no_photos_for_service": "No photos available for this service.",
      "admin_no_expenses_for_service": "No expenses reported for this service.",
      "admin_service_expenses": "Service Expenses",
      "admin_close": "Close",
      "admin_no_receipts_attached": "No receipts attached to this report",
      "admin_table_name": "Name",
      "admin_table_phone": "Phone",
      "admin_table_email": "Email",
      "admin_table_license": "License",
      "admin_table_actions": "Actions",
      "admin_driver_status_required": "Status *",
      "admin_driver_busy": "Busy",
      "admin_driver_offline": "Offline",
      "admin_toast_driver_created_ok": "Driver created successfully.",
      "admin_toast_driver_docs_uploaded": "{{count}} document(s) uploaded.",
      "admin_toast_driver_welcome_email_sent": "Welcome email sent.",
      "admin_service_expenses_subtitle": "Service #{{id}} - {{brand}} {{model}}",
      "admin_add_to_calendar": "Add to Calendar",
      "admin_download_contract": "Download Contract",
      "admin_premium": "Premium",
      "admin_toast_opening_calendar": "Opening Google Calendar...",
      "admin_toast_contract_downloaded": "Contract downloaded - 2 pages: Driver and Client",
      "admin_toast_contract_fallback_simple_pdf": "Simplified contract PDF (Playwright failed). Windows: from backend run \"python run_dev_api.py\". Linux/server: python -m playwright install chromium",
      "admin_toast_error_generate_contract": "Error generating contract",
      "admin_toast_error_download_contract": "Error downloading contract",
      "pagination_showing": "Showing",
      "pagination_to": "to",
      "pagination_of": "of",
      "pagination_results": "results",
      "pagination_prev": "Previous",
      "pagination_next": "Next",
      "pagination_page_of": "Page {{current}} of {{total}}",
      "driver_profile_title": "Driver Profile",
      "driver_profile_subtitle": "Detailed information, documents and statistics",
      "driver_basic_info": "Basic Information",
      "driver_upload_new": "Upload New",
      "driver_upload_new_document": "Upload New Document",
      "driver_statistics": "Statistics",
      "driver_total_services": "Total Services",
      "driver_completed": "Completed",
      "driver_earnings": "Earnings",
      "driver_billing_info": "Billing Information",
      "driver_doc_not_uploaded": "Not uploaded",
      "driver_doc_expires_soon": "Expires Soon",
      "driver_doc_approved": "Approved",
      "driver_doc_pending": "Pending",
      "driver_doc_rejected": "Rejected",
      "driver_doc_expired": "Expired",
      "driver_doc_dni_front": "ID - Front",
      "driver_doc_dni_back": "ID - Back",
      "driver_doc_license_front": "License - Front",
      "driver_doc_license_back": "License - Back",
      "driver_doc_autonomo": "Self-Employed Certificate",
      "driver_doc_hacienda": "Tax Certificate",
      "driver_doc_ss": "Social Security",
      "driver_error_open_document": "Error opening document",
      "driver_validated": "Validated",
      "driver_subidos_required": "uploaded of {{required}} required",
      "admin_edit_driver": "Edit Driver",
      "admin_edit_driver_description": "Modify the driver's information. Admin can edit everything.",
      "admin_label_name": "Name",
      "admin_label_email": "Email",
      "admin_label_phone": "Phone",
      "admin_label_dni_nif": "DNI/NIF",
      "admin_driver_available": "Driver available",
      "admin_documents_validated": "Documents Validated",
      "admin_billing_full_name": "Full Name *",
      "admin_billing_legal_name_hint": "Full legal name for invoices",
      "admin_billing_dni_nie": "ID or NIE *",
      "admin_billing_irpf": "IRPF Withholding (%)",
      "admin_billing_irpf_hint": "Percentage of IRPF to withhold (0-100%)",
      "admin_billing_fiscal_address": "Full Tax Address *",
      "admin_billing_bank_name": "Bank Name *",
      "admin_billing_iban": "Account Number (IBAN) *",
      "admin_driver_type": "Driver Type",
      "admin_fleet_driver": "Driver with Fleet",
      "admin_fleet_driver_hint": "Fleet drivers can create and manage other drivers under their supervision.",
      "admin_assign_fleet": "Assign to Fleet (Optional)",
      "admin_independent_driver": "Independent Driver",
      "admin_fleet_assign_hint": "If you select a fleet, this driver will be under the supervision of the selected fleet driver",
      "admin_create_new_driver_desc": "Create a new driver. A password will be generated automatically and sent by email.",
      "admin_create_new_driver": "Create New Driver",
      "admin_create_driver_password_info": "A random password will be generated and sent to the driver's email along with their access credentials.",
      "admin_driver_dni_required": "DNI/NIE / ID *",
      "admin_review_document": "Review Document",
      "admin_certificate_expiry_12m": "Expiry date (12 months)",
      "admin_certificate_expiry_6m": "Expiry date (6 months)",
      "admin_doc_label_pdf": "{{name}} (PDF)",
      "admin_add_new_driver": "Add New Driver",
      "admin_enter_driver_info": "Enter driver information",
      "admin_license_number": "License Number",
      "admin_name_label": "Name",
      "admin_vehicle_info_label": "Vehicle Information",
      "admin_vehicle_info_placeholder": "Make, model, license plate...",
      "admin_billing_full_name_placeholder": "e.g. Jane Doe",
      "admin_billing_fiscal_placeholder": "Street, number, postal code, city, province",
      "admin_billing_bank_placeholder": "e.g. Santander",
      "admin_billing_iban_placeholder": "ES00 0000 0000 0000 0000 0000",
      "admin_drivers_management": "Drivers Management",
      "admin_manage_driver_fleet": "Manage your driver fleet",
      "admin_clients_management": "Clients Management",
      "admin_clients_detail": "Detailed information for all clients",
      "admin_drivers_detail": "Detailed information for all drivers",
      "admin_drivers_assigned_desc": "Drivers assigned to you or that you have created",
      "admin_drivers_assigned": "Assigned",
      "admin_drivers_registered": "Registered",
      "admin_drivers_assigned_title": "Assigned Drivers",
      "admin_drivers_registered_title": "Registered Drivers",
      "admin_create_driver": "Create Driver",
      "admin_billing_info": "Billing Information",
      "admin_delivery_info": "Delivery Information",
      "admin_driver_docs_title": "Driver Documentation",
      "admin_validation_pending": "Validation Pending",
      "admin_docs_warning_title": "Attention: Validated driver without documents",
      "admin_docs_warning_body": "This driver is marked as \"Validated\" but has no documents uploaded to the system. Please upload the corresponding documents to keep records correct.",
      "admin_fleet_driver_info": "Fleet Driver: Only requires Driver's License and ID (4 basic documents)",
      "admin_independent_driver_info": "Independent/Fleet Owner Driver: Requires all documents (7 total)",
      "admin_docs_upload_note": "When uploading documents as admin, they are validated automatically. Maximum 5MB per file.",
      "admin_docs_uploaded_count": "Uploaded Documents ({{count}})",
      "admin_docs_basic": "Basic Documents (Mandatory)",
      "admin_docs_certificates": "Additional Certificates (Independent and Fleet Owner Drivers Only)",
      "admin_expiry_date": "Expiration Date",
      "admin_format_image_pdf": "Format: JPG, PNG or PDF (max. 5MB)",
      "admin_format_pdf": "Format: PDF (max. 5MB)",
      "admin_uploaded": "Uploaded",
      "admin_expires": "Expires",
      "admin_expired": "EXPIRED",
      "admin_expires_soon": "EXPIRES SOON",
      "admin_docs_no_delete": "Documents cannot be deleted. To replace a document, upload a new one of the same type.",
      "admin_uploading_doc": "Uploading document...",
      "admin_doc_license_front_full": "Driver's License (Front)",
      "admin_doc_license_back_full": "Driver's License (Back)",
      "admin_doc_dni_front_full": "ID (Front)",
      "admin_doc_dni_back_full": "ID (Back)",
      "admin_doc_autonomo_full": "Self-Employed Registration",
      "admin_doc_ss_full": "Current Social Security Certificate",
      "admin_doc_hacienda_full": "Current Tax Agency Certificate",
      "admin_general_pricing_title": "General Client Rates",
      "admin_general_pricing_description": "These rates apply by default to all clients",
      "admin_add_pricing_rate": "Add Pricing Rate",
      "admin_edit_pricing_rate": "Edit Pricing Rate",
      "admin_add_new_pricing_rate": "Add New Pricing Rate",
      "admin_configure_pricing_description": "Configure pricing for distance range",
      "admin_min_distance_km": "Minimum Distance (km)",
      "admin_max_distance_km": "Maximum Distance (km)",
      "admin_price_delivery": "Delivery Service Price (€)",
      "admin_price_bc": "B-C Service Price (€)",
      "admin_price_tradein": "TRADE-IN Service Price (€)",
      "admin_price_representation": "Representation Service Price (€)",
      "admin_per_km_section": "Prices per additional km (optional - for 1001+ km ranges)",
      "admin_per_km_delivery": "Delivery - Price per additional km (€)",
      "admin_per_km_bc": "B-C - Price per additional km (€)",
      "admin_per_km_tradein": "TRADE-IN - Price per additional km (€)",
      "admin_per_km_note": "If defined, price will be: base + (km - 1001) × this value",
      "admin_placeholder_040": "e.g. 0.40",
      "admin_placeholder_032": "e.g. 0.32",
      "admin_placeholder_028": "e.g. 0.28",
      "admin_pricing_table_title": "General Client Rates Table",
      "admin_pricing_table_description": "By default, all clients use these rates",
      "admin_pricing_col_distance": "Distance (km)",
      "admin_pricing_col_delivery": "Delivery (€)",
      "admin_pricing_col_bc": "B-C Service (€)",
      "admin_pricing_col_tradein": "TRADE-IN (€)",
      "admin_pricing_col_representation": "Representation (€)",
      "admin_pricing_col_actions": "Actions",
      "admin_no_rates_configured": "No rates configured. Click \"Add Pricing Rate\" to create one.",
      "admin_pricing_cell_base_plus_per_km": "€{{base}} + €{{perKm}}/{{perKmUnit}}",
      "admin_per_km_suffix": "additional km",
      "admin_additional_services_title": "Additional Services",
      "admin_additional_services_description": "Rates for extra services available to all clients",
      "admin_add_service": "Add Service",
      "admin_edit_additional_service": "Edit Additional Service",
      "admin_new_additional_service": "New Additional Service",
      "admin_edit_additional_service_desc": "Modify the service details",
      "admin_new_additional_service_desc": "Add a new additional service",
      "admin_service_name_label": "Service Name",
      "admin_service_name_placeholder": "e.g. Exterior Cleaning",
      "admin_service_price_label": "Price (€)",
      "admin_billing_unit_label": "Billing Unit",
      "admin_unit_per_service": "Per Service",
      "admin_unit_per_hour": "Per Hour",
      "admin_unit_per_vehicle": "Per Vehicle",
      "admin_service_description_label": "Description",
      "admin_service_description_placeholder": "Service description",
      "admin_additional_services_col_service": "Service",
      "admin_additional_services_col_price": "Price (€)",
      "admin_additional_services_col_unit": "Unit",
      "admin_additional_services_col_description": "Description",
      "admin_additional_services_col_actions": "Actions",
      "admin_no_additional_services": "No additional services configured",
      "admin_driver_pricing_title": "Rates for Drivers",
      "admin_driver_pricing_subtitle": "Manage the rates paid to drivers for their services",
      "admin_driver_template_desc_basica": "Basic rate for drivers",
      "admin_driver_template_desc_premium": "Premium rate for drivers",
      "admin_driver_template_desc_jluis": "Premium rate + 10%",
      "admin_driver_template_basica": "Basic (standard rate)",
      "admin_driver_template_premium": "Premium",
      "admin_driver_template_jluis": "Premium +10% (JLUIS)",
      "admin_new_template": "New Template",
      "admin_view_rates": "View Rates",
      "admin_badge_high_end": "High end",
      "admin_badge_standard": "Standard",
      "admin_badge_premium_plus_10": "Premium +10%",
      "admin_how_tariff_system_works": "How the pricing system works",
      "admin_basic_tariff_explanation": "Basic (standard rate): Standard rate for most services",
      "admin_premium_tariff_explanation": "Premium: Superior rate with better margins",
      "admin_jluis_tariff_explanation": "Premium +10% (JLUIS): 10% above the Premium rate, calculated automatically.",
      "admin_tariff_assignment_explanation": "When assigning a driver to a service, the admin chooses the applicable rate",
      "admin_custom_tariff_explanation": "A custom rate can also be entered for special cases",
      "admin_tariff_comparison_title": "Rate Comparison (Example: 500 km)",
      "admin_tariff_comparison_subtitle": "Approximate prices for 500 km services",
      "admin_standard_delivery": "Standard delivery",
      "admin_superior_delivery": "Superior delivery",
      "admin_premium_plus_10_label": "Premium + 10%",
      "admin_pricing_disclaimer": "* Exact prices vary according to distance and service type",
      "admin_services_with": "Services with {{name}}",
      "admin_error_load_rates": "Error loading rates",
      "admin_rates_for_template": "Rates - {{name}}",
      "admin_all_rates_configured_for_template": "All rates configured for this template",
      "admin_range_km": "Range (km)",
      "admin_rates_col_delivery": "Delivery",
      "admin_rates_col_bc": "B-C",
      "admin_rates_col_tradein": "Trade-In",
      "admin_rates_col_representation": "Representation",
      "admin_rates_col_actions": "Actions",
      "admin_base_plus_per_km": "Base + additional per km",
      "admin_rates_per_km_long_note": "Rates with \"+ km\" use a base price plus an extra charge per kilometer for distances over 1000 km.",
      "admin_distance_range_closed": "{{min}} - {{max}} km",
      "admin_distance_range_open": "{{min}}+ km",
      "admin_rates_plus_amount_per_km": "+ {{amount}}€/km",
      "admin_edit_rate_title": "Edit rate",
      "admin_edit_rate_range_caption": "Range: {{range}}",
      "admin_edit_rate_per_km_heading": "Additional per-km prices (for 1001+ km):",
      "admin_rate_delivery_per_km": "Delivery per km (€)",
      "admin_rate_bc_per_km": "B-C per km (€)",
      "admin_rate_tradein_per_km": "Trade-In per km (€)",
      "admin_no_rates_for_template": "No rates configured for this template",
      "admin_create_new_pricing_template": "Create New Pricing Template",
      "admin_new_template_intro": "The new template will be created with the same rates as the standard (Basic) template. You can edit them later.",
      "admin_template_name_required": "Template Name *",
      "admin_template_name_placeholder": "e.g. Premium Plus, Special, etc.",
      "admin_template_description_placeholder": "Brief description of this template",
      "admin_note": "Note:",
      "admin_new_template_note_body": "The new template will be created automatically with 17 rate ranges (based on the standard Basic template). You will be able to edit them individually after creating it.",
      "admin_create_template": "Create Template",
      "admin_creating": "Creating...",
      "admin_modal_create_intro": "Fill in the service details. Fields marked with * are required.",
      "admin_modal_client_optional_label": "Client (optional)",
      "admin_modal_no_client_admin": "No client (admin)",
      "admin_modal_no_client_hint": "If you do not select a client, the service will remain assigned to the admin",
      "admin_modal_datetime_range_title": "Date and time range",
      "admin_modal_switch_to_range": "Switch to range",
      "admin_modal_switch_to_fixed": "Switch to fixed date",
      "admin_modal_pickup_date_label": "Pickup date",
      "admin_modal_pickup_time_label": "Pickup time",
      "admin_modal_pickup_time_from": "Pickup time * — from",
      "admin_modal_pickup_time_to": "Pickup time * — to",
      "admin_modal_delivery_date_label": "Delivery date",
      "admin_modal_delivery_time_label": "Delivery time",
      "admin_modal_delivery_time_from": "Delivery time * — from",
      "admin_modal_delivery_time_to": "Delivery time * — to",
      "admin_optional_paren": "(optional)",
      "admin_modal_no_additional_services": "No additional services available",
      "admin_modal_total_price_label": "TOTAL PRICE:",
      "admin_modal_price_base_service": "Base service price:",
      "admin_modal_additional_services_sum": "Additional services:",
      "admin_modal_additional_selected_label": "Selected additional services:",
      "admin_modal_assign_driver_heading": "Assign driver (optional)",
      "admin_modal_driver_unassigned_placeholder": "Unassigned (pending)",
      "admin_modal_driver_status_assigned": "Status: assigned (an email will be sent to the driver)",
      "admin_modal_driver_status_pending": "Status: pending assignment",
      "admin_modal_driver_rate_block_title": "Driver rate (what you will pay)",
      "admin_modal_driver_price_label": "Price for driver *",
      "admin_modal_driver_price_hint": "Set how much you will pay the driver for this service",
      "admin_modal_pay_driver_short": "Driver payment",
      "admin_modal_your_margin": "Your margin:",
      "admin_modal_margin_percent": "{{pct}}% profit margin",
      "admin_modal_payment_status_title": "Payment status",
      "admin_modal_mark_paid_label": "Mark as paid",
      "admin_modal_payment_paid_hint": "✓ The service will be created as \"Paid\"",
      "admin_modal_payment_pending_hint": "The service will be created as \"Payment pending\"",
      "admin_modal_notes_additional": "Additional notes",
      "admin_placeholder_contact_first_name": "Name",
      "admin_placeholder_brand_example": "E.g. Toyota",
      "admin_placeholder_model_example": "E.g. Corolla",
      "admin_service_history_title": "Service history",
      "admin_history_delivered": "Delivered",
      "admin_history_completed_on": "Completed:",
      "admin_history_expenses_registered": "Recorded expenses",
      "admin_history_total_label": "TOTAL:",
      "admin_history_submitted_by": "Submitted by:",
      "admin_history_contract_photos": "Contract photos",
      "admin_history_expense_photos": "Expense / ticket photos",
      "admin_history_completion_notes": "Completion notes",
      "admin_history_completed_by": "Completed by:",
      "admin_loading_order_expenses": "Loading expenses...",
      "admin_expenses_registered_completion": "Expenses recorded when completing the service",
      "admin_expenses_by": "by {{name}}",
      "admin_expenses_on": "on {{date}}",
      "admin_expense_status_label": "Status:",
      "admin_expense_status_approved": "Approved",
      "admin_expense_status_rejected": "Rejected",
      "admin_expense_status_pending": "Pending approval",
      "admin_expense_reported": "Reported:",
      "admin_expense_total_expenses": "Total expenses:",
      "admin_expense_rejection_reason": "Rejection reason:",
      "admin_expense_other_na": "N/A",
      "admin_expense_gas_label": "Fuel:",
      "admin_expense_tolls_label": "Tolls:",
      "admin_expense_parking_label": "Parking:",
      "admin_expense_taxi_label": "Taxi:",
      "admin_expense_other_label_short": "Other ({{desc}}):",
      "admin_expense_tickets_attached": "Attached receipts/tickets ({{count}})",
      "admin_photo_source_admin": "(Admin)",
      "admin_photo_source_driver": "(Driver)",
      "admin_photos_completion_notice": "Photos uploaded when completing the service",
      "admin_photos_dialog_caption_driver_admin": "Service photos (driver and/or admin)",
      "admin_photo_pickup_alt": "Pickup {{n}}",
      "admin_photo_delivery_alt": "Delivery {{n}}",
      "admin_photo_contract_alt": "Contract {{n}}",
      "admin_photo_expense_alt": "Expense {{n}}",
      "admin_photo_ticket_label": "Ticket {{n}}",
      "admin_photo_contract_label": "Contract {{n}}",
      "admin_dialog_order_vehicle_line": "Service #{{id}} — {{brand}} {{model}} ({{plate}})",
      "admin_photo_numbered": "Photo {{n}}",
      "admin_expense_click_enlarge": "Click the image to enlarge",
      "admin_expense_click_enlarge_download": "Click the image to enlarge or use the \"{{download}}\" button",
      "admin_expense_no_receipts": "No receipts were attached to this report",
      "admin_charge_espera": "Waiting",
      "admin_charge_pit_stop": "Pit stop",
      "admin_charge_itv": "ITV (inspection)",
      "admin_charge_express": "Express",
      "admin_charge_recogida_extra": "Extra pickup",
      "admin_charge_cambio_ruta": "Route change",
      "admin_charge_otros": "Other",
      "admin_assign_rate": "Assign Rate",
      "admin_assign_rate_dialog_title": "Assign rate to client",
      "admin_assign_rate_dialog_desc": "Select a client and the rate template you want to assign",
      "admin_assign_rate_client_field": "Client *",
      "admin_assign_rate_template_field": "Rate template *",
      "admin_assign_rate_option_general": "General rate (default)",
      "admin_assign_rate_replace_warning": "⚠️ If the client already has a rate assigned, it will be replaced.",
      "admin_create_new_template_singular": "Create New Pricing Template",
      "admin_define_template_desc": "Define a name and description for the new pricing template",
      "admin_template_placeholder_vip": "e.g. VIP Rate Madrid",
      "admin_template_description_optional": "Description (optional)",
      "admin_template_placeholder_special": "e.g. Special rate for VIP clients in Madrid",
      "admin_no_custom_templates": "No custom templates.",
      "admin_click_new_template_to_create": "Click \"New Template\" to create one.",
      "admin_custom_pricing_clients_title": "Custom Client Rates",
      "admin_custom_pricing_subtitle": "Manage rate templates and assign them to specific clients",
      "admin_clients_and_assigned_rates": "Clients and their Assigned Rates",
      "admin_clients_assigned_rates_description": "All registered clients and the rate they are using",
      "admin_no_clients_registered": "No clients registered",
      "admin_assigned_rate": "Assigned Rate",
      "admin_general_rate": "General Rate",
      "admin_custom_rate": "Custom Rate",
      "admin_change": "Change",
      "admin_email_header": "Email",
      "admin_default_badge": "Default",
      "admin_standard_rate_default": "Standard rate applied by default to all clients",
      "admin_clients_count": "{{count}} clients",
      "admin_available_rate_templates": "Available Rate Templates",
      "admin_manage_templates_assign_clients": "Manage the rate templates you can assign to clients",
      "admin_distance_ranges": "Distance Ranges",
      "admin_add_rate": "Add Rate",
      "admin_add_rate_to": "Add Rate to {{name}}",
      "admin_add_rate_dialog_desc": "Define a distance range and prices for each service type",
      "admin_price_delivery_eur": "Delivery Price (€)",
      "admin_price_bc_eur": "B-C Price (€)",
      "admin_price_tradein_eur": "TRADE-IN Price (€)",
      "admin_price_representation_eur": "Representation Price (€)",
      "admin_template_clidrive_name": "Clidrive Rate",
      "admin_template_clidrive_description": "Special rates for Clidrive",
      "admin_client_invoices_subtitle": "Manage and generate invoices for client services",
      "admin_client_invoice_period_card_title": "Period to invoice",
      "admin_client_period_services_included": "Services included in this period",
      "admin_billing_period_no_services": "No services in this period",
      "admin_upload_client_invoice_title": "Upload client invoice",
      "admin_upload_client_invoice_desc": "Upload the PDF of the invoice generated externally (Holded or another system).",
      "admin_upload_client_invoice_pdf_label": "PDF file *",
      "admin_upload_client_invoice_number_label": "Invoice number *",
      "admin_upload_client_invoice_date_label": "Invoice date *",
      "admin_upload_client_invoice_submit": "Upload invoice",
      "admin_no_documents_for_driver": "No documents available for this driver.",
      "admin_generate_invoices": "Generate Invoices",
      "admin_current_period_in_progress": "Current period – In progress",
      "admin_services_period": "Services: {{start}} - {{end}}",
      "admin_billing_expected": "Expected billing: {{start}} - {{end}}",
      "admin_no_services_pending_invoice": "No services pending to invoice",
      "admin_metric_clients": "Clients",
      "admin_metric_services": "Services",
      "admin_taxable_base": "Taxable Base",
      "admin_total_with_vat": "Total with VAT",
      "admin_invoices_col_client": "CLIENT",
      "admin_invoices_col_services": "SERVICES",
      "admin_invoices_col_base": "BASE",
      "admin_invoices_col_iva": "VAT (21%)",
      "admin_invoices_col_total": "TOTAL",
      "admin_invoices_col_actions": "ACTIONS",
      "admin_view_detail": "View Detail",
      "admin_hide": "Hide",
      "admin_services_detail": "Service Details",
      "admin_invoices_col_date": "DATE",
      "admin_invoices_col_plate": "PLATE",
      "admin_service_id_col": "REF.",
      "admin_invoices_col_vehicle": "VEHICLE",
      "admin_invoices_col_type": "TYPE",
      "admin_invoices_col_extras": "EXTRAS",
      "admin_nif_label": "VAT ID",
      "admin_generate_client_invoices_title": "Generate Client Invoices",
      "admin_generate_client_invoices_desc": "Generate invoices for the selected period. Only delivered services will be included.",
      "admin_fortnight_type": "Fortnight Type",
      "admin_quincena_1_option": "Fortnight 1 (Serv. 25-9 → Invoice 10-15)",
      "admin_quincena_2_option": "Fortnight 2 (Serv. 10-24 → Invoice 25-end)",
      "admin_quincena_1_option_driver": "Fortnight 1 (Serv. 25-9 → Pay 10-15)",
      "admin_quincena_2_option_driver": "Fortnight 2 (Serv. 10-24 → Pay 25-end)",
      "admin_year": "Year",
      "admin_month_of_payment": "Month (of payment)",
      "admin_period_summary": "Period summary:",
      "admin_services_period_short": "Services: {{range}}",
      "admin_billing_period_short": "Billing: {{range}}",
      "admin_payment_period_short": "Payment: {{range}}",
      "admin_billing_25_end": "25-end",
      "admin_generating": "Generating...",
      "admin_driver_liquidations_title": "Driver Liquidations",
      "admin_driver_liquidations_subtitle": "Manage driver payments and liquidations",
      "admin_generate_liquidations": "Generate Liquidations",
      "admin_generate_liquidations_desc": "Generate liquidations for the selected period. Only services with approved expenses will be included.",
      "admin_generation_stopped": "Generation stopped",
      "admin_generation_stopped_reason": "No liquidations were generated: {{reason}}",
      "admin_payment_periods": "Payment Periods",
      "admin_quincena_1_desc": "Fortnight 1: Services from 25th to 9th → Payment from 10th to 15th",
      "admin_quincena_2_desc": "Fortnight 2: Services from 10th to 24th → Payment from 25th to last day",
      "admin_only_approved_expenses": "Only services with approved expenses are included",
      "admin_liquidation_calendar_split_hint": "From the 25th onward, the “In progress” tab shows the period from the 25th through the 9th of the following month—not the 10th–24th half-month that just closed. That closed half-month appears under “Pending to bill”.",
      "admin_liquidation_unapproved_banner": "{{count}} service(s) in this date range have a driver assigned but are not admin-approved yet (they do not count toward settlement until approval_status is “Approved”). Review them under Services → Pending approval or on each service page.",
      "admin_liquidation_banner_preview_line": "{{count}} completed service(s) pending settlement approval are listed below as a preview. Provisional base €{{amount}} — excluded from totals until approved.",
      "admin_liquidation_preview_section_title": "Preview — pending settlement approval",
      "admin_liquidation_preview_section_note": "These trips are completed or delivered but do not count toward the official settlement until you approve billing on each service. Amounts here are indicative (driver base only); they do not include VAT, IRPF, or the final breakdown.",
      "admin_liquidation_preview_col_settlement": "Settlement",
      "admin_liquidation_row_preview_only_badge": "Preview only",
      "admin_liquidation_generate_disabled_until_approved": "You cannot generate liquidations while the approved total is zero—approve the completed services first.",
      "admin_settlement_chip_tooltip": "Driver settlement status (approval_status)",
      "admin_settlement_chip_ok": "Settled ✓",
      "admin_settlement_chip_need_approval": "Approve settlement",
      "admin_settlement_chip_rejected": "Settled ✕",
      "admin_settlement_chip_open": "Not approved",
      "admin_pending_expense_approval_count": "{{count}} completed service(s) pending admin approval on the order — separate from expense reports in the list below",
      "admin_pending_expense_reports": "Pending Expense Reports ({{count}})",
      "admin_approve_reject_expenses_desc": "Approve or reject expenses reported by drivers",
      "admin_no_pending_reports": "There are no pending reports for approval",
      "admin_billing_periods_title": "Billing Periods",
      "admin_billing_periods_subtitle": "Liquidations grouped by payment period",
      "admin_loading_periods": "Loading periods...",
      "admin_in_progress": "In progress",
      "admin_invoice_pending": "Invoice pending",
      "admin_period_closed_ready_to_bill": "Period Closed, Ready to Bill",
      "admin_period_closed_generate_message": "This period has closed. Generate the settlements to process payments to drivers.",
      "admin_generate_settlements_first": "Generate settlements for this period first",
      "admin_billing_details": "Billing details",
      "admin_save_billing_data": "Save Data",
      "admin_realtime_accumulation": "Real-time accumulation",
      "admin_expected_payment": "Expected payment",
      "admin_services_count_label": "services",
      "admin_total_accumulated": "total accumulated",
      "admin_accumulating_status": "Accumulating",
      "admin_liquidation_fleet_owner_badge": "Fleet owner ({{count}})",
      "admin_tab_pending_to_bill": "Pending to bill",
      "admin_liquidation_status_paid": "Paid",
      "admin_liquidation_status_pending": "Pending",
      "admin_pending_period_banner_title": "{{label}} - Period closed, ready to bill",
      "admin_total_to_liquidate_label": "total to settle",
      "admin_no_pending_invoice_services": "No services pending invoicing",
      "admin_confirm_invoice_regenerate": "An invoice already exists. Regenerate with updated data?",
      "admin_confirm_invoice_regenerate_detail": "A new PDF will be generated from the current period data and will replace the stored invoice.",
      "admin_invoice_regenerate_confirm_btn": "Regenerate",
      "admin_services_detail_count": "Service details ({{count}})",
      "admin_route_col": "ROUTE",
      "admin_rate_col": "RATE",
      "admin_totals_label": "Totals:",
      "admin_liquidation_footer_drivers": "{{count}} driver(s) in this period",
      "admin_liquidation_footer_total_base": "Total Base:",
      "admin_liquidation_footer_total_supplies": "Total Supplies:",
      "admin_liquidation_footer_total_to_pay": "Total to Pay:",
      "admin_amounts_update_note": "Amounts update as expenses are approved. Liquidation is generated when the period is closed.",
      "admin_liquidated": "LIQUIDATED",
      "admin_driver_col": "DRIVER",
      "admin_supplies_col": "SUPPLIES",
      "admin_irpf_col": "INCOME TAX",
      "admin_status_col": "STATUS",
      "admin_no_drivers_match": "No drivers found with that name",
      "admin_no_approved_pending_liquidation": "There are no approved services pending liquidation",
      "admin_no_drivers_in_period": "No drivers in this period",
      "admin_reported_label": "Reported",
      "admin_expense_driver": "Driver",
      "admin_expense_fuel": "Fuel",
      "admin_expense_toll": "Tolls",
      "admin_expense_parking": "Parking",
      "admin_expense_taxi": "Taxi",
      "admin_expense_other": "Other",
      "admin_other_expenses_label": "Other expenses:",
      "admin_tickets_receipts": "Tickets and Receipts ({{count}})",
      "admin_ticket_label": "Ticket",
      "admin_approve_btn": "Approve",
      "admin_reject_btn": "Reject",
      "admin_reject_reason_prompt": "Rejection reason:",
      "admin_hide_services": "Hide services",
      "admin_view_services": "View services",
      "admin_payment_label": "Payment",
      "admin_approvals_subtitle": "Review and approve services completed by drivers",
      "admin_services_pending_approval_title": "Services Pending Approval",
      "admin_services_pending_approval_desc": "Services that have been completed and are awaiting approval",
      "admin_no_services_pending_approval": "There are no services pending approval",
      "admin_vehicle_label": "Vehicle",
      "admin_origin_label": "Origin",
      "admin_destination_label": "Destination",
      "admin_total_price_label": "Total Price",
      "admin_service_status_label": "Service Status",
      "admin_service_type_label": "Service Type",
      "admin_pending_approval_badge": "Pending Approval",
      "admin_photos_pickup_label": "Pickup Photos",
      "admin_photos_delivery_label": "Delivery Photos",
      "admin_expenses_label": "Expenses",
      "admin_view_photos_btn": "View Photos",
      "admin_profiles_title": "Profiles",
      "admin_profiles_subtitle": "View and manage client and driver profiles",
      "admin_profiles_subtitle_drivers_only": "View and manage your assigned drivers' profiles",
      "admin_profiles_clients_tab": "Client Profiles",
      "admin_profiles_drivers_tab": "Driver Profiles",
      "admin_profiles_fleets_tab": "Fleet Management",
      "admin_clients_registered": "Registered Clients",
      "admin_create_client": "Create Client",
      "admin_create_new_client": "Create New Client",
      "admin_create_new_client_desc": "Create a new client. A password will be automatically generated and sent by email.",
      "admin_create_client_password_info": "A random password will be generated and sent to the client's email along with their access credentials.",
      "admin_search_client_placeholder": "Search by name, DNI/NIF/CIF/NIE or email...",
      "admin_no_clients_search": "No clients found matching your search",
      "admin_no_clients_registered": "No registered clients",
      "admin_cif_dni_label": "CIF/DNI:",
      "admin_phone_label": "Phone:",
      "admin_address_label": "Address:",
      "admin_country_label": "Country:",
      "admin_registered_label": "Registered:",
      "admin_rate_label": "Rate:",
      "admin_not_specified": "Not specified",
      "admin_not_specified_f": "Not specified",
      "admin_view_details": "View Details",
      "admin_search_driver_profiles_placeholder": "Search by name, DNI/NIE, license or email...",
      "admin_no_drivers_search": "No drivers found matching your search",
      "admin_no_drivers_registered": "No registered drivers",
      "admin_driver_dni_label": "DNI/NIF:",
      "admin_driver_status_label": "Status:",
      "admin_available": "Available",
      "admin_not_available": "Not available",
      "admin_edit": "Edit",
      "admin_view_more": "View more",
      "admin_driver_badge_validated": "✓ Validated",
      "admin_driver_badge_pending": "⏳ Pending",
      "admin_driver_badge_expires_soon": "⚠️ Expires Soon",
      "admin_driver_badge_no_docs": "❌ No Documents",
      "admin_edit_client": "Edit Client",
      "admin_edit_client_desc": "Modify client information. The admin can edit everything, including email.",
      "admin_company_logo": "Company Logo",
      "admin_upload_logo": "Upload Logo",
      "admin_uploading": "Uploading...",
      "admin_logo_hint": "PNG, JPG • Max 2MB",
      "admin_name_required": "Name *",
      "admin_email_required": "Email *",
      "admin_email_change_warning": "Changing the email will affect client access",
      "admin_company_name": "Company Name",
      "admin_cif_dni": "CIF/DNI",
      "admin_phone": "Phone",
      "admin_country": "Country",
      "admin_address": "Address",
      "admin_country_placeholder": "ES, FR, etc.",
      "admin_payment_type": "Payment Type",
      "admin_payment_biweekly": "Biweekly (Transfer)",
      "admin_payment_instant": "Instant Payment (Virtual POS)",
      "admin_payment_biweekly_desc": "Invoiced every 15 days and paid by bank transfer",
      "admin_payment_instant_desc": "Charged when creating or editing services via Santander Virtual POS",
      "admin_save_changes": "Save Changes",
      "admin_documents_drivers_title": "Driver Documents",
      "admin_documents_subtitle": "Review and validate documents uploaded by drivers",
      "admin_documents_pending_expired_title": "Pending and Expired Documents",
      "admin_documents_require_attention": "Total: {{count}} documents require attention",
      "admin_no_documents_pending": "No documents pending validation",
      "admin_doc_confirm_approve_title": "Approve this document?",
      "admin_doc_confirm_approve_description": "It will be marked as validated.",
      "admin_doc_confirm_reject_title": "Reject this document?",
      "admin_doc_confirm_reject_description": "The driver will be notified. Enter the reason for rejection.",
      "admin_doc_reject_reason_placeholder": "Explain the reason for rejection…",
      "admin_doc_reject_reason_required": "Please enter a rejection reason.",
      "admin_document_label": "Document:",
      "admin_upload_date_label": "Upload date:",
      "admin_expiry_date_label": "Expiry date:",
      "admin_status_label": "Status:",
      "admin_status_expired": "⚠️ Expired",
      "driver_name_label": "Name",
      "driver_phone_label": "Phone",
      "driver_not_specified": "Not specified",
      "driver_type_label": "Type",
      "driver_fleet_member": "Fleet Member",
      "driver_independent": "Independent Driver",
      "driver_doc_status": "Document Status",
      "driver_docs_loading": "Loading documents...",
      "driver_documents": "Documents",
      "driver_view": "View",
      "driver_download": "Download",
      "driver_preview_title": "Preview",
      "driver_view_doc_tooltip": "View document in new tab",
      "driver_download_doc_tooltip": "Download document",
      "driver_delete_doc_tooltip": "Delete document",
      "driver_expires": "Expires:",
      "driver_bank_account": "Bank Account",
      "driver_tax_id": "Tax ID",

      // Messages
      "order_created": "Order created successfully!",
      "order_updated": "Order updated successfully!",
      "payment_success": "Payment completed successfully!",
      "payment_failed": "Payment failed. Please try again.",
      "error_occurred": "An error occurred. Please try again.",
      "auth_callback_no_session_id": "No session ID found",
      "address_toast_selected": "✓ Address selected successfully",
      "address_toast_no_coords": "Could not get coordinates for this address",
      "address_toast_init_error": "Error initializing autocomplete. Use the city buttons.",
      "address_toast_city_selected": "✓ City selected: {{city}}",
      "address_toast_coords_set": "✓ Coordinates set successfully",
      "address_toast_invalid_coords": "Invalid coordinates. Lat: -90 to 90, Lng: -180 to 180",
      "address_toast_coords_extracted": "✓ Coordinates extracted from Google Maps link",
      "address_toast_coords_extract_error": "Could not extract coordinates from link",
      "address_toast_select_suggestions": "Please select an address from the suggestions",
      "address_toast_error_get_details": "Error getting address details",
      "forgot_toast_success": "A recovery link has been sent to your email",
      "forgot_toast_error": "Error processing your request",
      "forgot_toast_error_send": "Error sending email",
      "forgot_toast_email_not_sent": "If your email is registered, we could not send the message. Please contact support.",
      "forgot_network_error": "Network error",
      "forgot_title": "Recover Password",
      "forgot_description": "Enter your email and we will send you instructions",
      "forgot_email_label": "Email Address",
      "forgot_email_placeholder": "your@email.com",
      "forgot_sending": "Sending...",
      "forgot_submit": "Send Recovery Link",
      "forgot_back_login": "Back to login",
      "change_password_mismatch": "Passwords do not match",
      "change_password_min_length": "Password must be at least 6 characters",
      "change_password_success": "Password updated successfully",
      "change_password_error": "Error changing password",
      "change_password_description": "Please set a new secure password",
      "change_password_first_login_description": "First-time setup: choose a new secure password. You do not need to re-enter the password you just used to sign in.",
      "change_password_current_required": "Please enter your current password",
      "change_password_btn": "Update Password",
      "change_password_updating": "Updating...",
      "show_password": "Show password",
      "hide_password": "Hide password",
      "admin_login_toast_success": "Login successful!",
      "admin_login_toast_error": "Invalid email or password",
      "admin_back_to_home": "Back to home",
      "admin_sign_in": "Sign in",
      "admin_signing_in": "Signing in...",
      "staff_portal_title": "Sign in",
      "staff_portal_subtitle": "Sign in as driver or administrator",
      "staff_portal_tab_driver": "Driver",
      "staff_portal_tab_admin": "Admin",
      "staff_portal_admin_banner": "Admin portal",
      "staff_portal_admin_desc": "Manage your transport operations",
      "client_login_welcome": "Welcome!",
      "client_login_error": "Error signing in",
      "client_toast_no_session": "No active session. Please sign in again.",
      "client_toast_preparing_contract": "Preparing contract...",
      "client_toast_contract_generated": "Contract generated. If it doesn't download automatically, check your pop-up blocker.",
      "client_toast_error_download_contract": "Error downloading contract",
      "client_toast_error_load_invoices": "Error loading invoices",
      "client_toast_photos_pending_approval": "Photos are pending admin approval",
      "client_toast_photos_not_available": "Photos are not available yet",
      "client_toast_no_photos_yet": "No photos available yet",
      "client_toast_error_load_photos": "Error loading photos",
      "client_toast_no_expenses_yet": "No approved expenses yet",
      "client_toast_error_load_expenses": "Error loading expenses",
      "client_toast_error_load_completion": "Error loading completion details",
      "client_incident_fetch_failed": "Could not load the information",
      "client_incident_fetch_error": "Error loading",
      "client_validation_bc_second_vehicle": "For B-C services you must add the second vehicle details (brand and license plate)",
      "client_validation_bc_point_c": "For B-C services you must add the second vehicle delivery address (Point C)",
      "client_validation_bc_point_c_contact": "For B-C services you must add the Point C contact details",
      "client_validation_tradein_second_vehicle": "For trade-in services you must add the second vehicle details",
      "client_order_created_at_label": "Created:",
      "client_incident_badge": "Incident",
      "client_incident_title_hint": "Click to view incident details",
      "client_incident_loading_details": "Loading details...",
      "client_incident_type_fallback": "Incident reported",
      "client_incident_reported_label": "Reported:",
      "client_incident_resolved_label": "Resolved:",
      "client_incident_resolution_label": "Resolution:",
      "client_incident_resolution_cancelled_at_pickup": "Service cancelled at pickup",
      "client_incident_resolution_cancelled": "Service cancelled",
      "client_incident_resolution_delivered": "Service completed",
      "client_incident_generic_notice": "This service had an associated incident. The administrator was notified.",
      "client_sidebar_subtitle": "Client portal",
      "client_sidebar_section_general": "General",
      "client_sidebar_section_tracking": "Tracking",
      "client_sidebar_section_account": "Account",
      "client_sidebar_dashboard": "Dashboard",
      "client_loading_services": "Loading services...",
      "client_deliveries_tracking_subtitle": "Track your vehicle transports",
      "client_deliv_status_sin_reservar_label": "Unassigned",
      "client_deliv_status_sin_reservar_desc": "Waiting for a driver to accept the service",
      "client_deliv_status_reservado_label": "Reserved",
      "client_deliv_status_reservado_desc": "A driver has accepted the service",
      "client_deliv_status_en_proceso_label": "In progress",
      "client_deliv_status_en_proceso_desc": "The vehicle is being transported",
      "client_deliv_status_entregado_label": "Delivered",
      "client_deliv_status_entregado_desc": "Service completed",
      "client_deliv_status_cancelado_label": "Cancelled",
      "client_deliv_status_cancelado_desc": "Service cancelled",
      "client_date_not_specified": "Not specified",
      "client_plate_missing": "No plate",
      "client_deliveries_showing": "Showing:",
      "client_deliveries_empty_title": "No services",
      "client_deliveries_empty_filtered": "You have no services with status \"{{status}}\"",
      "client_deliveries_empty_hint": "Your transport services will appear here",
      "client_deliv_view_tracking": "View tracking",
      "client_deliv_assigned_driver": "Assigned driver",
      "client_deliv_distance_prefix": "Distance",
      "client_deliv_notes_heading": "Notes",
      "client_deliv_payment_status_label": "Payment status",
      "client_inspections_modal_title": "Inspection",
      "client_inspections_photo_fallback": "Photo",
      "client_inspections_signature_title": "Responsible party signature",
      "client_inspections_signature_alt": "Signature",
      "client_inspections_done_by": "Performed by:",
      "client_inspections_fuel": "Fuel",
      "client_inspections_type_pickup": "Pickup",
      "client_inspections_type_delivery": "Delivery",
      "client_loading_inspections": "Loading inspections...",
      "client_inspections_title": "Vehicle inspections",
      "client_inspections_subtitle": "Inspection reports for your transported vehicles",
      "client_inspections_search_placeholder": "Search by license plate...",
      "client_inspections_stat_total": "Total inspections",
      "client_inspections_stat_no_damage": "No damage",
      "client_inspections_stat_with_damage": "With damage",
      "client_inspections_badge_pickup": "Pickup inspection",
      "client_inspections_badge_delivery": "Delivery inspection",
      "client_inspections_status_delivered": "Delivered",
      "client_inspections_status_in_progress": "In progress",
      "client_inspections_view_btn": "View inspection",
      "client_inspections_empty_title": "No inspections yet",
      "client_inspections_empty_search": "No results for your search",
      "client_inspections_empty_hint": "Inspection reports will appear here once drivers complete them",
      "client_inspections_vehicle_photos": "Vehicle photos ({{count}})",
      "client_inspections_photo_alt": "Photo {{n}}",
      "client_inspections_thumbnail_alt": "Thumbnail {{n}}",
      "client_inspections_photo_prev_aria": "Previous photo",
      "client_inspections_photo_next_aria": "Next photo",
      "client_inspections_ai_label": "AI analysis:",
      "client_inspections_ai_summary_title": "Analysis summary",
      "client_inspections_vehicle_state": "Vehicle condition",
      "client_inspections_damages_detected": "Damage detected:",
      "client_inspections_no_damage_ai": "✓ No damage detected",
      "client_inspections_odometer": "Odometer",
      "client_inspections_general_condition": "General condition",
      "client_gps_loading_vehicles": "Loading vehicles on route...",
      "client_gps_subtitle": "Monitor your vehicles in transit in real time",
      "client_gps_on_route_count": "{{count}} on route",
      "client_gps_last_update": "Last updated:",
      "client_gps_auto_refresh": "(Auto-refresh every 30s)",
      "client_gps_map_title": "Vehicle map",
      "client_gps_vehicles_on_route": "{{count}} vehicle on route",
      "client_gps_vehicles_on_route_plural": "{{count}} vehicles on route",
      "client_gps_loading_map": "Loading map...",
      "client_gps_empty_title": "No vehicles on route right now",
      "client_gps_empty_hint": "When a driver starts a transport, it will appear on the map",
      "client_gps_legend_vehicle": "Vehicle on route",
      "client_gps_legend_click": "Click a vehicle to see its exact location",
      "client_gps_card_en_route": "On route",
      "client_gps_route_origin": "Origin",
      "client_gps_route_destination": "Destination",
      "client_gps_eta_label": "ETA to destination:",
      "client_gps_eta_calculating": "Calculating ETA...",
      "client_gps_last_position": "Last position:",
      "client_gps_detail_suffix": "Details",
      "client_gps_call_driver": "Call driver",
      "client_gps_label_vehicle": "Vehicle",
      "client_gps_label_driver": "Driver",
      "client_gps_label_origin": "Origin",
      "client_gps_label_destination": "Destination",
      "client_gps_label_current_location": "Current location",
      "client_gps_infowindow_current_location": "Current location:",
      "client_gps_infowindow_destination": "Destination:",
      "client_gps_infowindow_eta_title": "ETA to destination",
      "client_gps_infowindow_eta_remaining": "remaining",
      "client_gps_infowindow_eta_calculating": "Calculating ETA...",
      "client_gps_infowindow_driver": "Driver:",
      "client_na": "N/A",
      "driver_doc_upload_click_to_select": "Click to select a file",
      "driver_doc_upload_formats_hint": "PDF, JPG or PNG (max. 10MB)",
      "driver_doc_upload_pending_note": "This document will replace the previous one and will be pending approval.",
      "client_toast_distance_calculated": "Distance calculated: {{distance}} km - Price: €{{price}}",
      "client_toast_error_calculate_distance": "Error calculating distance",
      "client_toast_service_cancelled_fee": "Service cancelled: {{status}}. Charge: €{{fee}}",
      "client_toast_error_cancel_service": "Error cancelling service",
      "client_toast_price_updated": "Price updated",
      "client_toast_error_calculate_price": "Error calculating price",
      "client_toast_enter_valid_distance": "Enter a valid distance",
      "client_completion_waiting_extras": "Waiting time / Extras",
      "client_completion_extras_total": "Extras total (excl. VAT)",
      "service_toast_load_failed": "Could not load service",
      "service_toast_error_load": "Error loading service",
      "service_toast_updated": "Service updated successfully",
      "service_toast_error_update": "Error updating",
      "service_toast_error_update_service": "Error updating service",
      "service_toast_error_upload_file": "Error uploading {{fileName}}",
      "service_toast_photos_uploaded": "{{count}} photo(s) uploaded",
      "service_toast_error_upload_photos": "Error uploading photos",
      "service_toast_completed": "Service completed successfully",
      "service_toast_error_complete": "Error completing",
      "service_toast_error_complete_service": "Error completing service",
      "service_toast_reverted": "Service reverted successfully",
      "service_toast_error_revert": "Error reverting",
      "service_toast_error_revert_service": "Error reverting service",
      "service_toast_deleted": "Service deleted",
      "service_toast_error_delete": "Error deleting",
      "service_toast_error_delete_service": "Error deleting service",
      "service_toast_cancelled": "Service cancelled",
      "service_toast_error_cancel": "Error cancelling",
      "service_toast_error_cancel_service": "Error cancelling service",
      "service_toast_contract_downloaded": "Contract downloaded",
      "service_toast_contract_fallback_simple_pdf": "Simplified PDF (Playwright failed). Windows: from the backend folder run \"python run_dev_api.py\" (do not use plain \"uvicorn --reload\"). Linux/server: python -m playwright install chromium",
      "service_toast_error_generate_contract": "Error generating contract",
      "service_toast_error_download_contract": "Error downloading contract",
      "service_toast_opening_calendar": "Opening Google Calendar...",
      "service_detail_loading": "Loading service...",
      "service_detail_back": "Back",
      "service_detail_title": "Service #{{id}}",
      "service_detail_print": "Print",
      "service_detail_price_client_short": "Client price",
      "service_detail_price_driver_short": "Driver price",
      "service_detail_vehicle_heading": "VEHICLE",
      "service_detail_type": "Type",
      "service_detail_fuel_default": "Gasoline",
      "service_detail_documents_heading": "DOCUMENTS",
      "service_detail_download_transport_contract": "Download transport contract",
      "service_detail_assign_driver_for_contract": "Assign a driver to generate the contract",
      "service_detail_photos_heading": "PHOTOS",
      "service_detail_view_service_photos": "View service photos",
      "service_detail_actions_heading": "Actions",
      "service_detail_edit_service": "Edit service",
      "service_detail_complete_service": "Complete service",
      "service_detail_revert_to_in_progress": "Revert to in progress",
      "service_detail_add_to_calendar": "Add to calendar",
      "service_detail_cancel_service": "Cancel service",
      "service_detail_edit_dialog_title": "Edit service",
      "service_detail_label_status": "Status",
      "service_detail_label_driver": "Driver",
      "service_detail_no_driver_option": "Unassigned",
      "service_detail_label_distance_km": "Distance (km)",
      "service_detail_label_client_price_eur": "Client price (€)",
      "service_detail_label_driver_price_eur": "Driver price (€)",
      "service_detail_label_pickup_address": "Pickup address",
      "service_detail_label_delivery_address": "Delivery address",
      "service_detail_label_notes": "Notes",
      "service_detail_complete_dialog_title": "Complete service",
      "service_detail_complete_dialog_desc": "Add expenses and photos to complete the service",
      "service_detail_expenses_heading": "Expenses",
      "service_detail_label_parking": "Parking (€)",
      "service_detail_label_completion_notes": "Completion notes",
      "service_detail_photos_section": "Photos",
      "service_detail_label_pickup_photos_count": "Pickup photos ({{count}})",
      "service_detail_label_delivery_photos_count": "Delivery photos ({{count}})",
      "service_detail_label_expense_tickets_count": "Expense tickets ({{count}})",
      "service_detail_label_signed_contract_count": "Signed contract ({{count}})",
      "service_detail_cancel_dialog_title": "Cancel service",
      "service_detail_cancel_dialog_desc": "Choose the cancellation type",
      "service_detail_cancel_normal": "Standard cancellation",
      "service_detail_cancel_at_pickup": "Cancel at pickup (vehicle unavailable)",
      "service_detail_cancel_in_transit": "Cancel in transit",
      "service_detail_close": "Close",
      "service_detail_photos_dialog_title": "Service photos",
      "service_detail_loading_photos": "Loading photos...",
      "service_detail_pickup_photos_heading": "Pickup photos",
      "service_detail_delivery_photos_heading": "Delivery photos",
      "service_detail_no_photos": "No photos available",
      "service_detail_contact": "Contact:",
      "service_detail_pickup_otp_whatsapp": "Pickup confirmation code (same as WhatsApp to contact)",
      "service_detail_delivery_otp_whatsapp": "Delivery confirmation code (WhatsApp)",
      "service_calendar_event_body": "AutoGo service\nVehicle: {{brand}} {{model}} ({{plate}})\nDriver: {{driver}}\n\n📍 Pickup: {{pickup}}\n📍 Delivery: {{delivery}}",
      "driver_complete_dialog_title": "Complete service #{{id}}",
      "driver_complete_status_done": "Done",
      "driver_complete_section_pickup": "📦 Pickup photos",
      "driver_complete_section_delivery": "🎯 Delivery photos",
      "driver_complete_section_contract": "📝 Signed contract",
      "driver_complete_section_expenses": "💰 Expense report",
      "driver_complete_pickup_hint": "Upload photos of the vehicle at pickup (exterior and interior)",
      "driver_complete_delivery_hint": "Upload photos of the vehicle at delivery (exterior and interior)",
      "driver_complete_contract_hint": "Upload photo(s) of the transport contract signed by the customer",
      "driver_complete_photo_count": "{{count}} photo(s)",
      "driver_complete_pickup_done": "✓ Pickup photos uploaded",
      "driver_complete_delivery_done": "✓ Delivery photos uploaded",
      "driver_complete_contract_done": "✓ Contract uploaded",
      "driver_complete_expense_intro": "Report service expenses (you can enter 0 if there were none)",
      "driver_expense_parking": "Parking (€)",
      "driver_expense_taxi": "Taxi (€)",
      "driver_expense_other_label": "Other (€)",
      "driver_expense_other_description": "Other description",
      "driver_complete_receipt_photos_label": "📸 Invoice/ticket photos (optional)",
      "driver_complete_invoice_count": "{{count}} receipt(s)",
      "driver_complete_expense_done": "✓ Expense report already sent",
      "driver_complete_service_status_title": "Service status:",
      "driver_complete_summary_pickup": "Pickup photos",
      "driver_complete_summary_delivery": "Delivery photos",
      "driver_complete_summary_contract": "Signed contract",
      "driver_complete_summary_expenses": "Expense report",
      "driver_complete_finish": "✓ Finish",
      "driver_complete_section_batch_hint": "These files upload when you tap Upload all below.",
      "driver_complete_contract_optional_batch": "Optional for submission; add it if you already have the signed contract.",
      "driver_complete_extra_docs_batch_hint": "Optional. Included when you tap Upload all.",
      "driver_complete_submit_all": "Upload all & submit",
      "driver_complete_submit_all_desc": "Fill any sections that still need data, then tap once: photos, expenses, and extra documents are sent in order.",
      "driver_complete_submitting_all": "Uploading…",
      "driver_complete_validation_pickup": "Add at least one pickup photo.",
      "driver_complete_validation_delivery": "Add at least one delivery photo.",
      "driver_complete_validation_other_desc": "If “Other expenses” is above 0, add a short description.",
      "driver_complete_nothing_to_upload": "Nothing new to upload. Add files or check the checklist.",
      "driver_complete_all_uploaded_ok": "Everything uploaded successfully. The service will be pending review if applicable.",
      "driver_complete_batch_failed": "Upload could not finish. Check your connection and try again.",
      "driver_complete_locked": "This service is already closed or approved.",
      "driver_download_contract": "Download contract",
      "driver_fleet_assign_service": "Assign service",
      "driver_fleet_reassign_service": "Reassign service",
      "driver_fleet_assign_desc": "Choose who will perform this service. An email with the contract will be sent automatically.",
      "driver_fleet_service_block_title": "Service:",
      "driver_fleet_current_assignee": "Currently assigned to:",
      "driver_toast_contract_downloaded": "Contract downloaded successfully",
      "driver_toast_error_download_contract": "Error downloading contract",
      "driver_toast_error_load_drivers": "Error loading drivers",
      "driver_toast_driver_created": "Driver created. Documents pending admin approval.",
      "driver_toast_driver_created_with_password": "Driver created successfully. ⚠️ Temporary password: {{temp_password}}. Please share it with the driver.",
      "driver_toast_error_create_driver": "Error creating driver: {{message}}",
      "driver_error_create_driver_fallback": "Error creating driver",
      "driver_toast_driver_updated": "Driver updated successfully",
      "driver_toast_error_update_driver": "Error updating driver",
      "driver_toast_driver_deleted": "Driver deleted successfully",
      "driver_toast_error_delete_driver": "Error deleting driver",
      "driver_toast_service_assigned_self": "Service assigned to yourself.",
      "driver_toast_service_reassigned": "Service reassigned successfully. Email sent.",
      "driver_toast_service_assigned": "Service assigned successfully. Email sent.",
      "driver_toast_service_started": "Service started",
      "driver_toast_error_assign_service": "Error assigning service",
      "driver_toast_logged_out": "Logged out",
      "driver_toast_error_load_billing_periods": "Error loading billing periods",
      "driver_toast_error_load_period_details": "Error loading period details",
      "driver_toast_error_load_incomplete_services": "Error loading incomplete services",
      "driver_toast_complete_required_fields": "Please complete all required fields",
      "driver_toast_profile_updated": "Profile updated successfully",
      "driver_toast_new_iban_next_invoice": "The new account number will be used on your next invoice",
      "driver_toast_error_update_profile": "Error updating profile",
      "driver_toast_error_save_changes": "Error saving changes",
      "driver_toast_member_updated": "Member updated successfully.",
      "driver_toast_member_updated_with_docs": "Member updated successfully. {{count}} document(s) uploaded.",
      "driver_toast_error_update_member": "Error updating member",
      "driver_toast_select_file": "Please select a file",
      "driver_toast_document_uploaded": "Document uploaded successfully",
      "driver_toast_error_upload_document": "Error uploading document",
      "driver_toast_select_at_least_one_photo": "Select at least one photo",
      "driver_toast_pickup_photos_uploaded": "Pickup photos uploaded successfully",
      "driver_toast_error_upload_photos": "Error uploading photos",
      "driver_toast_error_upload_pickup_photos": "Error uploading pickup photos",
      "driver_toast_delivery_photos_uploaded": "Delivery photos uploaded successfully",
      "driver_toast_error_upload_delivery_photos": "Error uploading delivery photos",
      "driver_toast_select_contract_photo": "Select at least one contract photo",
      "driver_toast_contract_uploaded": "Contract uploaded successfully",
      "driver_toast_error_upload_contract": "Error uploading contract",
      "driver_toast_expense_report_sent": "Expense report sent successfully",
      "driver_toast_error_send_report": "Error sending report",
      "driver_toast_error_connection_expense_report": "Error connecting while sending expense report",
      "driver_toast_service_completed": "Service completed successfully",
      "driver_toast_invalid_server_response": "Invalid server response",
      "driver_toast_incident_reported": "Incident reported successfully. The admin will be notified.",
      "driver_toast_error_report_incident": "Error reporting incident",
      "driver_toast_contract_photo_added": "Contract photo added",
      "driver_toast_vehicle_photo_added": "Vehicle photo added",
      "driver_toast_image_process_error": "Error processing the image",
      "admin_toast_error_load_photos": "Error loading photos",
      "admin_toast_error_load_expenses": "Error loading expenses",
      "admin_toast_failed_load_data": "Failed to load data",
      "admin_toast_error_load_billing": "Error loading billing data",
      "admin_toast_partial_load": "Some data could not be loaded. Refresh the page to try again.",
      "admin_toast_error_generate_liquidations": "Error generating liquidations",
      "admin_toast_error_generate_client_invoices": "Error generating client invoices",
      "admin_toast_excel_downloaded": "Excel downloaded",
      "admin_toast_provisional_excel_no_orders": "There are no services in this row to export to Excel yet.",
      "admin_toast_error_download_excel": "Error downloading Excel",
      "admin_toast_error_load_period_details": "Error loading period details",
      "admin_toast_error_load_period_trips": "Error loading period trips",
      "admin_toast_driver_profile_incomplete": "Driver profile is incomplete. Please edit the driver and complete all billing fields (full name, ID, fiscal address, bank and account).",
      "admin_toast_error_generate_invoice": "Error generating invoice. Please ensure the driver has all billing details complete.",
      "admin_toast_select_charge_and_amount": "Select a charge type and enter the amount",
      "admin_toast_error_update_report": "Error updating report",
      "admin_toast_period_marked_paid": "Period marked as paid",
      "admin_toast_error_mark_period_paid": "Error marking period as paid",
      "admin_toast_failed_save_driver": "Failed to save driver",
      "admin_toast_driver_deleted": "Driver deleted successfully",
      "admin_toast_failed_delete_driver": "Failed to delete driver",
      "admin_toast_error_save_rate": "Error saving rate",
      "admin_toast_pricing_deleted": "Pricing deleted successfully",
      "admin_toast_failed_delete_pricing": "Failed to delete pricing",
      "admin_toast_error_save_service": "Error saving service",
      "admin_toast_service_deleted": "Service deleted successfully",
      "admin_toast_error_delete_service": "Error deleting service",
      "admin_toast_template_created": "Pricing template created successfully",
      "admin_toast_error_create_template": "Error creating template",
      "admin_toast_template_deleted": "Template deleted successfully",
      "admin_toast_error_delete_template": "Error deleting template",
      "admin_toast_rate_added": "Rate added successfully",
      "admin_toast_rate_deleted": "Rate deleted successfully",
      "admin_toast_error_delete_rate": "Error deleting rate",
      "admin_toast_rate_assigned": "Rate assigned to client successfully",
      "admin_toast_error_assign_rate": "Error assigning rate",
      "admin_toast_custom_rate_removed": "Custom rate removed. Client uses general rates.",
      "admin_toast_error_remove_assignment": "Error removing assignment",
      "admin_toast_client_updated": "Client updated successfully",
      "admin_toast_error_update_client": "Error updating client",
      "admin_toast_driver_updated": "Driver updated successfully",
      "admin_toast_error_open_document": "Error opening document",
      "admin_toast_error_view_document": "Error viewing document",
      "admin_incident_type_pickup_unavailable": "Vehicle not available at pickup",
      "admin_incident_type_vehicle_breakdown": "Breakdown / tow truck",
      "admin_incident_type_accident": "Accident",
      "admin_incident_type_minor_damage": "Minor damage",
      "admin_incident_type_delay": "Delay",
      "admin_incident_type_other": "Other incident",
      "admin_incident_reported_on": "Reported on {{datetime}}",
      "admin_incident_service_info_heading": "Service information",
      "admin_incident_vehicle_label": "Vehicle:",
      "admin_incident_driver_label": "Driver:",
      "admin_incident_btn_in_review": "In review",
      "admin_incident_btn_move_history": "Move to history",
      "admin_incident_description_heading": "Description",
      "admin_incident_cancellation_heading": "Cancellation reason",
      "admin_incident_photos_heading": "Attached photos",
      "admin_incident_contract_signed_caption": "Signed contract",
      "admin_incident_alt_contract": "Contract",
      "admin_incident_vehicle_photo_caption": "Vehicle photo",
      "admin_incident_alt_vehicle": "Vehicle",
      "admin_incident_admin_notes_heading": "Admin notes",
      "admin_incident_status_current_label": "Current status:",
      "admin_incident_order_status_label": "Service status:",
      "admin_incident_status_reported": "Reported",
      "admin_incident_status_in_progress_short": "In progress",
      "admin_incident_status_resolved": "Resolved",
      "admin_incident_sent_to_client_log": "[Sent to client: {{datetime}}]",
      "admin_incident_report_sent_to_client": "This report has already been sent to the client",
      "admin_incident_in_progress_notice": "In progress: this incident is being handled. When you are done reviewing it, mark it as resolved to move it to history.",
      "admin_incident_finalize_title": "Complete service from incident",
      "admin_incident_finalize_how_label": "How did the service end? *",
      "admin_incident_finalize_delivered_title": "Delivered",
      "admin_incident_finalize_delivered_help": "The service was completed (despite the incident)",
      "admin_incident_finalize_cancel_pickup_title": "Cancelled at pickup",
      "admin_incident_finalize_cancel_pickup_help": "The car was not available; the driver still showed up",
      "admin_incident_finalize_box_delivered_title": "Service completed",
      "admin_incident_finalize_box_delivered_body": "The service will enter the driver billing flow at the full price.",
      "admin_incident_finalize_box_cancel_title": "Pickup cancellation — driver fulfilled duty",
      "admin_incident_finalize_box_cancel_body": "Under cancellation rules: the driver was on site and is entitled to 100% compensation.",
      "admin_incident_finalize_box_cancel_footer": "The service will be included on the driver invoice at the full price.",
      "admin_incident_finalize_notes_label": "Admin notes",
      "admin_incident_finalize_notes_placeholder": "Additional notes on how it was resolved…",
      "admin_incident_finalize_expenses_label": "Driver expenses (if any)",
      "admin_incident_finalize_expenses_hint_cancel": "Travel, tolls, etc.",
      "admin_incident_finalize_confirm_delivered": "Confirm delivery",
      "admin_incident_finalize_confirm_compensation": "Confirm with compensation",
      "admin_incident_finalize_service_btn": "Complete service",
      "admin_incident_send_client_btn": "Send to client",
      "admin_liquidation_dialog_title": "Generate driver settlements",
      "admin_liquidation_dialog_description": "Generate settlements for the selected period. Only services with approved expenses are included.",
      "admin_client_invoice_dialog_title": "Generate client invoices",
      "admin_client_invoice_dialog_description": "Generate invoices for the selected period. Only delivered services are included.",
      "admin_liquidation_period_type": "Fortnight type",
      "admin_liquidation_quincena_1": "Fortnight 1 (svc. 25–9 → pay 10–15)",
      "admin_liquidation_quincena_2": "Fortnight 2 (svc. 10–24 → pay 25–last day)",
      "admin_client_invoice_q1": "Fortnight 1 (svc. 25–9 → invoice 10–15)",
      "admin_client_invoice_q2": "Fortnight 2 (svc. 10–24 → invoice 25–last day)",
      "admin_client_invoice_label_billing": "Invoicing:",
      "admin_liquidation_year_label": "Year",
      "admin_liquidation_payment_month_label": "Month (payment)",
      "admin_liquidation_period_summary": "Period summary:",
      "admin_liquidation_label_services": "Services:",
      "admin_liquidation_label_payment": "Payment:",
      "admin_liquidation_payment_suffix_last": "25–last day",
      "admin_liquidation_generate_btn": "Generate settlements",
      "admin_client_invoice_generate_btn": "Generate invoices",
      "admin_toast_liquidations_created": "{{count}} settlements generated",
      "admin_toast_liquidations_created_carried_suffix": " (includes {{carried}} services carried over from previous periods)",
      "admin_toast_no_approved_services_period": "No approved services in this period",
      "admin_toast_client_invoices_created": "{{count}} client invoices generated",
      "admin_toast_no_services_pending_invoice_period": "No services pending invoicing in this period",
      "admin_toast_invoice_generated_success": "Invoice {{number}} generated successfully",
      "admin_toast_invoice_regenerated_success": "Invoice {{number}} regenerated successfully",
      "admin_toast_server_error_generic": "Error {{status}}: {{message}}",
      "admin_toast_billing_update_failed_fallback": "Could not update data",
      "admin_liquidation_empty_driver_search": "No drivers found with that name",
      "admin_liquidation_empty_current_period": "No approved services pending settlement in the current period",
      "admin_liquidation_empty_pending_tab": "No services pending invoicing",
      "admin_liquidation_empty_period_no_drivers": "No drivers in this period",
      "admin_incidents_empty_active_title": "No active incidents",
      "admin_incidents_empty_history_title": "No history yet",
      "admin_incidents_empty_active_desc": "No incidents pending resolution",
      "admin_incidents_empty_history_desc": "No resolved incidents yet",
      "admin_tariff_label_colon": "Rate:",
      "admin_toast_invoice_created": "Invoice created: {{number}}",
      "admin_toast_incident_finalize_delivered_ok": "Service completed successfully",
      "admin_toast_incident_finalize_cancel_ok": "Service cancelled at pickup successfully",
      "admin_toast_incident_updated": "Incident updated",
      "admin_toast_error_update_incident": "Error updating incident",
      "admin_toast_incident_report_sent_client": "Incident report sent to the client",
      "admin_toast_error_send_incident_report_client": "Error sending report to the client",
      "admin_toast_error_finalize_service": "Error finalizing service",
      "admin_toast_no_pending_invoice_period": "No billing period pending to invoice",
      "admin_toast_select_fleet_owner_and_driver": "Select a fleet owner and at least one driver",
      "admin_toast_error_assign_drivers": "Error assigning drivers",
      "admin_toast_error_remove_driver_assignment": "Error removing driver",
      "admin_toast_error_create_fleet": "Error creating fleet",
      "admin_toast_driver_id_not_found": "Error: driver ID not found",
      "admin_toast_billing_data_updated": "Billing details updated",
      "admin_toast_error_apply_penalty": "Error applying penalty",
      "admin_toast_penalty_applied": "Penalty of €{{amount}} applied to {{name}}",
      "admin_toast_connection_error_with_message": "Connection error: {{message}}",
      "admin_toast_no_rate_for_km": "No rate found for {{distance}} km",
      "service_toast_created_ok": "Service created successfully",
      "admin_toast_file_too_large": "File is too large. Maximum 5MB.",
      "admin_toast_invalid_format": "Invalid format. Only JPG, PNG or PDF allowed.",
      "admin_toast_license_expiry_required": "Please enter the license expiry date",
      "admin_toast_dni_expiry_required": "Please enter the ID expiry date",
      "admin_toast_client_created": "Client created successfully. Welcome email sent.",
      "admin_toast_client_created_no_email": "Client created successfully. Welcome email could not be sent; please share credentials manually.",
      "admin_toast_error_upload_photos": "Error uploading photos",
      "admin_toast_service_completed_historic": "Service completed and moved to history",
      "admin_toast_error_connection_complete": "Connection error while completing service",
      "admin_toast_error_revert_service": "Error reverting service",
      "admin_toast_error_load_service_details": "Error loading service details",
      "admin_toast_complete_pickup_delivery": "Please complete pickup and delivery addresses",
      "admin_toast_delivery_date_required": "Set the service delivery date and time",
      "admin_toast_complete_vehicle_data": "Please complete vehicle data",
      "admin_toast_set_driver_price": "Please set the price for the driver",
      "admin_toast_logo_uploaded": "Logo uploaded successfully",
      "admin_toast_document_approved": "Document approved",
      "admin_toast_error_approve_document": "Error approving document",
      "admin_toast_document_rejected": "Document rejected. Email sent to driver.",
      "admin_toast_document_rejected_no_email": "Document rejected. Email could not be sent to driver.",
      "admin_toast_driver_created_no_email": "Driver created successfully. Welcome email could not be sent; share credentials manually.",
      "admin_toast_error_reject_document": "Error rejecting document",
      "admin_toast_select_rate_before_save": "You must select a rate for the driver (Basic (standard rate), Premium, Premium +10%, or Custom) before saving",
      "admin_toast_complete_all_fields": "Please complete all fields",
      "admin_toast_invoice_uploaded": "Invoice uploaded successfully",
      "admin_toast_period_marked_paid_short": "Period marked as paid",
      "admin_toast_error_mark_period_paid": "Error marking period as paid",
      "admin_toast_invoice_deleted": "Invoice deleted successfully",
      "admin_toast_error_delete_invoice": "Error deleting invoice",
      "admin_toast_period_no_services": "Period has no associated services",
      "admin_toast_warning_period_no_services": "This period has no services",
      "admin_toast_warning_services_not_found": "Services for this period were not found in the database",
      "admin_toast_service_not_found": "Service not found",
      "admin_toast_service_no_distance": "Service has no distance defined",
      "admin_toast_service_no_type": "Service has no type defined",
      "admin_toast_error_calculate_prices": "Error calculating prices",
      "admin_toast_driver_docs_not_validated": "This driver does not have validated documents. Cannot assign services.",
      "admin_toast_enter_distance_before_assign": "Please enter the service distance before assigning a driver.",
      "admin_toast_select_service_type_before_assign": "Please select the service type before assigning a driver.",
      "admin_toast_templates_not_loaded": "Error: Pricing templates not loaded. Please refresh the page.",
      "admin_toast_could_not_calculate_rates": "Could not calculate rates.",
      "admin_toast_error_calculate_rates": "Error calculating rates",
      "admin_toast_error_calculate_price_message": "Error calculating price: {{message}}",
      "admin_toast_enter_distance_before_rate": "Please enter distance before selecting rate",
      "admin_toast_select_type_before_rate": "Please select service type before selecting rate",
      "admin_toast_could_not_calculate_price": "Could not calculate price. Check distance and service type.",
      "admin_toast_error_calculate_rate_message": "Error calculating rate: {{message}}",
      "admin_toast_rate_updated": "Rate updated successfully",
      "admin_toast_error_update_rate": "Error updating rate",
      "admin_toast_template_name_required": "Template name is required",
      "admin_toast_template_created_short": "Template created successfully",
      "admin_toast_contract_downloaded_2pages": "Contract downloaded - 2 pages: Driver and Client",
      "admin_confirm_delete_driver": "Are you sure you want to delete this driver?",
      "admin_delete_driver_dialog_title": "Delete driver",
      "admin_confirm_delete_driver_detail": "{{name}} will be permanently removed. This action cannot be undone.",
      "admin_delete_pricing_rate_dialog_title": "Delete general rate",
      "admin_confirm_delete_pricing": "Are you sure you want to delete this pricing rate?",
      "admin_delete_additional_service_dialog_title": "Delete additional service",
      "admin_confirm_delete_additional_service": "Are you sure you want to delete this additional service?",
      "admin_toast_additional_service_deleted": "Additional service deleted successfully",
      "admin_toast_error_delete_additional_service": "Error deleting additional service",
      "admin_confirm_delete_template": "Delete this template and all its rates?",
      "admin_confirm_delete_rate": "Delete this rate?",
      "admin_confirm_remove_custom_rate": "Remove the custom rate from this client?",
      "admin_confirm_delete_custom_template_detail": "All distance-based price rows for this template will also be removed.",
      "admin_confirm_delete_custom_rate_row_detail": "Only this distance price row will be removed.",
      "admin_confirm_remove_custom_rate_detail": "The client will use the general rate again.",
      "admin_remove_assignment_btn": "Remove assignment",
      "admin_confirm_delete_service": "Are you sure you want to delete this service? This action cannot be undone.",
      "admin_confirm_revert_service": "Are you sure you want to revert this service to \"In Progress\"? Completion data (photos, expenses) will be kept.",
      "admin_confirm_delete_invoice": "Delete this invoice? The period will return to pending status.",
      "admin_confirm_cancel_order": "Are you sure you want to cancel this service?\n\nService: #{{serviceId}}\nClient: {{clientName}}\nDriver: {{driverName}}\n\nCancellation logic will be applied automatically:\n- Client: Charge based on time until pickup\n- Driver: Compensation based on time until pickup\n- Notification emails will be sent",
      "admin_confirm_cancel_at_pickup": "⚠️ CANCELLED AT PICKUP\n\nIs the vehicle NOT available at pickup time?\n\nService: #{{serviceId}}\nClient: {{clientName}}\nDriver: {{driverName}}\n\nIMPORTANT:\n- Client: FULL charge (100%)\n- Driver: FULL payment (100%)\n- Moves to HISTORY automatically\n- Notification emails will be sent",
      "admin_confirm_cancel_in_transit": "⚠️ CANCELLED IN TRANSIT\n\nWas the service cancelled during the journey?\n\nService: #{{serviceId}}\nClient: {{clientName}}\nDriver: {{driverName}}\n\nPROCESS:\n1. Service moves to PENDING\n2. Driver must upload: Expenses, Pickup photos, Photos of where vehicle was left\n3. You must APPROVE the documentation\n4. Once approved: Client pays 100%, Driver receives 100%, Moves to HISTORY",
      "admin_confirm_approve_transit": "✅ APPROVE TRANSIT CANCELLATION\n\nHave you reviewed the driver's documentation?\n\nService: #{{serviceId}}\nDriver: {{driverName}}\n\nOn approval: Client will pay 100%, Driver will receive 100%, Service will move to HISTORY, Will be included in billing",
      "admin_confirm_remove_driver_from_fleet": "Remove {{name}} from their fleet?",
      "admin_confirm_promote_fleet_owner": "Make {{name}} a Fleet Owner?",
      "admin_prompt_rejection_reason": "Enter the rejection reason:",
      "admin_toast_order_cancelled_success": "✅ Service cancelled successfully\n\nStatus: {{status}}\nClient charge: €{{clientFee}}\nDriver compensation: €{{driverPayment}}{{reasonExtra}}",
      "admin_toast_order_cancelled_at_pickup_success": "✅ Service cancelled at pickup\n\nStatus: {{status}}\nClient charge: €{{clientFee}}\nDriver payment: €{{driverPayment}}",
      "admin_toast_order_marked_cancel_in_transit_success": "✅ Service marked as cancelled in transit\n\nStatus: {{status}}\nThe driver must upload documentation\nYou must approve before finalising",
      "admin_toast_transit_cancellation_approved_success": "✅ Transit cancellation approved\n\nStatus: {{status}}\nClient charge: €{{clientFee}}\nDriver payment: €{{driverPayment}}",
      "admin_toast_cancel_order_error": "Error cancelling: {{message}}",
      "admin_toast_error_cancel_at_pickup_detail": "Error cancelling at pickup",
      "admin_toast_error_cancel_in_transit_detail": "Error cancelling in transit",
      "admin_toast_error_approve_transit_detail": "Error approving",
      "admin_toast_error_upload_client_invoice_detail": "Error uploading invoice",
      "admin_toast_error_colon_message": "Error: {{message}}",
      "admin_incident_severity_urgent": "URGENT",
      "admin_incident_card_cancellation_prefix": "Cancellation reason:",
      "admin_unknown_driver": "Unknown driver",
      "admin_toast_service_reverted_ok": "Service reverted to \"{{status}}\" successfully",
      "admin_title_edit_billing": "Edit billing details",
      "admin_title_cancellation_normal": "Standard cancellation (by timing)",
      "admin_title_cancellation_vehicle_unavailable_pickup": "Vehicle not available at pickup",
      "admin_title_cancellation_during_transit": "Cancelled during transport",
      "admin_approvals_page_title": "Pending approvals",
      "admin_approvals_page_subtitle": "Review and approve services completed by drivers",
      "admin_approvals_card_title": "Services pending approval",
      "admin_approvals_card_description": "Services that have been completed and are awaiting approval",
      "admin_approvals_empty": "No services pending approval",
      "admin_incidents_reported_title": "Reported incidents",
      "admin_incidents_page_subtitle": "Manage incidents reported by drivers",
      "admin_incidents_tab_active": "Active",
      "admin_expense_approve_dialog_title": "Approve expense report",
      "admin_expense_approve_reported_heading": "Expenses reported by the driver:",
      "admin_expense_approve_driver_total": "Driver total:",
      "admin_expense_approve_client_charges_title": "Additional charges to the client",
      "admin_expense_approve_client_charges_hint": "Add charges that will be invoiced to the client (not visible to the driver)",
      "admin_expense_approve_total_charges": "Charges total: {{total}}€",
      "admin_approve_with_charges": "Approve with charges",
      "admin_label_type_short": "Type",
      "admin_order_incident_tooltip": "This service had an incident",
      "admin_order_incident_label": "Incident",
      "admin_toast_error_load_services": "Error loading services",
      "admin_toast_period_details_load_error": "Error loading details: {{message}}",
      "admin_toast_unknown_service_type": "Unknown service type: {{type}}",
      "admin_error_unknown": "Unknown error",
      "admin_toast_error_approve_driver_detail": "Error approving driver: {{detail}}",
      "admin_toast_error_create_client": "Error creating client",
      "admin_toast_service_created_with_client": "Service created and assigned to the client successfully",
      "admin_toast_service_created_admin_only": "Service created successfully (no client assigned)",
      "admin_toast_error_create_service": "Error creating service",
      "admin_toast_error_upload_logo": "Error uploading logo",
      "admin_toast_driver_document_uploaded": "Document uploaded successfully",
      "admin_toast_driver_document_validated_auto": "Document uploaded and driver validated automatically",
      "admin_toast_error_upload_driver_document": "Error uploading document",
      "admin_driver_billing_dialog_title": "Billing details — {{name}}",
      "admin_penalty_dialog_title": "Unassigning driver",
      "admin_penalty_service_label": "Service:",
      "admin_penalty_route_label": "Route:",
      "admin_penalty_hours_until_pickup": "Time until pickup: {{hours}} h",
      "admin_penalty_apply_label": "Apply cancellation penalty",
      "admin_penalty_calculated_label": "Calculated penalty:",
      "admin_penalty_rule_under_48": "(Cancellation with less than 48 h notice: -€50)",
      "admin_penalty_rule_over_48": "(Cancellation with more than 48 h notice: -€25)",
      "admin_penalty_amount_label": "Amount (€)",
      "admin_penalty_reason_label": "Reason",
      "admin_penalty_reason_late": "Late cancellation",
      "admin_penalty_reason_no_show": "No-show",
      "admin_penalty_reason_breach": "Non-compliance",
      "admin_penalty_reason_other": "Other",
      "admin_penalty_save_without": "Save without penalty",
      "admin_penalty_save_with": "Save with penalty (€{{amount}})",
      "admin_toast_error_update_driver": "Error updating driver: {{message}}",
      "admin_toast_template_not_found": "Template \"{{name}}\" not found",
      "admin_toast_no_rates_for_template": "No rates loaded for \"{{name}}\"",
      "admin_toast_expense_report_approved_ok": "Report approved successfully",
      "admin_toast_expense_report_rejected_ok": "Report rejected successfully",
      "admin_toast_driver_created_ok": "Driver created successfully",
      "admin_toast_driver_updated_ok": "Driver updated successfully",
      "admin_toast_pricing_created_ok": "Rate created successfully",
      "admin_toast_pricing_updated_ok": "Rate updated successfully",
      "admin_toast_driver_created_with_docs_welcome": "Driver created successfully. {{docsPart}}Welcome email sent.",
      "admin_toast_error_create_driver": "Error creating driver",
      "admin_toast_no_services_pending_liquidation": "No services pending settlement",
      "admin_toast_distance_calculated": "Distance calculated: {{km}} km",
      "admin_google_cal_service_title": "AutoGo service",
      "admin_calendar_schedule_prefix": "Schedule:",
      "admin_calendar_contact_prefix": "Contact:",
      "admin_calendar_time_tbd": "TBD",
      "admin_cancel_dialog_title_standard": "Cancel service",
      "admin_cancel_dialog_title_pickup": "Cancel at pickup",
      "admin_cancel_dialog_title_transit": "Cancel in transit",
      "admin_cancel_dialog_title_approve_transit": "Approve transit cancellation",
      "admin_cancel_dialog_cta_confirm": "Confirm",
      "admin_toast_cancel_service_failed": "Failed to cancel service",
      "admin_delete_dialog_title": "Delete service",
      "admin_delete_dialog_confirm": "Delete",
      "service_confirm_revert": "Are you sure you want to revert this service?",
      "service_confirm_delete": "Are you sure you want to DELETE this service? This action cannot be undone.",
      "driver_confirm_delete_member": "Delete driver {{name}}?",
      "driver_doc_confirm_delete": "Are you sure you want to delete this document?",
      "driver_doc_alert_connection_error": "Connection error while opening document",
      "driver_doc_alert_download_error": "Error downloading document",
      "driver_doc_alert_deleted": "Document deleted successfully",
      "driver_doc_alert_error_delete": "Error deleting document",
      "driver_doc_alert_uploaded": "Document uploaded successfully",
      "driver_doc_alert_error_upload": "Error uploading document",
      "driver_doc_alert_error_upload_detail": "Error uploading document: {{detail}}",
      "service_status_undefined": "Not set",
      "service_status_not_calculated": "Not calculated",
      "service_status_pending": "Pending",
      "service_status_assigned": "Assigned",
      "service_status_in_progress": "In Progress",
      "service_status_in_transit": "In Transit",
      "service_status_inspected": "Inspected",
      "service_status_delivered": "Delivered",
      "service_status_completed": "Completed",
      "service_status_cancelled": "Cancelled",
      "service_detail_billing_requires_approval_title": "Not yet included in driver settlement",
      "service_detail_billing_requires_approval_body": "Liquidation and billing periods only include services whose admin approval status is «Approved». If the transport is finished but still awaiting validation, approve the completion from the Pending Approval section on the admin dashboard.",
      "service_detail_approve_for_billing": "Approve for billing",
      "service_detail_approval_badge_label": "Admin approval (settlement)",
      "service_detail_approval_status_pending": "Pending",
      "service_detail_approval_status_pending_approval": "Pending approval",
      "service_detail_approval_status_approved": "Approved — counts toward settlement",
      "service_detail_approval_status_rejected": "Rejected",
      "service_no_client": "No client",
      "service_no_driver": "Unassigned",
      "service_no_plate": "No plate",
      "driver_no_orders": "You have no assigned services yet",
      "driver_no_orders_filter": "No services found with the applied filters",
      "driver_date_unspecified": "Not specified",
      "driver_pending_approval": "Pending Approval",
      "driver_complete_service": "Complete Service",
      "driver_cancel_driver_initiated": "Cancel service (client charge)",
      "driver_cancel_driver_initiated_help": "Only if pickup is at least 48 h away. The client is invoiced €{{fee}} (taxable base).",
      "driver_cancel_driver_initiated_confirm": "Cancel this service as the driver? The client will be charged €{{fee}} (ex-VAT base) on their invoice. This cannot be undone.",
      "driver_cancel_driver_initiated_success": "Service cancelled. Client invoice charge: €{{fee}}.",
      "driver_cancel_driver_initiated_error_window": "This cancellation is only available at least 48 hours before pickup. If less time remains, contact admin.",
      "driver_cancel_driver_initiated_failed": "Could not cancel the service.",
      "driver_not_specified": "Not specified",
      "driver_available": "Available",
      "driver_not_available": "Not Available",
      "driver_saving": "Saving...",
      "driver_edit_click_hint": "Click \"Edit\" to update your information.",
      "driver_status_rejected": "Rejected",
      "driver_send_expense_report": "Send Expense Report",
      "driver_sending": "Sending...",
      "address_toast_selected": "Address selected successfully",
      "common_document_preview": "Document Preview",
      "ph_description": "Description",
      "ph_observations_delivery": "Observations about delivery...",
      "ph_email_example": "admin@example.com",
      "ph_enter_password": "Enter your password",
      "ph_email_driver": "your@email.com",
      "ph_password_dots": "••••••••",
      "ph_new_password_placeholder": "Enter your new password",
      "ph_city_search": "Type a city...",
      "ph_vehicle_address": "Address where the vehicle is located",
      "ph_phone_es": "+34 600 123 456",
      "ph_distance_example": "e.g. 150.5",
      "title_download": "Download",
      "title_pdf_viewer": "PDF Viewer",
      "ph_company_example": "e.g. Acme Transport S.L.",
      "ph_select_country": "Select country",
      "ph_name_example": "e.g. John Smith",
      "ph_lat_example": "Latitude (e.g. 41.3851 for Barcelona)",
      "ph_lon_example": "Longitude (e.g. 2.1734 for Barcelona)",
      "ph_cities_search": "Madrid, Barcelona...",
      "ph_brands": "Toyota, BMW...",
      "ph_models": "Corolla, Series 3...",
      "ph_plate_example": "1234ABC",
      "ph_fullname_example": "e.g. John Smith",
      "ph_dni_example": "12345678A",
      "ph_number_short": "15",
      "ph_fiscal_address": "Street, number, postcode, city, province",
      "ph_city_example": "e.g. London",
      "ph_iban_example": "ES00 0000 0000 0000 0000 0000",
      "ph_describe_expense": "Describe the expense",
      "ph_select_client": "Select client",
      "ph_select_client_alt": "Select a client",
      "ph_notes_service": "Add notes or comments about this service...",
      "ph_amount": "0.00",
      "ph_optional": "Optional",
      "ph_no_client_admin": "No client (Admin)",
      "admin_create_service_title": "Create New Service",
      "admin_create_service_desc": "Complete the service details. Fields marked with * are required.",
      "admin_client_optional": "Client (Optional)",
      "admin_create_service_no_client_hint": "If no client is selected, the service will be assigned to admin",
      "admin_label_color": "Color",
      "admin_label_year": "Year",
      "admin_additional_services_optional": "Additional Services (Optional)",
      "admin_quantity_short": "Qty:",
      "admin_no_additional_services_available": "No additional services available",
      "admin_selected_additional_services": "Selected additional services:",
      "admin_total_price_upper": "TOTAL PRICE:",
      "admin_base_service_price": "Base service price:",
      "admin_assign_driver_optional": "Assign Driver (Optional)",
      "admin_driver_status_assigned": "Status: Assigned (an email will be sent to the driver)",
      "admin_driver_status_pending": "Status: Pending assignment",
      "admin_driver_rate_title": "Driver Rate (How much you'll pay)",
      "admin_driver_price_label": "Price for Driver *",
      "admin_driver_price_hint": "Set how much you'll pay the driver for this service",
      "admin_client_price": "Client Price",
      "admin_driver_payment": "Driver Payment",
      "admin_your_margin": "Your Margin:",
      "admin_profit_margin_suffix": "profit margin",
      "admin_payment_status": "Payment Status",
      "admin_mark_as_paid": "Mark as paid",
      "admin_service_created_paid_status": "✓ The service will be created with 'Paid' status",
      "admin_service_created_pending_status": "The service will be created with 'Pending payment' status",
      "admin_additional_notes": "Additional Notes",
      "admin_create_service": "Create Service",
      "admin_create_switch_to_range": "Switch to range",
      "admin_create_switch_to_fixed": "Switch to fixed date",
      "admin_create_pickup_date_label": "Pickup date",
      "admin_create_pickup_time_label": "Pickup time",
      "admin_create_delivery_date_label": "Delivery date",
      "admin_create_delivery_time_label": "Delivery time",
      "admin_pickup_time_from": "Pickup time * - From",
      "admin_pickup_time_to": "Pickup time * - Until",
      "admin_delivery_time_from": "Delivery time * - From",
      "admin_delivery_time_to": "Delivery time * - Until",
      "admin_label_driver": "Driver",
      "admin_driver_unassigned": "Unassigned",
      "admin_distance_label": "Distance",
      "admin_base_price_label": "Base price",
      "admin_create_creating": "Creating...",
      "admin_toast_create_vehicle_required": "Please complete the vehicle details",
      "admin_toast_create_driver_price_required": "Please set the price for the driver",
      "admin_create_success_with_client": "Service created and assigned to the client successfully",
      "admin_create_success_admin_only": "Service created successfully (no client assigned)",
      "admin_create_docs_warn": "Service created, but there was a problem with documents: {{detail}}",
      "admin_docs_fallback": "Some documents could not be uploaded.",
      "admin_create_error_generic": "Error creating service",
      "ph_search_pickup": "Search pickup address...",
      "ph_search_delivery": "Search delivery address...",
      "ph_name": "Name",
      "ph_invoice_ref": "e.g. 2025/001",
      "ph_no_driver_pending": "Unassigned (pending)",
      "ph_special_instructions": "Special instructions, notes...",
      "ph_toll_example": "e.g. Urban toll, etc.",
      "ph_time_example": "e.g. 30 minutes",
      "ph_notes_delivery_optional": "Add notes about delivery (optional)...",
      "title_edit_service": "Edit service",
      "title_mark_paid": "Mark as paid",
      "title_approve_driver": "Approve driver",
      "title_view_profile": "View full profile",
      "title_view_details": "View details",
      "title_download_excel": "Download Excel",
      "title_download_pdf": "Download PDF",
      "title_generate_invoice_pdf": "Generate Invoice PDF",
      "title_regenerate_invoice_pdf": "Regenerate Invoice PDF",
      "title_download_pdf_existing": "Download existing PDF",
      "ph_address_maps": "💡 Type address, select suggestions or paste a Google Maps link",
      "address_autocomplete_placeholder_default": "Type an address or paste a Google Maps link...",
      "address_quick_city_heading": "🏙️ Or pick a city:",
      "address_city_country_suffix": "{{city}}, Spain",
      "address_coords_from_maps": "Coordinates from Google Maps: {{lat}}, {{lng}}",
      "address_maps_short_label": "Google Maps: {{lat}}, {{lng}}",
      "address_manual_gps_close": "✗ Close coordinates",
      "address_manual_gps_open": "📍 Or enter GPS coordinates manually",
      "address_manual_gps_hint": "Enter precise GPS coordinates:",
      "address_manual_gps_apply": "✓ Set coordinates",
      "ph_phone_admin": "+34 600 000 000",
      "ph_qty": "Qty",
      "ph_price": "Price",
      "ph_extra_description": "Custom extra description...",
      "ph_search_vehicle": "Brand, model, plate...",
      "ph_price_eur": "Price in €",
      "ph_brand_toyota": "Toyota",
      "ph_model_corolla": "Corolla",
      "ph_plate_short": "1234ABC",
      "ph_color_example": "e.g. White",
      "ph_year_example": "2023",
      "ph_zero": "0",
      "ph_rate_040": "0.40",
      "ph_rate_032": "0.32",
      "ph_rate_028": "0.28",
      "aria_select_language": "Select language",
      "aria_pagination": "pagination",
      "aria_prev_page": "Go to previous page",
      "aria_next_page": "Go to next page",
      "aria_breadcrumb": "breadcrumb",
      "common_previous": "Previous",
      "common_next": "Next",
      "common_close": "Close",
      "period_trips_title": "Travel Details",
      "period_trips_total_trips": "Total Trips",
      "period_trips_income": "Income",
      "period_trips_expenses": "Expenses",
      "period_trips_total_vat": "Total with VAT",
      "period_trips_loading": "Loading trips...",
      "period_trips_empty": "No trips in this period.",
      "period_trips_expenses_approved": "✓ Expenses Approved",
      "period_trips_vehicle": "Vehicle:",
      "period_trips_plate": "License plate:",
      "period_trips_client": "Client:",
      "period_trips_pickup_date": "Pickup date:",
      "period_trips_delivery_date": "Delivery date:",
      "period_trips_service": "Service:",
      "period_trips_route": "Route:",
      "period_trips_driver_rate": "Driver rate",
      "period_trips_supplied_expenses": "Supplied expenses",
      "period_trips_total_service": "Total service",
      "period_trips_fuel": "Fuel:",
      "period_trips_tolls": "Tolls:",
      "period_trips_parking": "Parking:",
      "period_trips_taxi": "Taxi:",
      "period_trips_other": "Other:",
      "period_trips_id_label": "ID:",
      "period_trips_period_intro": "Period: {{start}} - {{end}}",
      "period_status_completed": "Completed",
      "period_label_period": "Period:",
      "driver_nav_home": "Home",
      "driver_nav_services": "Services",
      "driver_nav_complete": "Complete",
      "driver_nav_profile": "My Profile",
      "driver_nav_billing": "Billing",
      "driver_nav_fleet": "My Fleet",
      "driver_portal_subtitle": "Driver portal",
      "driver_docs_pending_title": "Pending Documentation",
      "driver_docs_pending_text": "You must upload and validate all required documents to receive service assignments.",
      "driver_loading": "Loading...",
      "calendar_scheduled_subtitle": "Your scheduled services",
      "driver_active_services": "Active services",
      "driver_from_n_services": "From {{count}} services",
      "driver_fleet_employee_no_tariffs": "Pricing is managed by your fleet operator",
      "driver_validation_progress": "Validation progress ({{uploaded}}/7 uploaded)",
      "driver_this_week_n_services": "This week ({{count}} services)",
      "driver_status_services": "Service Status",
      "driver_status_documents": "Document Status",
      "driver_trend_title": "Service and Revenue Trend",
      "driver_trend_subtitle": "Last 6 months",
      "driver_recent_services": "Recent Services",
      "driver_last_5_assigned": "Last 5 assigned services",
      "calendar_prev_period": "Previous period",
      "calendar_next_period": "Next period",
      "calendar_day": "Day",
      "calendar_week": "Week",
      "calendar_month": "Month",
      "calendar_legend_assigned": "Assigned",
      "calendar_legend_completed": "Completed",
      "calendar_legend_today": "Today",
      "driver_completed_count": "{{count}} completed",
      "driver_chart_completed": "Services Completed",
      "driver_chart_income": "Income",
      "driver_chart_approved": "Approved",
      "driver_chart_rejected": "Rejected",
      "driver_chart_missing": "Missing",
      "driver_chart_cancelled": "Cancelled",
      "driver_chart_week_empty_title": "No activity this week",
      "driver_chart_week_empty_hint": "When you have in-progress or completed services in the current week, a summary will appear here.",
      "driver_date_unavailable": "Date unavailable",
      "calendar_origin": "Origin:",
      "calendar_destination": "Destination:",
      "calendar_view_full_details": "View full details",
      "calendar_no_services": "No services",
      "calendar_no_services_this_day": "No services scheduled for this day",
      "driver_validated": "Validated",
      "driver_commission": "Commission",
      "driver_services_title": "Services",
      "driver_services_subtitle": "Manage your active and historical trips",
      "driver_services_in_progress": "In progress",
      "driver_services_historical": "Historic",
      "driver_filters_title": "Search Filters",
      "driver_clear": "Clear",
      "driver_clear_filters": "Clear filters",
      "driver_search_address": "Search Address/City",
      "driver_status": "Status",
      "driver_all": "All",
      "driver_driver_label": "Driver",
      "driver_myself": "Myself",
      "driver_vehicle_brand": "Vehicle Brand",
      "driver_vehicle_model": "Vehicle Model",
      "driver_plate": "License Plate",
      "driver_fuel_type": "Fuel Type",
      "driver_fuel_gasoline": "Gasoline",
      "driver_fuel_diesel": "Diesel",
      "driver_fuel_electric": "Electric",
      "driver_fuel_hybrid": "Hybrid",
      "driver_payment_status": "Payment Status",
      "driver_paid": "Paid",
      "driver_unpaid": "Unpaid",
      "driver_showing_services": "Showing {{shown}} of {{total}} services",
      "driver_table_date": "Date",
      "driver_table_trip": "Trip",
      "driver_table_vehicle": "Vehicle",
      "driver_table_price": "Price",
      "driver_table_status": "Status",
      "driver_table_actions": "Actions",
      "driver_details": "Details",
      "driver_order_attachments_title": "Files attached to this service",
      "driver_service_doc_preview_error": "Could not open the document. Check your connection or try again.",
      "driver_overdue_banner": "Delivery date passed - Complete service urgently",
      "driver_origin_short": "Origin",
      "driver_destination_short": "Destination",
      "driver_service_type_delivery": "Delivery",
      "driver_label_remuneration": "Remuneration",
      "driver_label_distance": "Distance",
      "driver_label_vehicle": "Vehicle",
      "driver_pickup": "PICKUP",
      "driver_delivery": "DELIVERY",
      "driver_completion_docs_title": "Other service documents",
      "driver_completion_docs_subtitle": "Optional: delivery notes, authorizations, or other PDFs or images. They stay attached to the service for the client and admin.",
      "driver_completion_docs_field_label": "Files to upload",
      "driver_completion_docs_hint": "PDF or images (JPEG, PNG, WebP). Max 10 MB per file, up to 15 per service in total (including existing attachments).",
      "driver_upload_completion_docs": "Upload documents",
      "driver_uploading_completion_docs": "Uploading…",
      "driver_toast_completion_docs_uploaded": "Documents uploaded successfully",
      "driver_toast_completion_docs_error": "Could not upload documents",
      "driver_incomplete_title": "Incomplete Services",
      "driver_incomplete_subtitle": "These services are delivered but need vehicle photos and expense report before the period closes",
      "driver_loading_services": "Loading services...",
      "driver_all_services_completed": "All services are completed!",
      "driver_no_pending_complete": "No pending services to complete",
      "driver_rejected": "Rejected",
      "driver_service_id": "Service ID",
      "driver_date_pickup": "Pickup Date",
      "driver_date_delivery_label": "Delivery Date",
      "driver_pending_approval_message": "This service is pending approval by the administrator. Once approved, it will be automatically added to your billing.",
      "driver_rejection_reason": "Rejection reason:",
      "driver_reupload_photos_expenses": "Please re-upload the photos and/or expenses correctly.",
      "driver_missing_pickup_photos": "Missing pickup photos",
      "driver_pickup_photos_uploaded": "Pickup photos uploaded",
      "driver_missing_delivery_photos": "Missing delivery photos",
      "driver_delivery_photos_uploaded": "Delivery photos uploaded",
      "driver_missing_expense_report": "Missing expense report",
      "driver_expense_reported": "Expenses reported",
      "driver_profile_title": "My Profile",
      "driver_profile_subtitle": "Driver personal information",
      "driver_label_name": "Name",
      "driver_label_phone": "Phone",
      "driver_label_dni": "DNI/NIF",
      "driver_label_status": "Status",
      "driver_status_available": "Available",
      "driver_status_not_available": "Not Available",
      "driver_doc_validation": "Document Validation",
      "driver_validation_pending": "Validation Pending",
      "driver_billing_title": "Billing Information",
      "driver_billing_description": "This information is used to generate your invoices",
      "driver_billing_full_name": "Full Legal Name",
      "driver_billing_dni": "DNI/NIE",
      "driver_billing_irpf": "IRPF Withholding (%)",
      "driver_billing_fiscal_address": "Full Tax Address",
      "driver_billing_bank": "Bank",
      "driver_billing_iban": "Account Number (IBAN)",
      "driver_billing_iban_note": "Account change will apply to your next invoice",
      "driver_billing_incomplete_warning": "To generate your invoices, you need to complete all billing fields. Click \"Edit\" to update your information.",
      "driver_my_documents": "My Documents",
      "driver_docs_progress": "Progress: {{uploaded}} of {{total}} documents uploaded",
      "driver_upload_document": "Upload Document",
      "driver_upload_dialog_desc": "Upload the required document so an administrator can validate your profile.",
      "driver_doc_type_label": "Document type *",
      "driver_doc_type_placeholder": "Select a type",
      "driver_file_label": "File *",
      "driver_file_hint_pdf": "PDF only (max. {{maxMB}} MB)",
      "driver_file_hint_image": "Images only (max. {{maxMB}} MB)",
      "driver_upload_date_label": "Upload date *",
      "driver_expiry_date_label": "Expiry date *",
      "driver_expiry_hint_hacienda": "Usually expires 12 months after the issue date.",
      "driver_expiry_hint_ss": "Usually expires 6 months after the issue date.",
      "driver_error_file_too_large": "The file exceeds the maximum size ({{maxMB}} MB). Choose a smaller file.",
      "driver_doc_license_front": "Driver's License (Front)",
      "driver_doc_license_back": "Driver's License (Back)",
      "driver_doc_dni_front": "ID/NIE (Front)",
      "driver_doc_dni_back": "ID/NIE (Back)",
      "driver_doc_autonomo": "Self-Employed Registration",
      "driver_doc_hacienda": "Tax Authority Current Account",
      "driver_doc_ss": "Social Security Current Account",
      "driver_doc_uploaded": "Uploaded:",
      "driver_doc_expires": "Expires:",
      "driver_doc_not_uploaded": "Not uploaded",
      "driver_update": "Update",
      "driver_doc_status_pending": "Pending",
      "driver_doc_status_approved": "Approved",
      "driver_doc_status_expired": "Expired",
      "driver_fleet_docs_title": "My Drivers' Documents",
      "driver_fleet_validated": "✓ Validated",
      "driver_billing_my_settlements": "My Settlements",
      "driver_billing_subtitle": "Bi-weekly payment periods with full breakdown",
      "driver_billing_periods_info": "Payment periods: Fortnight 1 (services 25-9, payment 10-15) • Fortnight 2 (services 10-24, payment 25-last)",
      "driver_billing_current_no_services": "Current Period: No services",
      "driver_billing_current_no_services_desc": "You have no approved services in the current period. When you complete services and they are approved, they will appear here.",
      "driver_billing_previous_periods": "Previous Periods",
      "driver_billing_no_previous": "There are no previous settlements",
      "driver_billing_no_previous_desc": "When a period closes and your services are settled, they will appear here",
      "driver_billing_loading_settlements": "Loading settlements...",
      "driver_billing_loading_period": "Loading current period...",
      "driver_billing_in_progress": "In progress",
      "driver_billing_fortnight_1": "Fortnight 1",
      "driver_billing_fortnight_2": "Fortnight 2",
      "driver_billing_payment_label": "Payment:",
      "driver_billing_services": "Services",
      "driver_billing_base": "Base",
      "driver_billing_iva": "VAT (21%)",
      "driver_billing_supplies": "Supplies",
      "driver_billing_irpf_label": "IRPF",
      "driver_billing_total_accumulated": "TOTAL ACCUMULATED",
      "driver_billing_fleet_breakdown": "Breakdown by Fleet Driver:",
      "driver_billing_trips": "trips",
      "driver_billing_hide_services": "▲ Hide Services",
      "driver_billing_view_services": "▼ View Services ({{count}})",
      "driver_billing_grand_total_abbr": "TOTAL",
      "driver_billing_totals": "Totals:",
      "driver_billing_driver": "Driver",
      "driver_billing_rate": "Rate",
      "driver_billing_paid": "✓ Paid",
      "driver_billing_status_pending": "⏳ Payment pending",
      "driver_billing_period_breakdown": "Breakdown by driver:",
      "driver_billing_services_count": "service(s)",
      "driver_billing_view_services_btn": "View Services",
      "driver_billing_download_invoice": "Download Invoice",
      "driver_billing_issued_invoices_title": "Issued invoices (PDF)",
      "driver_billing_issued_invoices_desc": "All invoices on record for you (and your fleet, if you are an owner). If a period row is missing a link, download the PDF here.",
      "driver_billing_no_invoices_on_file": "No invoices on file yet.",
      "driver_billing_period_details_title": "Billing Period Details",
      "driver_billing_period_label": "Period:",
      "driver_billing_total_trips": "Total Trips",
      "driver_billing_income_without_vat": "Income (ex. VAT)",
      "driver_billing_expenses_without_vat": "Expenses (ex. VAT)",
      "driver_billing_total_to_pay": "Total to pay",
      "driver_billing_total_to_pay_caption": "(Income + VAT + Expenses)",
      "driver_billing_completed_services_count": "Completed services ({{count}})",
      "driver_billing_column_expenses": "Expenses",
      "driver_billing_total_parking": "Total parking:",
      "driver_billing_total_expenses_short": "Total expenses:",
      "driver_billing_no_tickets_attached": "No receipts attached",
      "driver_billing_ticket_number": "Receipt {{n}}",
      "driver_dialog_upload_section_title": "Upload documents",
      "driver_action_start": "Start",
      "driver_you_short": "(You)",
      "driver_fleet_no_validated_members": "No drivers with validated documents",
      "driver_fleet_no_validated_members_hint": "Wait for the admin to approve documents or assign the service to yourself",
      "driver_report_incident_title": "Report incident",
      "driver_incident_type_label": "Incident type *",
      "driver_incident_cancel_reason_label": "Pickup cancellation reason *",
      "driver_incident_cancel_reason_placeholder": "Explain why the vehicle is unavailable (e.g. customer not present, vehicle does not exist, wrong address...)",
      "driver_incident_description_label": "Detailed description *",
      "driver_incident_description_placeholder": "Describe what happened in detail...",
      "driver_incident_contract_photo_label": "Signed contract photo",
      "driver_incident_vehicle_photo_label": "Vehicle photo (if applicable)",
      "driver_incident_submit_notice_title": "⚠️ Important:",
      "driver_incident_submit_notice_body": "When you report this incident, the administrator will be notified immediately. Make sure you provide all necessary information.",
      "driver_assign_driver": "Assign Driver",
      "driver_reassign_driver": "Reassign Driver",
      "driver_urgent": "URGENT!",
      "driver_fleet_manage_subtitle": "Manage your fleet drivers",
      "driver_fleet_members_title": "Fleet Drivers",
      "driver_fleet_members_count": "{{count}} driver in your fleet",
      "driver_fleet_members_count_plural": "{{count}} drivers in your fleet",
      "driver_fleet_no_members": "No drivers in your fleet",
      "driver_fleet_add_to_start": "Add drivers to start managing your fleet",
      "driver_fleet_add_first": "Add First Driver",
      "driver_label_phone_short": "Phone:",
      "driver_label_license_no": "License No.:",
      "driver_status_busy": "Busy",
      "driver_status_disconnected": "Disconnected",
      "driver_label_documents": "Documents:",
      "driver_expense_details_title": "Expense Details",
      "driver_view_more": "View More",
      "driver_expense_fuel": "Fuel",
      "driver_expense_tolls": "Tolls",
      "driver_expense_tickets": "Tickets and Receipts",
      "driver_expenses_label": "Expenses",
      "driver_uploading": "Uploading...",
      "driver_upload_btn": "Upload",
      "driver_dialog_add_fleet_title": "Add Driver to Fleet",
      "driver_dialog_add_fleet_desc": "Create a new driver in your fleet.",
      "driver_dialog_basic_info": "Basic Information",
      "driver_dialog_full_name": "Full Name",
      "driver_dialog_license_no": "Driver's License No.",
      "driver_dialog_password_note": "📧 Note: A temporary password will be generated and sent by email to the driver along with their access credentials.",
      "driver_dialog_docs_optional": "Documents (Optional)",
      "driver_dialog_docs_later": "You can upload documents now or the driver can upload them later from their portal.",
      "driver_dialog_create_driver": "Create Driver",
      "driver_dialog_edit_fleet_title": "Edit Fleet Driver",
      "driver_dialog_edit_fleet_desc": "Update the driver information and upload documents.",
      "driver_fleet_edit_docs_intro": "Upload or update the driver's documents (ID and license). Maximum {{maxMB}} MB per file.",
      "driver_dialog_driver_available": "Driver available to receive services",
      "driver_save_changes": "Save Changes",
      "driver_close": "Close",
      "driver_select_driver": "Select Driver",
      "driver_upload_pickup_photos": "Upload {{count}} Pickup Photo(s)",
      "driver_upload_delivery_photos": "Upload {{count}} Delivery Photo(s)",
      "driver_upload_contract_photos": "Upload {{count}} Contract Photo(s)",
      "placeholder_select_driver": "Select driver",
      "placeholder_amount": "0.00",
      "admin_toast_service_approved_completed": "Service approved and moved to Completed",
      "admin_toast_error_detail": "Error: {{message}}",
      "admin_toast_error_approve_service": "Error approving service",
      "admin_toast_service_approved": "Service approved successfully",
      "admin_toast_service_rejected": "Service rejected",
      "admin_toast_error_reject_service": "Error rejecting service",
      "admin_toast_driver_approved": "Driver approved successfully",
      "admin_toast_error_approve_driver": "Error approving driver",
      "admin_confirm_approve_driver_title": "Approve driver?",
      "admin_confirm_approve_driver_description": "{{name}} will be set to available and their documents will be marked as validated. Do you want to continue?",
      "admin_driver_approve_dialog_confirm": "Approve",
      "admin_error_unknown": "Unknown error",
      "admin_toast_complete_distance_and_type": "Complete distance (km) and service type first to calculate rate",
      "admin_toast_template_basic_not_found": "Basic (standard rate) driver template not found",
      "admin_toast_template_premium_not_found": "Premium template not found",
      "admin_toast_template_jluis_not_found": "Premium +10% driver template not found",
      "admin_toast_enter_valid_price": "Enter a valid price",
      "admin_toast_please_enter_valid_price": "Please enter a valid price",
      "admin_toast_select_extra_type": "Select an extra type",
      "admin_toast_price_must_be_positive": "Price must be greater than 0",
      "admin_toast_extra_added": "Extra added",
      "admin_toast_could_not_calculate_rate": "Could not calculate rate",
      "admin_toast_error_calculate_price_short": "Error calculating price",
      "login_successful": "Login successful!",
      "logout_successful": "Logged out successfully",
      "invalid_credentials": "Invalid credentials",
      "driver_login_welcome": "Welcome!",
      "driver_login_error": "Invalid email or password",
      "driver_forgot_success": "A new password has been sent to your email",
      "driver_forgot_email_not_sent": "If your email is registered, we could not send the message. Please contact support.",
      "driver_forgot_error": "Could not send recovery email",
      "driver_forgot_send_error": "Error sending email",
      "driver_forgot_description": "Enter your email and we will send you a new password.",
      "driver_forgot_submit": "Send",
      "reset_toast_invalid_token": "Invalid recovery token",
      "reset_toast_password_requirements": "Password does not meet security requirements",
      "reset_toast_error": "Error resetting password",
      "reset_toast_success": "Password reset successfully",
      "reset_title": "Reset Password",
      "reset_description": "Enter your new password",
      "reset_new_password": "New Password",
      "reset_confirm_password": "Confirm Password",
      "reset_requirements_title": "Password requirements:",
      "reset_req_min_length": "Minimum 8 characters",
      "reset_req_uppercase": "At least one uppercase letter",
      "reset_req_number": "At least one number",
      "reset_req_symbol": "At least one symbol (!@#$%^&*)",
      "reset_passwords_match": "Passwords match",
      "reset_resetting": "Resetting...",
      "reset_submit": "Reset Password",
      "reset_back_login": "Back to login",
      "driver_reset_description": "Driver - Enter your new password",
      "reset_network_error": "Network error",
      "fill_required_fields": "Please fill in all required fields",
      "address_required": "Please select a valid address",
      "client_toast_delivery_date_required": "Set the start and end dates for the delivery window",
      "distance_calculating": "Calculating distance automatically...",
      
      // Auth Pages
      "welcome_back": "Welcome Back",
      "sign_in_to_manage": "Sign in to manage your transport services",
      "email_address": "Email Address",
      "email_placeholder": "you@email.com",
      "password": "Password",
      "password_placeholder": "Enter your password",
      "forgot_password": "Forgot your password?",
      "sign_in": "Sign In",
      "no_account": "Don't have an account? Contact the administrator:",
    }
  }
};

mergeAdminDashboardExtras(resources);

// Add Spanish translations for auth pages
resources.es.translation.welcome_back = "Bienvenido de Nuevo";
resources.es.translation.sign_in_to_manage = "Inicia sesión para gestionar tus servicios de transporte";
resources.es.translation.email_address = "Correo Electrónico";
resources.es.translation.email_placeholder = "tu@email.com";
resources.es.translation.password = "Contraseña";
resources.es.translation.password_placeholder = "Enter your password";
resources.es.translation.forgot_password = "¿Olvidaste tu contraseña?";
resources.es.translation.sign_in = "Iniciar Sesión";
resources.es.translation.no_account = "¿No tienes cuenta? Contacta con el administrador:";
resources.es.translation.driver_portal = "Portal de Conductores";
resources.es.translation.sign_in_to_view_services = "Inicia sesión para ver tus servicios asignados";
resources.es.translation.back_to_home = "Volver al inicio";
resources.es.translation.driver_access = "Acceso Conductor";

// Add English translations for driver login
resources.en.translation.driver_portal = "Driver Portal";
resources.en.translation.sign_in_to_view_services = "Sign in to view your assigned services";
resources.en.translation.back_to_home = "Back to Home";
resources.en.translation.driver_access = "Driver Access";

// Get saved language from localStorage or default to 'es'
// Normalize to 'es' or 'en' so it matches our resources
const stored = localStorage.getItem('i18nextLng') || 'es';
const savedLanguage = stored.startsWith('en') ? 'en' : 'es';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    },
    react: {
      bindI18n: 'languageChanged',
      useSuspense: false
    }
  });

// Save language to localStorage whenever it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;